/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: acceptInquiry
// ====================================================

export interface acceptInquiry {
  /**
   * Accept quote and confirm shipment
   */
  acceptInquiry: boolean | null;
}

export interface acceptInquiryVariables {
  inquiryArgs: InquiryScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: assignAttachment
// ====================================================

export interface assignAttachment_assignFile_uploader {
  name: string | null;
}

export interface assignAttachment_assignFile {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: assignAttachment_assignFile_uploader | null;
  url: string | null;
}

export interface assignAttachment {
  /**
   * Attach a file to an existing blank Attachment
   */
  assignFile: assignAttachment_assignFile | null;
}

export interface assignAttachmentVariables {
  attachmentId: string;
  s3Key?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createAttachment
// ====================================================

export interface createAttachment_uploadFile_uploader {
  name: string | null;
}

export interface createAttachment_uploadFile {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: createAttachment_uploadFile_uploader | null;
  url: string | null;
}

export interface createAttachment {
  /**
   * add attachments to a shipment
   */
  uploadFile: createAttachment_uploadFile[] | null;
}

export interface createAttachmentVariables {
  attachmentsArgs: ShipmentUploadInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createFilelessAttachment
// ====================================================

export interface createFilelessAttachment_createFilelessAttachment_uploader {
  name: string | null;
}

export interface createFilelessAttachment_createFilelessAttachment {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: createFilelessAttachment_createFilelessAttachment_uploader | null;
  url: string | null;
}

export interface createFilelessAttachment {
  /**
   * Creates an attachment without a file
   */
  createFilelessAttachment: createFilelessAttachment_createFilelessAttachment | null;
}

export interface createFilelessAttachmentVariables {
  filelessCreationArgs?: FilelessCreationInput | null;
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AttachmentDelete
// ====================================================

export interface AttachmentDelete {
  /**
   * Delete an attachment
   */
  deleteAttachment: boolean | null;
}

export interface AttachmentDeleteVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateAttachment
// ====================================================

export interface updateAttachment_updateAttachment_uploader {
  name: string | null;
}

export interface updateAttachment_updateAttachment {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: updateAttachment_updateAttachment_uploader | null;
  url: string | null;
}

export interface updateAttachment {
  /**
   * Update a attachment
   */
  updateAttachment: updateAttachment_updateAttachment | null;
}

export interface updateAttachmentVariables {
  attachmentId: string;
  attachmentArgs: AttachmentInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteBankAccount
// ====================================================

export interface deleteBankAccount {
  /**
   * Delete a bank account
   */
  deleteBankAccount: boolean | null;
}

export interface deleteBankAccountVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BillCreate
// ====================================================

export interface BillCreate_createBill {
  id: string;
}

export interface BillCreate {
  createBill: BillCreate_createBill | null;
}

export interface BillCreateVariables {
  shipmentsArgs?: ShipmentScopedInput[] | null;
  language: AvailableLocalesEnum;
  billItemIds?: string[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BillDelete
// ====================================================

export interface BillDelete {
  /**
   * Find an bill then change the status to deleted
   */
  deleteBill: boolean | null;
}

export interface BillDeleteVariables {
  billArgs: BillInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertBillItems
// ====================================================

export interface upsertBillItems_upsertBillItems_partner {
  id: string;
  code: string;
}

export interface upsertBillItems_upsertBillItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: upsertBillItems_upsertBillItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface upsertBillItems {
  /**
   * Upsert bill_items list for a shipment
   */
  upsertBillItems: upsertBillItems_upsertBillItems[] | null;
}

export interface upsertBillItemsVariables {
  billItemsArgs: BillItemInput[];
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteBillItemTemplate
// ====================================================

export interface deleteBillItemTemplate {
  deleteBillItemTemplate: boolean | null;
}

export interface deleteBillItemTemplateVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertBillItemTemplate
// ====================================================

export interface upsertBillItemTemplate_upsertBillItemTemplate {
  category: string | null;
  description: string | null;
  id: string;
  taxType: TaxTypeEnum;
}

export interface upsertBillItemTemplate {
  upsertBillItemTemplate: upsertBillItemTemplate_upsertBillItemTemplate | null;
}

export interface upsertBillItemTemplateVariables {
  biItemTemplateArgs: BillItemTemplateInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BillPublish
// ====================================================

export interface BillPublish_publishBill {
  id: string;
}

export interface BillPublish {
  /**
   * Find an bill then change the status to published
   */
  publishBill: BillPublish_publishBill | null;
}

export interface BillPublishVariables {
  billArgs: BillInput;
  billingComplete: boolean;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BillRegenerate
// ====================================================

export interface BillRegenerate_regenerateBill {
  id: string;
}

export interface BillRegenerate {
  regenerateBill: BillRegenerate_regenerateBill | null;
}

export interface BillRegenerateVariables {
  billId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BillUpdate
// ====================================================

export interface BillUpdate_updateBill {
  id: string;
  status: BillStatusEnum | null;
  dueDate: any | null;
  issueDate: any | null;
  remark: string | null;
}

export interface BillUpdate {
  /**
   * Find a bill matching the id and update
   */
  updateBill: BillUpdate_updateBill | null;
}

export interface BillUpdateVariables {
  billArgs: BillInput;
  billItemIds?: string[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createPartnerMembersChannel
// ====================================================

export interface createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_channel {
  id: string;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_file_uploader {
  name: string | null;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_file_uploader | null;
  url: string | null;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_sender {
  avatar: createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_channelMessages {
  channel: createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_file | null;
  id: string;
  sender: createPartnerMembersChannel_createPartnerMembersChannel_channelMessages_sender;
  shipmentId: string;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_channel {
  id: string;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_file_uploader {
  name: string | null;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_file_uploader | null;
  url: string | null;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_sender {
  avatar: createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_lastMessage {
  channel: createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_file | null;
  id: string;
  sender: createPartnerMembersChannel_createPartnerMembersChannel_lastMessage_sender;
  shipmentId: string;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_partnerMembers_partner {
  id: string;
  name: string;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel_partnerMembers {
  id: string;
  partner: createPartnerMembersChannel_createPartnerMembersChannel_partnerMembers_partner;
}

export interface createPartnerMembersChannel_createPartnerMembersChannel {
  channelMessages: createPartnerMembersChannel_createPartnerMembersChannel_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: createPartnerMembersChannel_createPartnerMembersChannel_lastMessage | null;
  partnerMembers: createPartnerMembersChannel_createPartnerMembersChannel_partnerMembers[] | null;
  shipmentId: string;
}

export interface createPartnerMembersChannel {
  /**
   * Create a new partner members chat channel
   */
  createPartnerMembersChannel: createPartnerMembersChannel_createPartnerMembersChannel | null;
}

export interface createPartnerMembersChannelVariables {
  partnerMemberIds: string[];
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createChannelMessage
// ====================================================

export interface createChannelMessage_createChannelMessage_channel {
  id: string;
}

export interface createChannelMessage_createChannelMessage_file_uploader {
  name: string | null;
}

export interface createChannelMessage_createChannelMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: createChannelMessage_createChannelMessage_file_uploader | null;
  url: string | null;
}

export interface createChannelMessage_createChannelMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface createChannelMessage_createChannelMessage_sender {
  avatar: createChannelMessage_createChannelMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface createChannelMessage_createChannelMessage {
  channel: createChannelMessage_createChannelMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: createChannelMessage_createChannelMessage_file | null;
  id: string;
  sender: createChannelMessage_createChannelMessage_sender;
  shipmentId: string;
}

export interface createChannelMessage {
  /**
   * Create a new channel message
   */
  createChannelMessage: createChannelMessage_createChannelMessage | null;
}

export interface createChannelMessageVariables {
  message: ChannelMessageInput;
  channelId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateChannel
// ====================================================

export interface updateChannel_updateChannel_channelMessages_channel {
  id: string;
}

export interface updateChannel_updateChannel_channelMessages_file_uploader {
  name: string | null;
}

export interface updateChannel_updateChannel_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: updateChannel_updateChannel_channelMessages_file_uploader | null;
  url: string | null;
}

export interface updateChannel_updateChannel_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface updateChannel_updateChannel_channelMessages_sender {
  avatar: updateChannel_updateChannel_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface updateChannel_updateChannel_channelMessages {
  channel: updateChannel_updateChannel_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: updateChannel_updateChannel_channelMessages_file | null;
  id: string;
  sender: updateChannel_updateChannel_channelMessages_sender;
  shipmentId: string;
}

export interface updateChannel_updateChannel_lastMessage_channel {
  id: string;
}

export interface updateChannel_updateChannel_lastMessage_file_uploader {
  name: string | null;
}

export interface updateChannel_updateChannel_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: updateChannel_updateChannel_lastMessage_file_uploader | null;
  url: string | null;
}

export interface updateChannel_updateChannel_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface updateChannel_updateChannel_lastMessage_sender {
  avatar: updateChannel_updateChannel_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface updateChannel_updateChannel_lastMessage {
  channel: updateChannel_updateChannel_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: updateChannel_updateChannel_lastMessage_file | null;
  id: string;
  sender: updateChannel_updateChannel_lastMessage_sender;
  shipmentId: string;
}

export interface updateChannel_updateChannel_partnerMembers_partner {
  id: string;
  name: string;
}

export interface updateChannel_updateChannel_partnerMembers {
  id: string;
  partner: updateChannel_updateChannel_partnerMembers_partner;
}

export interface updateChannel_updateChannel {
  channelMessages: updateChannel_updateChannel_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: updateChannel_updateChannel_lastMessage | null;
  partnerMembers: updateChannel_updateChannel_partnerMembers[] | null;
  shipmentId: string;
}

export interface updateChannel {
  /**
   * Update partner members in a channel
   */
  updateChannel: updateChannel_updateChannel | null;
}

export interface updateChannelVariables {
  channelId: string;
  partnerMemberIds: string[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: checkTask
// ====================================================

export interface checkTask_checkTask_assignee_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface checkTask_checkTask_assignee {
  id: string;
  name: string;
  assigneeType: TaskAssigneeTypeEnum;
  avatar: checkTask_checkTask_assignee_avatar | null;
}

export interface checkTask_checkTask_customerOrganization {
  id: string;
  name: string;
}

export interface checkTask_checkTask {
  assignee: checkTask_checkTask_assignee | null;
  customerOrganization: checkTask_checkTask_customerOrganization;
  deadlineDate: any | null;
  description: string | null;
  doneAt: any | null;
  id: string;
  isPublic: boolean;
  reminderDate: any | null;
  responsibleParty: string;
  shipmentId: string;
  shipmentReference: string;
  shipmentType: string;
  title: string;
}

export interface checkTask {
  /**
   * Check a shipment's task
   */
  checkTask: checkTask_checkTask | null;
}

export interface checkTaskVariables {
  taskArgs: TaskCheckInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createContact
// ====================================================

export interface createContact_createContact_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface createContact_createContact_address_country {
  id: string;
  nameTranslations: createContact_createContact_address_country_nameTranslations;
  unLocode: string;
}

export interface createContact_createContact_address {
  city: string | null;
  country: createContact_createContact_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface createContact_createContact_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface createContact_createContact_country {
  id: string;
  nameTranslations: createContact_createContact_country_nameTranslations;
  unLocode: string;
}

export interface createContact_createContact_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface createContact_createContact_customerOrganization_address_country {
  id: string;
  nameTranslations: createContact_createContact_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface createContact_createContact_customerOrganization_address {
  city: string | null;
  country: createContact_createContact_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface createContact_createContact_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface createContact_createContact_customerOrganization {
  address: createContact_createContact_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: createContact_createContact_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface createContact_createContact {
  address: createContact_createContact_address | null;
  country: createContact_createContact_country | null;
  customerOrganization: createContact_createContact_customerOrganization;
  email: string | null;
  faxNumber: string | null;
  id: string;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
}

export interface createContact {
  createContact: createContact_createContact | null;
}

export interface createContactVariables {
  contactArgs: ContactInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteContact
// ====================================================

export interface deleteContact {
  /**
   * Find an contact then set it's deleted flag
   */
  deleteContact: boolean | null;
}

export interface deleteContactVariables {
  contactArgs: ContactInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateContact
// ====================================================

export interface updateContact_updateContact_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateContact_updateContact_address_country {
  id: string;
  nameTranslations: updateContact_updateContact_address_country_nameTranslations;
  unLocode: string;
}

export interface updateContact_updateContact_address {
  city: string | null;
  country: updateContact_updateContact_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateContact_updateContact_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateContact_updateContact_country {
  id: string;
  nameTranslations: updateContact_updateContact_country_nameTranslations;
  unLocode: string;
}

export interface updateContact_updateContact_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateContact_updateContact_customerOrganization_address_country {
  id: string;
  nameTranslations: updateContact_updateContact_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface updateContact_updateContact_customerOrganization_address {
  city: string | null;
  country: updateContact_updateContact_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateContact_updateContact_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateContact_updateContact_customerOrganization {
  address: updateContact_updateContact_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: updateContact_updateContact_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface updateContact_updateContact {
  address: updateContact_updateContact_address | null;
  country: updateContact_updateContact_country | null;
  customerOrganization: updateContact_updateContact_customerOrganization;
  email: string | null;
  faxNumber: string | null;
  id: string;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
}

export interface updateContact {
  /**
   * Find and update a contact
   */
  updateContact: updateContact_updateContact | null;
}

export interface updateContactVariables {
  contactArgs: ContactInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createProduct
// ====================================================

export interface createProduct_createProduct_attachments_uploader {
  name: string | null;
}

export interface createProduct_createProduct_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: createProduct_createProduct_attachments_uploader | null;
  url: string | null;
}

export interface createProduct_createProduct_hsCodes {
  code: string | null;
  country: string | null;
}

export interface createProduct_createProduct {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: createProduct_createProduct_attachments[] | null;
  hsCodes: createProduct_createProduct_hsCodes[] | null;
}

export interface createProduct {
  createProduct: createProduct_createProduct | null;
}

export interface createProductVariables {
  productArgs: ProductInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createSignedUploadUrl
// ====================================================

export interface createSignedUploadUrl_generateSignedUploadUrl {
  expiration: any | null;
  serializedFields: string;
  url: string;
}

export interface createSignedUploadUrl {
  /**
   * Generate a signed url for safe uploading from client valid for 1 hour
   */
  generateSignedUploadUrl: createSignedUploadUrl_generateSignedUploadUrl | null;
}

export interface createSignedUploadUrlVariables {
  fileName: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteLocation
// ====================================================

export interface deleteLocation {
  deleteCustomerLocation: boolean | null;
}

export interface deleteLocationVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateCustomerOrganization
// ====================================================

export interface updateCustomerOrganization_updateCustomerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateCustomerOrganization_updateCustomerOrganization_address_country {
  id: string;
  nameTranslations: updateCustomerOrganization_updateCustomerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface updateCustomerOrganization_updateCustomerOrganization_address {
  city: string | null;
  country: updateCustomerOrganization_updateCustomerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateCustomerOrganization_updateCustomerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateCustomerOrganization_updateCustomerOrganization {
  address: updateCustomerOrganization_updateCustomerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: updateCustomerOrganization_updateCustomerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface updateCustomerOrganization {
  /**
   * Update basic information on the customer organization
   */
  updateCustomerOrganization: updateCustomerOrganization_updateCustomerOrganization | null;
}

export interface updateCustomerOrganizationVariables {
  customerOrganizationArgs: CustomerOrganizationInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertCustomerOrganization
// ====================================================

export interface upsertCustomerOrganization_upsertCustomerOrganization {
  id: string;
}

export interface upsertCustomerOrganization {
  /**
   * Upsert a Customer Organization without any shipper
   */
  upsertCustomerOrganization: upsertCustomerOrganization_upsertCustomerOrganization | null;
}

export interface upsertCustomerOrganizationVariables {
  organizationArgs: CustomerOrganizationInput;
  orgId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: hideCustomerOrganization
// ====================================================

export interface hideCustomerOrganization_hideCustomerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface hideCustomerOrganization_hideCustomerOrganization_address_country {
  id: string;
  nameTranslations: hideCustomerOrganization_hideCustomerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface hideCustomerOrganization_hideCustomerOrganization_address {
  city: string | null;
  country: hideCustomerOrganization_hideCustomerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface hideCustomerOrganization_hideCustomerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface hideCustomerOrganization_hideCustomerOrganization {
  address: hideCustomerOrganization_hideCustomerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: hideCustomerOrganization_hideCustomerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface hideCustomerOrganization {
  /**
   * hide or unhide customer organization
   */
  hideCustomerOrganization: hideCustomerOrganization_hideCustomerOrganization | null;
}

export interface hideCustomerOrganizationVariables {
  customerOrganizationArgs: CustomerOrganizationHideInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateShipper
// ====================================================

export interface updateShipper_updateShipper_organization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateShipper_updateShipper_organization_address_country {
  id: string;
  nameTranslations: updateShipper_updateShipper_organization_address_country_nameTranslations;
  unLocode: string;
}

export interface updateShipper_updateShipper_organization_address {
  city: string | null;
  country: updateShipper_updateShipper_organization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateShipper_updateShipper_organization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateShipper_updateShipper_organization {
  address: updateShipper_updateShipper_organization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: updateShipper_updateShipper_organization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface updateShipper_updateShipper {
  email: string | null;
  hiddenAt: any | null;
  id: string | null;
  language: AvailableLocalesEnum | null;
  name: string | null;
  phoneNumber: string | null;
  customerOrganizationId: string;
  organization: updateShipper_updateShipper_organization;
  status: string | null;
}

export interface updateShipper {
  /**
   * Update basic information on the shipper
   */
  updateShipper: updateShipper_updateShipper | null;
}

export interface updateShipperVariables {
  shipperArgs: ShipperInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteProduct
// ====================================================

export interface DeleteProduct {
  /**
   * Find a product  then set it's deleted flag
   */
  deleteProduct: boolean | null;
}

export interface DeleteProductVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteQuote
// ====================================================

export interface deleteQuote {
  /**
   * Find a quote by ID and delete it
   */
  deleteQuote: boolean | null;
}

export interface deleteQuoteVariables {
  quoteId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteTask
// ====================================================

export interface deleteTask {
  /**
   * delete a task
   */
  deleteTask: boolean | null;
}

export interface deleteTaskVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: copyShipmentDocument
// ====================================================

export interface copyShipmentDocument_copyShipmentDocument {
  createdAt: any;
  documentType: DocumentTypeEnum;
  id: string;
  title: string | null;
  updatedAt: any;
}

export interface copyShipmentDocument {
  /**
   * Create a Copy of a Shipment Document with an altered title
   */
  copyShipmentDocument: copyShipmentDocument_copyShipmentDocument | null;
}

export interface copyShipmentDocumentVariables {
  shipmentDocumentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createShipmentDocument
// ====================================================

export interface createShipmentDocument_createShipmentDocument {
  createdAt: any;
  documentType: DocumentTypeEnum;
  id: string;
  title: string | null;
  updatedAt: any;
}

export interface createShipmentDocument {
  /**
   * Will create a new entry in shipment_documents with generated default values
   */
  createShipmentDocument: createShipmentDocument_createShipmentDocument | null;
}

export interface createShipmentDocumentVariables {
  shipmentId: string;
  documentType: DocumentTypeEnum;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteShipmentDocument
// ====================================================

export interface deleteShipmentDocument_deleteShipmentDocument {
  id: string;
}

export interface deleteShipmentDocument {
  /**
   * Will delete the generated shipment document that matches the given ID
   */
  deleteShipmentDocument: deleteShipmentDocument_deleteShipmentDocument | null;
}

export interface deleteShipmentDocumentVariables {
  shipmentDocumentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateShipmentDocument
// ====================================================

export interface updateShipmentDocument_updateShipmentDocument_data_billItems {
  id: string;
  category: string | null;
  description: string | null;
  displayCurrency: CurrencyEnum;
  quantity: number | null;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  unitPrice: number | null;
}

export interface updateShipmentDocument_updateShipmentDocument_data_containerNumbers {
  containerCount: number | null;
  containerNumber: string | null;
  containerType: ContainerSizeEnum | null;
  sealNumber: string | null;
}

export interface updateShipmentDocument_updateShipmentDocument_data_delegatedSteps {
  delegatedStep: string | null;
  taxType: TaxTypeEnumBase | null;
}

export interface updateShipmentDocument_updateShipmentDocument_data {
  airCarrier: string | null;
  arrangementRemarks: string | null;
  assignedOperator: string | null;
  attachedDocuments: AttachedDocumentEnum[] | null;
  billItems: updateShipmentDocument_updateShipmentDocument_data_billItems[] | null;
  blNumberOfOriginals: number | null;
  blPlaceOfIssuance: string | null;
  blType: BlTypeEnum | null;
  bookingNumber: string | null;
  cargoCollectionAddress: string | null;
  cargoCollectionContact: string | null;
  cargoPickupDatetime: any | null;
  cargoRemarks: string | null;
  freeTime: any | null;
  clientRemarks: string | null;
  collectionAddress: string | null;
  collectionContact: string | null;
  collectionContactInformation: string | null;
  collectionName: string | null;
  collectionPhone: string | null;
  collectionPreferredDatetime: any | null;
  consolidator: string | null;
  containerNumbers: updateShipmentDocument_updateShipmentDocument_data_containerNumbers[] | null;
  customerAddress: string | null;
  customerBankAccountNumber: string | null;
  customerCompanyNumber: string | null;
  /**
   * 包括 / 付保なし / 個別
   */
  customerInsurance: CustomerInsuranceEnum | null;
  customerInsuranceNumber: string | null;
  customerName: string | null;
  customerPostponementNumber: string | null;
  customerShipperConsigneeStandardCode: string | null;
  customsArrivalDate: any | null;
  customsClearanceDate: any | null;
  customsClearanceDesiredDate: any | null;
  customsLocation: string | null;
  customsPickupDate: any | null;
  cyCfsCutDate: any | null;
  /**
   * O - X
   */
  dangerous: boolean | null;
  declaredValue: string | null;
  delegatedSteps: updateShipmentDocument_updateShipmentDocument_data_delegatedSteps[] | null;
  deliveryLocation: string | null;
  deliveryPlaceRemarks: string | null;
  deliveryRemarks: string | null;
  descriptionOfGoods: string | null;
  /**
   * 希望する・希望しない
   */
  dispatchArrangements: boolean | null;
  dutyTaxPaymentMethod: DutyTaxPaymentMethodEnum | null;
  /**
   * 希望する・希望しない
   */
  emptyVanPickup: boolean | null;
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  /**
   * 希望する・希望しない
   */
  exportRegistration: boolean | null;
  finalCurrency: CurrencyEnum | null;
  finalDestination: string | null;
  finalRemarks: string | null;
  flightNumber: string | null;
  freightDeliveryAddress: string | null;
  freightDeliveryContact: string | null;
  freightDeliveryContactInformation: string | null;
  freightDeliveryDatetime: any | null;
  freightDeliveryName: string | null;
  freightRemarks: string | null;
  grossVolume: number | null;
  grossWeight: number | null;
  houseBlNumber: string | null;
  hsCode: string | null;
  importDestinationAddress: string | null;
  importDestinationPhone: string | null;
  issuanceDate: any | null;
  masterBlNumber: string | null;
  /**
   * O - X
   */
  motorGenerator: boolean | null;
  /**
   * 希望する・希望しない
   */
  naccsAclDockReport: boolean | null;
  naccsCode: string | null;
  /**
   * 希望する・希望しない
   */
  naccsHdl: boolean | null;
  /**
   * free text / なし
   */
  otherLaws: string | null;
  packagingQuantity: number | null;
  packaging: string | null;
  pickupDate: any | null;
  pickupPlaceRemarks: string | null;
  pickupRemarks: string | null;
  placeOfDelivery: string | null;
  placeOfReceipt: string | null;
  portOfDischarge: string | null;
  portOfLoading: string | null;
  preCarriageBy: string | null;
  /**
   * O - X
   */
  preCooling: boolean | null;
  /**
   * 希望する・希望しない
   */
  preliminaryFilings: boolean | null;
  presetTemperature: string | null;
  priceCategorization: PriceCategorization | null;
  /**
   * O - X
   */
  proofOfOrigin: boolean | null;
  quantityOfContainers: number | null;
  remarks: string | null;
  /**
   * X / Free Text
   */
  requiresWarehouseWork: string | null;
  seaCarrier: string | null;
  shipmentAlsoNotifyName: string | null;
  shipmentAlsoNotifyAddress: string | null;
  shipmentAlsoNotifyEmail: string | null;
  shipmentAlsoNotifyPhone: string | null;
  shipmentConsigneeAccountNumber: string | null;
  shipmentConsigneeAddress: string | null;
  shipmentConsigneeEmail: string | null;
  shipmentConsigneeName: string | null;
  shipmentConsigneePhone: string | null;
  shipmentCustomerRole: CustomerRoleEnum | null;
  shipmentDeliveryAgentAccountNumber: string | null;
  shipmentDeliveryAgentAddress: string | null;
  shipmentDeliveryAgentEmail: string | null;
  shipmentDeliveryAgentName: string | null;
  shipmentDeliveryAgentPhone: string | null;
  shipmentExchangeRate: number | null;
  shipmentIncoterms: IncotermsTypeEnum | null;
  shipmentInvoiceNumber: string | null;
  shipmentNotifyAccountNumber: string | null;
  shipmentNotifyAddress: string | null;
  shipmentNotifyEmail: string | null;
  shipmentNotifyName: string | null;
  shipmentNotifyPhone: string | null;
  shipmentPaymentPlace: string | null;
  shipmentPaymentTerms: PaymentTermsTypeEnum | null;
  shipmentReference: string | null;
  shipmentShipperAccountNumber: string | null;
  shipmentShipperAddress: string | null;
  shipmentShipperEmail: string | null;
  shipmentShipperName: string | null;
  shipmentShipperPhone: string | null;
  /**
   * 希望する・希望しない
   */
  shippingCompanyChargeAdvance: boolean | null;
  shippingMarks: string | null;
  shippingPlaceRemarks: string | null;
  shippingRemarks: string | null;
  /**
   * 免税・課税
   */
  taxType: TaxTypeEnumBase | null;
  transportCargoType: TransportationCargoTypeEnum | null;
  transportationType: TransportationTypeEnum | null;
  truckChassisType: AxleTypeEnum | null;
  truckType: TruckTypeEnum | null;
  vanningLocation: string | null;
  vanningLocationAddress: string | null;
  ventilation: string | null;
  vesselName: string | null;
  voyageNumber: string | null;
  /**
   * O - X
   */
  weightCalibration: boolean | null;
}

export interface updateShipmentDocument_updateShipmentDocument_shipment_customerOrganization {
  id: string;
}

export interface updateShipmentDocument_updateShipmentDocument_shipment {
  customerOrganization: updateShipmentDocument_updateShipmentDocument_shipment_customerOrganization;
  id: string;
  transportationType: TransportationTypeEnum | null;
}

export interface updateShipmentDocument_updateShipmentDocument {
  data: updateShipmentDocument_updateShipmentDocument_data;
  documentType: DocumentTypeEnum;
  id: string;
  shipment: updateShipmentDocument_updateShipmentDocument_shipment;
  title: string | null;
  updatedAt: any;
  url: string;
}

export interface updateShipmentDocument {
  /**
   * Will update data of the shipment document that matches the given ID
   */
  updateShipmentDocument: updateShipmentDocument_updateShipmentDocument | null;
}

export interface updateShipmentDocumentVariables {
  documentId: string;
  documentAttributes: ShipmentDocumentInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FollowShipment
// ====================================================

export interface FollowShipment {
  /**
   * Allow a customer to follow a shipment/inquiry
   */
  followShipment: boolean | null;
}

export interface FollowShipmentVariables {
  shipmentId: string;
  shipperId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ImportProducts
// ====================================================

export interface ImportProducts {
  /**
   * Find a product entry matching the inputs and update/create it
   */
  importProducts: boolean | null;
}

export interface ImportProductsVariables {
  uploadKey: string;
  csvSource: string;
  customerOrganizationId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteInquiry
// ====================================================

export interface deleteInquiry {
  /**
   * Find an inquiry then change it's status to cancelled
   */
  deleteInquiry: boolean | null;
}

export interface deleteInquiryVariables {
  inquiryArgs: InquiryInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: calculateInsurance
// ====================================================

export interface calculateInsurance_calculateInsurance {
  currency: string;
  amount: number;
  amountJpy: number;
}

export interface calculateInsurance {
  calculateInsurance: calculateInsurance_calculateInsurance | null;
}

export interface calculateInsuranceVariables {
  form: any;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: cancelInsurance
// ====================================================

export interface cancelInsurance {
  cancelInsurance: boolean | null;
}

export interface cancelInsuranceVariables {
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createInsurance
// ====================================================

export interface createInsurance_createInsurance {
  id: string;
  registrationRef: string | null;
  complete: boolean | null;
  currency: string | null;
  amount: number | null;
  amountJpy: number | null;
}

export interface createInsurance {
  createInsurance: createInsurance_createInsurance | null;
}

export interface createInsuranceVariables {
  shipmentId: string;
  form: any;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: saveInsurance
// ====================================================

export interface saveInsurance {
  saveInsurance: boolean | null;
}

export interface saveInsuranceVariables {
  shipmentId: string;
  form: InsuranceRequestInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LockShipment
// ====================================================

export interface LockShipment {
  /**
   * Lock a shipment
   */
  lockShipment: boolean | null;
}

export interface LockShipmentVariables {
  arguments: ShipmentLockInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: authenticateUser
// ====================================================

export interface authenticateUser_authenticateUser {
  loginToken: string;
}

export interface authenticateUser {
  /**
   * Signin mutation
   */
  authenticateUser: authenticateUser_authenticateUser | null;
}

export interface authenticateUserVariables {
  loginInformations: LoginInformationInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: logoutUser
// ====================================================

export interface logoutUser {
  /**
   * When the user logs out, create invalidation_date for the user
   */
  logoutUser: boolean | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: checkMilestone
// ====================================================

export interface checkMilestone_checkMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface checkMilestone_checkMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: checkMilestone_checkMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface checkMilestone_checkMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface checkMilestone_checkMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: checkMilestone_checkMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface checkMilestone_checkMilestone_devanningDetails {
  container: checkMilestone_checkMilestone_devanningDetails_container | null;
}

export interface checkMilestone_checkMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface checkMilestone_checkMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface checkMilestone_checkMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface checkMilestone_checkMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface checkMilestone_checkMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface checkMilestone_checkMilestone {
  deliveryTime: any | null;
  details: checkMilestone_checkMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: checkMilestone_checkMilestone_devanningDetails | null;
  doneDates: checkMilestone_checkMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: checkMilestone_checkMilestone_pod | null;
  pol: checkMilestone_checkMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: checkMilestone_checkMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: checkMilestone_checkMilestone_vessel | null;
  vesselId: string | null;
}

export interface checkMilestone {
  /**
   * Mark a milestone as done or not
   */
  checkMilestone: checkMilestone_checkMilestone | null;
}

export interface checkMilestoneVariables {
  milestoneArgs: MilestoneCheckInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createMilestone
// ====================================================

export interface createMilestone_createMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface createMilestone_createMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: createMilestone_createMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface createMilestone_createMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface createMilestone_createMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: createMilestone_createMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface createMilestone_createMilestone_devanningDetails {
  container: createMilestone_createMilestone_devanningDetails_container | null;
}

export interface createMilestone_createMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface createMilestone_createMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface createMilestone_createMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface createMilestone_createMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface createMilestone_createMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface createMilestone_createMilestone {
  deliveryTime: any | null;
  details: createMilestone_createMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: createMilestone_createMilestone_devanningDetails | null;
  doneDates: createMilestone_createMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: createMilestone_createMilestone_pod | null;
  pol: createMilestone_createMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: createMilestone_createMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: createMilestone_createMilestone_vessel | null;
  vesselId: string | null;
}

export interface createMilestone {
  createMilestone: createMilestone_createMilestone | null;
}

export interface createMilestoneVariables {
  milestoneArgs: MilestoneInput;
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteMilestone
// ====================================================

export interface deleteMilestone_deleteMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface deleteMilestone_deleteMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: deleteMilestone_deleteMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface deleteMilestone_deleteMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface deleteMilestone_deleteMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: deleteMilestone_deleteMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface deleteMilestone_deleteMilestone_devanningDetails {
  container: deleteMilestone_deleteMilestone_devanningDetails_container | null;
}

export interface deleteMilestone_deleteMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface deleteMilestone_deleteMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface deleteMilestone_deleteMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface deleteMilestone_deleteMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface deleteMilestone_deleteMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface deleteMilestone_deleteMilestone {
  deliveryTime: any | null;
  details: deleteMilestone_deleteMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: deleteMilestone_deleteMilestone_devanningDetails | null;
  doneDates: deleteMilestone_deleteMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: deleteMilestone_deleteMilestone_pod | null;
  pol: deleteMilestone_deleteMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: deleteMilestone_deleteMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: deleteMilestone_deleteMilestone_vessel | null;
  vesselId: string | null;
}

export interface deleteMilestone {
  deleteMilestone: deleteMilestone_deleteMilestone | null;
}

export interface deleteMilestoneVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: reorderMilestones
// ====================================================

export interface reorderMilestones_reorderMilestones_details_containerDetails {
  containerNumber: string | null;
}

export interface reorderMilestones_reorderMilestones_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: reorderMilestones_reorderMilestones_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface reorderMilestones_reorderMilestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface reorderMilestones_reorderMilestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: reorderMilestones_reorderMilestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface reorderMilestones_reorderMilestones_devanningDetails {
  container: reorderMilestones_reorderMilestones_devanningDetails_container | null;
}

export interface reorderMilestones_reorderMilestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface reorderMilestones_reorderMilestones_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface reorderMilestones_reorderMilestones_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface reorderMilestones_reorderMilestones_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface reorderMilestones_reorderMilestones_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface reorderMilestones_reorderMilestones {
  deliveryTime: any | null;
  details: reorderMilestones_reorderMilestones_details | null;
  devanningDate: any | null;
  devanningDetails: reorderMilestones_reorderMilestones_devanningDetails | null;
  doneDates: reorderMilestones_reorderMilestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: reorderMilestones_reorderMilestones_pod | null;
  pol: reorderMilestones_reorderMilestones_pol | null;
  shipmentId: string | null;
  truckingDetails: reorderMilestones_reorderMilestones_truckingDetails | null;
  updatedAt: any | null;
  vessel: reorderMilestones_reorderMilestones_vessel | null;
  vesselId: string | null;
}

export interface reorderMilestones {
  reorderMilestones: reorderMilestones_reorderMilestones[] | null;
}

export interface reorderMilestonesVariables {
  milestoneIds: string[];
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateMilestone
// ====================================================

export interface updateMilestone_updateMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface updateMilestone_updateMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: updateMilestone_updateMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface updateMilestone_updateMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface updateMilestone_updateMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: updateMilestone_updateMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface updateMilestone_updateMilestone_devanningDetails {
  container: updateMilestone_updateMilestone_devanningDetails_container | null;
}

export interface updateMilestone_updateMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface updateMilestone_updateMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface updateMilestone_updateMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface updateMilestone_updateMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface updateMilestone_updateMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface updateMilestone_updateMilestone {
  deliveryTime: any | null;
  details: updateMilestone_updateMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: updateMilestone_updateMilestone_devanningDetails | null;
  doneDates: updateMilestone_updateMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: updateMilestone_updateMilestone_pod | null;
  pol: updateMilestone_updateMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: updateMilestone_updateMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: updateMilestone_updateMilestone_vessel | null;
  vesselId: string | null;
}

export interface updateMilestone {
  updateMilestone: updateMilestone_updateMilestone | null;
}

export interface updateMilestoneVariables {
  milestoneArgs: MilestoneInput;
  milestoneId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateProfile
// ====================================================

export interface updateProfile_updateCurrentOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface updateProfile_updateCurrentOperator {
  avatar: updateProfile_updateCurrentOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface updateProfile {
  /**
   * Update basic information on the current operator
   */
  updateCurrentOperator: updateProfile_updateCurrentOperator | null;
}

export interface updateProfileVariables {
  operatorArgs: OperatorInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: OperatorOrgUpdate
// ====================================================

export interface OperatorOrgUpdate {
  /**
   * Updates Operator Org fields
   */
  updateOperatorOrganization: boolean | null;
}

export interface OperatorOrgUpdateVariables {
  operatorOrgArgs: OperatorOrganizationInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createPartnerMember
// ====================================================

export interface createPartnerMember_createPartnerMember_partner {
  id: string;
}

export interface createPartnerMember_createPartnerMember {
  deletedAt: any | null;
  email: string;
  id: string;
  locale: AvailableLocalesEnum;
  name: string;
  partner: createPartnerMember_createPartnerMember_partner;
  phoneNumber: string | null;
}

export interface createPartnerMember {
  /**
   * Allows for the creation of 1 or more Partner members
   */
  createPartnerMember: createPartnerMember_createPartnerMember[] | null;
}

export interface createPartnerMemberVariables {
  partnerId: string;
  membersArgs: PartnerMemberScopedInput[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deletePartner
// ====================================================

export interface deletePartner_deletePartner_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface deletePartner_deletePartner_address_country {
  id: string;
  nameTranslations: deletePartner_deletePartner_address_country_nameTranslations;
  unLocode: string;
}

export interface deletePartner_deletePartner_address {
  city: string | null;
  country: deletePartner_deletePartner_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface deletePartner_deletePartner_members_partner {
  id: string;
}

export interface deletePartner_deletePartner_members {
  deletedAt: any | null;
  email: string;
  id: string;
  locale: AvailableLocalesEnum;
  name: string;
  partner: deletePartner_deletePartner_members_partner;
  phoneNumber: string | null;
}

export interface deletePartner_deletePartner {
  address: deletePartner_deletePartner_address | null;
  code: string;
  deletedAt: any | null;
  faxNumber: string | null;
  id: string;
  name: string;
  normalizedName: string | null;
  note: string | null;
  /**
   * List our various Partner Members
   */
  members: deletePartner_deletePartner_members[] | null;
  phoneNumber: string | null;
  url: string | null;
}

export interface deletePartner {
  /**
   * Delete a Partner
   */
  deletePartner: deletePartner_deletePartner | null;
}

export interface deletePartnerVariables {
  partnerId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deletePartnerMember
// ====================================================

export interface deletePartnerMember_deletePartnerMember_partner {
  id: string;
}

export interface deletePartnerMember_deletePartnerMember {
  deletedAt: any | null;
  email: string;
  id: string;
  locale: AvailableLocalesEnum;
  name: string;
  partner: deletePartnerMember_deletePartnerMember_partner;
  phoneNumber: string | null;
}

export interface deletePartnerMember {
  /**
   * Allows the deletion of a partner member
   */
  deletePartnerMember: deletePartnerMember_deletePartnerMember | null;
}

export interface deletePartnerMemberVariables {
  memberId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePartnerMember
// ====================================================

export interface updatePartnerMember_updatePartnerMember_partner {
  id: string;
}

export interface updatePartnerMember_updatePartnerMember {
  deletedAt: any | null;
  email: string;
  id: string;
  locale: AvailableLocalesEnum;
  name: string;
  partner: updatePartnerMember_updatePartnerMember_partner;
  phoneNumber: string | null;
}

export interface updatePartnerMember {
  /**
   * Allows the updating of a partner member
   */
  updatePartnerMember: updatePartnerMember_updatePartnerMember | null;
}

export interface updatePartnerMemberVariables {
  memberId: string;
  memberArgs: PartnerMemberScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertPartner
// ====================================================

export interface upsertPartner_upsertPartner_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface upsertPartner_upsertPartner_address_country {
  id: string;
  nameTranslations: upsertPartner_upsertPartner_address_country_nameTranslations;
  unLocode: string;
}

export interface upsertPartner_upsertPartner_address {
  city: string | null;
  country: upsertPartner_upsertPartner_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface upsertPartner_upsertPartner_members_partner {
  id: string;
}

export interface upsertPartner_upsertPartner_members {
  deletedAt: any | null;
  email: string;
  id: string;
  locale: AvailableLocalesEnum;
  name: string;
  partner: upsertPartner_upsertPartner_members_partner;
  phoneNumber: string | null;
}

export interface upsertPartner_upsertPartner {
  address: upsertPartner_upsertPartner_address | null;
  code: string;
  deletedAt: any | null;
  faxNumber: string | null;
  id: string;
  name: string;
  normalizedName: string | null;
  note: string | null;
  /**
   * List our various Partner Members
   */
  members: upsertPartner_upsertPartner_members[] | null;
  phoneNumber: string | null;
  url: string | null;
}

export interface upsertPartner {
  /**
   * Create or Update a Partner
   */
  upsertPartner: upsertPartner_upsertPartner | null;
}

export interface upsertPartnerVariables {
  partnerId?: string | null;
  partnerArgs?: PartnerScopedInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuoteSelect
// ====================================================

export interface QuoteSelect {
  /**
   * Allows an operator to select a quote
   */
  selectQuote: boolean | null;
}

export interface QuoteSelectVariables {
  quoteId: string;
  selectedSections?: QuoteSectionEnum[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuoteSubmit
// ====================================================

export interface QuoteSubmit_submitQuote {
  id: string;
}

export interface QuoteSubmit {
  /**
   * Allows an operator to submit a quote to a customer for one or multiple inquiries
   */
  submitQuote: QuoteSubmit_submitQuote | null;
}

export interface QuoteSubmitVariables {
  quoteArgs: QuoteInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuoteTemplateCreate
// ====================================================

export interface QuoteTemplateCreate {
  /**
   * Create a quote template
   */
  createQuoteTemplate: boolean | null;
}

export interface QuoteTemplateCreateVariables {
  quoteTemplateArgs: QuoteTemplateInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteQuoteTemplate
// ====================================================

export interface deleteQuoteTemplate {
  /**
   * Soft delete quote templates
   */
  deleteQuoteTemplates: boolean | null;
}

export interface deleteQuoteTemplateVariables {
  quoteTemplateIds: string[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: loadQuoteTemplate
// ====================================================

export interface loadQuoteTemplate {
  /**
   * loads the template into the selected shipment
   */
  loadQuoteTemplate: boolean | null;
}

export interface loadQuoteTemplateVariables {
  quoteTemplateLoadArgs: QuoteTemplateLoadInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: readNotification
// ====================================================

export interface readNotification {
  readNotifications: boolean | null;
}

export interface readNotificationVariables {
  notificationArgs?: NotificationReadInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: assignShipment
// ====================================================

export interface assignShipment_assignShipment_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface assignShipment_assignShipment_assignedOperator {
  avatar: assignShipment_assignShipment_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface assignShipment_assignShipment {
  id: string;
  assignedOperator: assignShipment_assignShipment_assignedOperator | null;
}

export interface assignShipment {
  /**
   * Assign a shipment to operator
   */
  assignShipment: assignShipment_assignShipment | null;
}

export interface assignShipmentVariables {
  arguments: ShipmentAssignInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteShipment
// ====================================================

export interface deleteShipment {
  /**
   * Find an shipment then change it's status to cancelled
   */
  deleteShipment: boolean | null;
}

export interface deleteShipmentVariables {
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateShipment
// ====================================================

export interface updateShipment_updateShipment_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface updateShipment_updateShipment_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateShipment_updateShipment_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: updateShipment_updateShipment_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface updateShipment_updateShipment_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface updateShipment_updateShipment_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: updateShipment_updateShipment_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: updateShipment_updateShipment_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface updateShipment_updateShipment_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface updateShipment_updateShipment_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface updateShipment_updateShipment_assignedOperator {
  avatar: updateShipment_updateShipment_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface updateShipment_updateShipment_billItems_partner {
  id: string;
  code: string;
}

export interface updateShipment_updateShipment_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: updateShipment_updateShipment_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface updateShipment_updateShipment_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface updateShipment_updateShipment_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface updateShipment_updateShipment_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface updateShipment_updateShipment_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: updateShipment_updateShipment_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: updateShipment_updateShipment_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface updateShipment_updateShipment_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface updateShipment_updateShipment_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface updateShipment_updateShipment_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface updateShipment_updateShipment_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: updateShipment_updateShipment_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: updateShipment_updateShipment_cargoDescription_departureOptions_vanningInformations | null;
}

export interface updateShipment_updateShipment_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface updateShipment_updateShipment_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: updateShipment_updateShipment_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface updateShipment_updateShipment_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface updateShipment_updateShipment_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: updateShipment_updateShipment_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: updateShipment_updateShipment_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface updateShipment_updateShipment_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: updateShipment_updateShipment_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface updateShipment_updateShipment_cargoDescription {
  arrivalOptions: updateShipment_updateShipment_cargoDescription_arrivalOptions | null;
  containers: updateShipment_updateShipment_cargoDescription_containers[] | null;
  departureOptions: updateShipment_updateShipment_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: updateShipment_updateShipment_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface updateShipment_updateShipment_cargoReleaseContact {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface updateShipment_updateShipment_carrier {
  id: string;
  carrierType: CarrierTypeEnum;
  naccsCode: string;
  name: string | null;
}

export interface updateShipment_updateShipment_channelList_channelMessages_channel {
  id: string;
}

export interface updateShipment_updateShipment_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface updateShipment_updateShipment_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: updateShipment_updateShipment_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface updateShipment_updateShipment_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface updateShipment_updateShipment_channelList_channelMessages_sender {
  avatar: updateShipment_updateShipment_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface updateShipment_updateShipment_channelList_channelMessages {
  channel: updateShipment_updateShipment_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: updateShipment_updateShipment_channelList_channelMessages_file | null;
  id: string;
  sender: updateShipment_updateShipment_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface updateShipment_updateShipment_channelList_lastMessage_channel {
  id: string;
}

export interface updateShipment_updateShipment_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface updateShipment_updateShipment_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: updateShipment_updateShipment_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface updateShipment_updateShipment_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface updateShipment_updateShipment_channelList_lastMessage_sender {
  avatar: updateShipment_updateShipment_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface updateShipment_updateShipment_channelList_lastMessage {
  channel: updateShipment_updateShipment_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: updateShipment_updateShipment_channelList_lastMessage_file | null;
  id: string;
  sender: updateShipment_updateShipment_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface updateShipment_updateShipment_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface updateShipment_updateShipment_channelList_partnerMembers {
  id: string;
  partner: updateShipment_updateShipment_channelList_partnerMembers_partner;
}

export interface updateShipment_updateShipment_channelList {
  channelMessages: updateShipment_updateShipment_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: updateShipment_updateShipment_channelList_lastMessage | null;
  partnerMembers: updateShipment_updateShipment_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface updateShipment_updateShipment_containerInformation {
  containerNumber: string | null;
  containerReference: string | null;
  containerType: ContainerSizeEnum | null;
}

export interface updateShipment_updateShipment_consigneeDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface updateShipment_updateShipment_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateShipment_updateShipment_customerOrganization_address_country {
  id: string;
  nameTranslations: updateShipment_updateShipment_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface updateShipment_updateShipment_customerOrganization_address {
  city: string | null;
  country: updateShipment_updateShipment_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateShipment_updateShipment_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateShipment_updateShipment_customerOrganization {
  address: updateShipment_updateShipment_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: updateShipment_updateShipment_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface updateShipment_updateShipment_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface updateShipment_updateShipment_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateShipment_updateShipment_departureCustomerLocation_country {
  id: string;
  nameTranslations: updateShipment_updateShipment_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface updateShipment_updateShipment_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface updateShipment_updateShipment_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: updateShipment_updateShipment_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: updateShipment_updateShipment_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface updateShipment_updateShipment_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface updateShipment_updateShipment_milestones_details_containerDetails {
  containerNumber: string | null;
}

export interface updateShipment_updateShipment_milestones_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: updateShipment_updateShipment_milestones_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface updateShipment_updateShipment_milestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface updateShipment_updateShipment_milestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: updateShipment_updateShipment_milestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface updateShipment_updateShipment_milestones_devanningDetails {
  container: updateShipment_updateShipment_milestones_devanningDetails_container | null;
}

export interface updateShipment_updateShipment_milestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface updateShipment_updateShipment_milestones_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface updateShipment_updateShipment_milestones_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface updateShipment_updateShipment_milestones_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface updateShipment_updateShipment_milestones_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface updateShipment_updateShipment_milestones {
  deliveryTime: any | null;
  details: updateShipment_updateShipment_milestones_details | null;
  devanningDate: any | null;
  devanningDetails: updateShipment_updateShipment_milestones_devanningDetails | null;
  doneDates: updateShipment_updateShipment_milestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: updateShipment_updateShipment_milestones_pod | null;
  pol: updateShipment_updateShipment_milestones_pol | null;
  shipmentId: string | null;
  truckingDetails: updateShipment_updateShipment_milestones_truckingDetails | null;
  updatedAt: any | null;
  vessel: updateShipment_updateShipment_milestones_vessel | null;
  vesselId: string | null;
}

export interface updateShipment_updateShipment_naccsDocument_ida_consignee_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateShipment_updateShipment_naccsDocument_ida_consignee_address_country {
  id: string;
  nameTranslations: updateShipment_updateShipment_naccsDocument_ida_consignee_address_country_nameTranslations;
  unLocode: string;
}

export interface updateShipment_updateShipment_naccsDocument_ida_consignee_address {
  city: string | null;
  country: updateShipment_updateShipment_naccsDocument_ida_consignee_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateShipment_updateShipment_naccsDocument_ida_consignee {
  address: updateShipment_updateShipment_naccsDocument_ida_consignee_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface updateShipment_updateShipment_naccsDocument_ida_importCertificates {
  code: string | null;
  number: string | null;
}

export interface updateShipment_updateShipment_naccsDocument_ida_shipper_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateShipment_updateShipment_naccsDocument_ida_shipper_address_country {
  id: string;
  nameTranslations: updateShipment_updateShipment_naccsDocument_ida_shipper_address_country_nameTranslations;
  unLocode: string;
}

export interface updateShipment_updateShipment_naccsDocument_ida_shipper_address {
  city: string | null;
  country: updateShipment_updateShipment_naccsDocument_ida_shipper_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateShipment_updateShipment_naccsDocument_ida_shipper {
  address: updateShipment_updateShipment_naccsDocument_ida_shipper_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface updateShipment_updateShipment_naccsDocument_ida {
  awbNumber: string | null;
  blNumber: string[] | null;
  bondedArea: string | null;
  consignee: updateShipment_updateShipment_naccsDocument_ida_consignee | null;
  customsApplicationDate: any | null;
  declarationType: NaccsDeclarationTypeEnum | null;
  depositPaymentNumber: string | null;
  dueDateExtensionType: NaccsDueDateExtensionTypeEnum | null;
  evaluation: NaccsEvaluationEnum | null;
  existingAssessmentNumbers: string[] | null;
  incoterms: IncotermsTypeEnum | null;
  importCertificates: updateShipment_updateShipment_naccsDocument_ida_importCertificates[] | null;
  insuranceCoverage: string | null;
  insuranceCurrency: string | null;
  insurancePrice: string | null;
  insuranceType: NaccsInsuranceTypeEnum | null;
  invoiceCurrency: string | null;
  invoiceNumber: string | null;
  invoicePrice: string | null;
  invoiceType: NaccsInvoiceTypeEnum | null;
  mawbNumber: string | null;
  otherRegulations: NaccsImportRegulationCodeEnum[] | null;
  paymentMethod: NaccsPaymentMethodEnum | null;
  realTimeBankAccount: string | null;
  remarkFromShipper: string | null;
  shipper: updateShipment_updateShipment_naccsDocument_ida_shipper | null;
  shipperConsigneeStandardCode: string | null;
  shipperReferenceNumber: string | null;
  shipperSectionCode: string | null;
  tradingType: number | null;
}

export interface updateShipment_updateShipment_naccsDocument {
  ida: updateShipment_updateShipment_naccsDocument_ida | null;
}

export interface updateShipment_updateShipment_notifyPartyDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface updateShipment_updateShipment_shipperDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface updateShipment_updateShipment_trackableMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface updateShipment_updateShipment_trackableMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: updateShipment_updateShipment_trackableMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface updateShipment_updateShipment_trackableMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface updateShipment_updateShipment_trackableMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: updateShipment_updateShipment_trackableMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface updateShipment_updateShipment_trackableMilestone_devanningDetails {
  container: updateShipment_updateShipment_trackableMilestone_devanningDetails_container | null;
}

export interface updateShipment_updateShipment_trackableMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface updateShipment_updateShipment_trackableMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface updateShipment_updateShipment_trackableMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface updateShipment_updateShipment_trackableMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface updateShipment_updateShipment_trackableMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface updateShipment_updateShipment_trackableMilestone {
  deliveryTime: any | null;
  details: updateShipment_updateShipment_trackableMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: updateShipment_updateShipment_trackableMilestone_devanningDetails | null;
  doneDates: updateShipment_updateShipment_trackableMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: updateShipment_updateShipment_trackableMilestone_pod | null;
  pol: updateShipment_updateShipment_trackableMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: updateShipment_updateShipment_trackableMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: updateShipment_updateShipment_trackableMilestone_vessel | null;
  vesselId: string | null;
}

export interface updateShipment_updateShipment {
  arrivalAddress: updateShipment_updateShipment_arrivalAddress | null;
  arrivalCustomerLocation: updateShipment_updateShipment_arrivalCustomerLocation | null;
  arrivalPlace: updateShipment_updateShipment_arrivalPlace | null;
  assignedOperator: updateShipment_updateShipment_assignedOperator | null;
  billingComplete: boolean;
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: updateShipment_updateShipment_billItems[] | null;
  blMetaData: updateShipment_updateShipment_blMetaData | null;
  cargoDescription: updateShipment_updateShipment_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoReleaseContact: updateShipment_updateShipment_cargoReleaseContact | null;
  cargoType: CargoTypeEnum | null;
  carrier: updateShipment_updateShipment_carrier | null;
  channelList: updateShipment_updateShipment_channelList[];
  containerInformation: updateShipment_updateShipment_containerInformation[];
  consigneeDetails: updateShipment_updateShipment_consigneeDetails | null;
  createdAt: any | null;
  customerOrganization: updateShipment_updateShipment_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureAddress: updateShipment_updateShipment_departureAddress | null;
  departureCustomerLocation: updateShipment_updateShipment_departureCustomerLocation | null;
  departurePlace: updateShipment_updateShipment_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  endFreeTime: any | null;
  /**
   * true if the current user follow the shipment
   */
  followed: boolean;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  invoiceNumber: string | null;
  isProblem: boolean | null;
  locked: boolean | null;
  milestones: updateShipment_updateShipment_milestones[] | null;
  naccsDocument: updateShipment_updateShipment_naccsDocument | null;
  notifyPartyDetails: updateShipment_updateShipment_notifyPartyDetails | null;
  organizationPaymentTerms: string | null;
  paymentAsArranged: boolean | null;
  paymentPlace: string | null;
  paymentTerms: PaymentTermsTypeEnum | null;
  quoteAcceptedAt: any | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  reference: string | null;
  shipperDetails: updateShipment_updateShipment_shipperDetails | null;
  shippingMarks: string | null;
  showTotal: boolean | null;
  status: ShipmentStatusEnum;
  statusComment: string | null;
  taxRate: number | null;
  trackedBlNumber: string | null;
  trackableMilestone: updateShipment_updateShipment_trackableMilestone | null;
  transportationType: TransportationTypeEnum | null;
  updatedAt: any | null;
  usdJpyExchangeRate: number | null;
}

export interface updateShipment {
  /**
   * Update a shipment
   */
  updateShipment: updateShipment_updateShipment | null;
}

export interface updateShipmentVariables {
  shipmentUpdateArgs: ShipmentUpdateInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteShipper
// ====================================================

export interface deleteShipper_deleteShipper_organization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface deleteShipper_deleteShipper_organization_address_country {
  id: string;
  nameTranslations: deleteShipper_deleteShipper_organization_address_country_nameTranslations;
  unLocode: string;
}

export interface deleteShipper_deleteShipper_organization_address {
  city: string | null;
  country: deleteShipper_deleteShipper_organization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface deleteShipper_deleteShipper_organization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface deleteShipper_deleteShipper_organization {
  address: deleteShipper_deleteShipper_organization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: deleteShipper_deleteShipper_organization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface deleteShipper_deleteShipper {
  email: string | null;
  hiddenAt: any | null;
  id: string | null;
  language: AvailableLocalesEnum | null;
  name: string | null;
  phoneNumber: string | null;
  customerOrganizationId: string;
  organization: deleteShipper_deleteShipper_organization;
  status: string | null;
}

export interface deleteShipper {
  /**
   * delete shipper
   */
  deleteShipper: deleteShipper_deleteShipper | null;
}

export interface deleteShipperVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: inviteNewShipper
// ====================================================

export interface inviteNewShipper {
  /**
   * invite shipper with name and email
   */
  inviteNewShipper: boolean | null;
}

export interface inviteNewShipperVariables {
  shipperInvitationArgs: ShipperInvitationInput;
  customerOrganizationId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePassword
// ====================================================

export interface updatePassword {
  /**
   * update the password
   */
  updatePassword: boolean | null;
}

export interface updatePasswordVariables {
  passwordArgs: UpdatePasswordInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: simulateQuote
// ====================================================

export interface simulateQuote_simulateQuote_details_extra_billItems {
  category: string | null;
  cost: number;
  costJpy: number | null;
  currency: string | null;
  description: string | null;
  id: string;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  quantity: number | null;
  taxRate: number | null;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
  taxType: TaxTypeEnum;
  billId: string | null;
}

export interface simulateQuote_simulateQuote_details_extra {
  billItems: simulateQuote_simulateQuote_details_extra_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface simulateQuote_simulateQuote_details_arrivalDrayage_billItems {
  category: string | null;
  cost: number;
  costJpy: number | null;
  currency: string | null;
  description: string | null;
  id: string;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  quantity: number | null;
  taxRate: number | null;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
  taxType: TaxTypeEnum;
  billId: string | null;
}

export interface simulateQuote_simulateQuote_details_arrivalDrayage {
  billItems: simulateQuote_simulateQuote_details_arrivalDrayage_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface simulateQuote_simulateQuote_details_arrivalTrucking_billItems {
  category: string | null;
  cost: number;
  costJpy: number | null;
  currency: string | null;
  description: string | null;
  id: string;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  quantity: number | null;
  taxRate: number | null;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
  taxType: TaxTypeEnum;
  billId: string | null;
}

export interface simulateQuote_simulateQuote_details_arrivalTrucking {
  billItems: simulateQuote_simulateQuote_details_arrivalTrucking_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface simulateQuote_simulateQuote_details_departureDrayage_billItems {
  category: string | null;
  cost: number;
  costJpy: number | null;
  currency: string | null;
  description: string | null;
  id: string;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  quantity: number | null;
  taxRate: number | null;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
  taxType: TaxTypeEnum;
  billId: string | null;
}

export interface simulateQuote_simulateQuote_details_departureDrayage {
  billItems: simulateQuote_simulateQuote_details_departureDrayage_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface simulateQuote_simulateQuote_details_departureTrucking_billItems {
  category: string | null;
  cost: number;
  costJpy: number | null;
  currency: string | null;
  description: string | null;
  id: string;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  quantity: number | null;
  taxRate: number | null;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
  taxType: TaxTypeEnum;
  billId: string | null;
}

export interface simulateQuote_simulateQuote_details_departureTrucking {
  billItems: simulateQuote_simulateQuote_details_departureTrucking_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface simulateQuote_simulateQuote_details_transport_billItems {
  category: string | null;
  cost: number;
  costJpy: number | null;
  currency: string | null;
  description: string | null;
  id: string;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  quantity: number | null;
  taxRate: number | null;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
  taxType: TaxTypeEnum;
  billId: string | null;
}

export interface simulateQuote_simulateQuote_details_transport {
  billItems: simulateQuote_simulateQuote_details_transport_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface simulateQuote_simulateQuote_details {
  extra: simulateQuote_simulateQuote_details_extra;
  arrivalDrayage: simulateQuote_simulateQuote_details_arrivalDrayage;
  arrivalTrucking: simulateQuote_simulateQuote_details_arrivalTrucking;
  departureDrayage: simulateQuote_simulateQuote_details_departureDrayage;
  departureTrucking: simulateQuote_simulateQuote_details_departureTrucking;
  transport: simulateQuote_simulateQuote_details_transport;
}

export interface simulateQuote_simulateQuote_inquiry_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface simulateQuote_simulateQuote_inquiry_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: simulateQuote_simulateQuote_inquiry_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: simulateQuote_simulateQuote_inquiry_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: simulateQuote_simulateQuote_inquiry_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: simulateQuote_simulateQuote_inquiry_cargoDescription_departureOptions_vanningInformations | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: simulateQuote_simulateQuote_inquiry_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: simulateQuote_simulateQuote_inquiry_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: simulateQuote_simulateQuote_inquiry_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: simulateQuote_simulateQuote_inquiry_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface simulateQuote_simulateQuote_inquiry_cargoDescription {
  arrivalOptions: simulateQuote_simulateQuote_inquiry_cargoDescription_arrivalOptions | null;
  containers: simulateQuote_simulateQuote_inquiry_cargoDescription_containers[] | null;
  departureOptions: simulateQuote_simulateQuote_inquiry_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: simulateQuote_simulateQuote_inquiry_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface simulateQuote_simulateQuote_inquiry_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface simulateQuote_simulateQuote_inquiry_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface simulateQuote_simulateQuote_inquiry {
  arrivalAddress: simulateQuote_simulateQuote_inquiry_arrivalAddress | null;
  arrivalPlace: simulateQuote_simulateQuote_inquiry_arrivalPlace | null;
  cargoDescription: simulateQuote_simulateQuote_inquiry_cargoDescription | null;
  cargoType: CargoTypeEnum | null;
  departureAddress: simulateQuote_simulateQuote_inquiry_departureAddress | null;
  departurePlace: simulateQuote_simulateQuote_inquiry_departurePlace | null;
  transportationType: TransportationTypeEnum | null;
}

export interface simulateQuote_simulateQuote {
  details: simulateQuote_simulateQuote_details;
  id: string;
  inquiry: simulateQuote_simulateQuote_inquiry;
  margin: number | null;
  totalCost: number;
  totalMargin: number;
}

export interface simulateQuote {
  /**
   * Simulate a quote price for a simulated inquiry
   */
  simulateQuote: simulateQuote_simulateQuote | null;
}

export interface simulateQuoteVariables {
  inquiryArgs?: InquiryInput | null;
  extraBillItems?: BillItemInput[] | null;
  margin?: number | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: submitInquiry
// ====================================================

export interface submitInquiry_submitInquiry {
  id: string;
}

export interface submitInquiry {
  submitInquiry: submitInquiry_submitInquiry | null;
}

export interface submitInquiryVariables {
  inquiryArgs: InquiryInput;
  organizationId: string;
  originalInquiryId?: string | null;
  shipperIds?: string[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: unassignShipment
// ====================================================

export interface unassignShipment {
  /**
   * unassign an operator from a shipment
   */
  unassignOperator: boolean | null;
}

export interface unassignShipmentVariables {
  arguments: ShipmentAssignInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnfollowShipment
// ====================================================

export interface UnfollowShipment {
  /**
   * Allow a customer to unfollow a shipment/inquiry
   */
  unfollowShipment: boolean | null;
}

export interface UnfollowShipmentVariables {
  shipmentId: string;
  shipperId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateInquiry
// ====================================================

export interface UpdateInquiry_updateInquiry_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface UpdateInquiry_updateInquiry_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: UpdateInquiry_updateInquiry_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface UpdateInquiry_updateInquiry_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: UpdateInquiry_updateInquiry_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: UpdateInquiry_updateInquiry_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface UpdateInquiry_updateInquiry_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface UpdateInquiry_updateInquiry_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_assignedOperator {
  avatar: UpdateInquiry_updateInquiry_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface UpdateInquiry_updateInquiry_attachments_uploader {
  name: string | null;
}

export interface UpdateInquiry_updateInquiry_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: UpdateInquiry_updateInquiry_attachments_uploader | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_billItems_partner {
  id: string;
  code: string;
}

export interface UpdateInquiry_updateInquiry_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: UpdateInquiry_updateInquiry_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface UpdateInquiry_updateInquiry_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: UpdateInquiry_updateInquiry_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: UpdateInquiry_updateInquiry_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: UpdateInquiry_updateInquiry_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: UpdateInquiry_updateInquiry_cargoDescription_departureOptions_vanningInformations | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: UpdateInquiry_updateInquiry_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: UpdateInquiry_updateInquiry_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: UpdateInquiry_updateInquiry_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: UpdateInquiry_updateInquiry_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface UpdateInquiry_updateInquiry_cargoDescription {
  arrivalOptions: UpdateInquiry_updateInquiry_cargoDescription_arrivalOptions | null;
  containers: UpdateInquiry_updateInquiry_cargoDescription_containers[] | null;
  departureOptions: UpdateInquiry_updateInquiry_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: UpdateInquiry_updateInquiry_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface UpdateInquiry_updateInquiry_channelList_channelMessages_channel {
  id: string;
}

export interface UpdateInquiry_updateInquiry_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface UpdateInquiry_updateInquiry_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: UpdateInquiry_updateInquiry_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_channelList_channelMessages_sender {
  avatar: UpdateInquiry_updateInquiry_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface UpdateInquiry_updateInquiry_channelList_channelMessages {
  channel: UpdateInquiry_updateInquiry_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: UpdateInquiry_updateInquiry_channelList_channelMessages_file | null;
  id: string;
  sender: UpdateInquiry_updateInquiry_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface UpdateInquiry_updateInquiry_channelList_lastMessage_channel {
  id: string;
}

export interface UpdateInquiry_updateInquiry_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface UpdateInquiry_updateInquiry_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: UpdateInquiry_updateInquiry_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_channelList_lastMessage_sender {
  avatar: UpdateInquiry_updateInquiry_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface UpdateInquiry_updateInquiry_channelList_lastMessage {
  channel: UpdateInquiry_updateInquiry_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: UpdateInquiry_updateInquiry_channelList_lastMessage_file | null;
  id: string;
  sender: UpdateInquiry_updateInquiry_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface UpdateInquiry_updateInquiry_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface UpdateInquiry_updateInquiry_channelList_partnerMembers {
  id: string;
  partner: UpdateInquiry_updateInquiry_channelList_partnerMembers_partner;
}

export interface UpdateInquiry_updateInquiry_channelList {
  channelMessages: UpdateInquiry_updateInquiry_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: UpdateInquiry_updateInquiry_channelList_lastMessage | null;
  partnerMembers: UpdateInquiry_updateInquiry_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface UpdateInquiry_updateInquiry_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface UpdateInquiry_updateInquiry_customerOrganization_address_country {
  id: string;
  nameTranslations: UpdateInquiry_updateInquiry_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface UpdateInquiry_updateInquiry_customerOrganization_address {
  city: string | null;
  country: UpdateInquiry_updateInquiry_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface UpdateInquiry_updateInquiry_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface UpdateInquiry_updateInquiry_customerOrganization {
  address: UpdateInquiry_updateInquiry_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: UpdateInquiry_updateInquiry_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface UpdateInquiry_updateInquiry_departureCustomerLocation_country {
  id: string;
  nameTranslations: UpdateInquiry_updateInquiry_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface UpdateInquiry_updateInquiry_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: UpdateInquiry_updateInquiry_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: UpdateInquiry_updateInquiry_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface UpdateInquiry_updateInquiry_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface UpdateInquiry_updateInquiry_followers {
  id: string | null;
}

export interface UpdateInquiry_updateInquiry_lastPublicChannelMessage_channel {
  id: string;
}

export interface UpdateInquiry_updateInquiry_lastPublicChannelMessage_file_uploader {
  name: string | null;
}

export interface UpdateInquiry_updateInquiry_lastPublicChannelMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: UpdateInquiry_updateInquiry_lastPublicChannelMessage_file_uploader | null;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_lastPublicChannelMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface UpdateInquiry_updateInquiry_lastPublicChannelMessage_sender {
  avatar: UpdateInquiry_updateInquiry_lastPublicChannelMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface UpdateInquiry_updateInquiry_lastPublicChannelMessage {
  channel: UpdateInquiry_updateInquiry_lastPublicChannelMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: UpdateInquiry_updateInquiry_lastPublicChannelMessage_file | null;
  id: string;
  sender: UpdateInquiry_updateInquiry_lastPublicChannelMessage_sender;
  shipmentId: string;
}

export interface UpdateInquiry_updateInquiry_truckingDetails {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface UpdateInquiry_updateInquiry {
  arrivalAddress: UpdateInquiry_updateInquiry_arrivalAddress | null;
  arrivalCustomerLocation: UpdateInquiry_updateInquiry_arrivalCustomerLocation | null;
  arrivalPlace: UpdateInquiry_updateInquiry_arrivalPlace | null;
  assignedOperator: UpdateInquiry_updateInquiry_assignedOperator | null;
  attachments: UpdateInquiry_updateInquiry_attachments[] | null;
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: UpdateInquiry_updateInquiry_billItems[] | null;
  blMetaData: UpdateInquiry_updateInquiry_blMetaData | null;
  cargoDescription: UpdateInquiry_updateInquiry_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoType: CargoTypeEnum | null;
  channelList: UpdateInquiry_updateInquiry_channelList[];
  createdAt: any | null;
  customerOrganization: UpdateInquiry_updateInquiry_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureAddress: UpdateInquiry_updateInquiry_departureAddress | null;
  departureCustomerLocation: UpdateInquiry_updateInquiry_departureCustomerLocation | null;
  departurePlace: UpdateInquiry_updateInquiry_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  followers: UpdateInquiry_updateInquiry_followers[];
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  isFirst: boolean | null;
  lastPublicChannelMessage: UpdateInquiry_updateInquiry_lastPublicChannelMessage | null;
  organizationPaymentTerms: string | null;
  priority: number | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  quotedAt: any | null;
  reference: string | null;
  showTotal: boolean | null;
  status: InquiryStatusEnum;
  taxRate: number | null;
  transportationType: TransportationTypeEnum | null;
  truckingDetails: UpdateInquiry_updateInquiry_truckingDetails | null;
  updatedAt: any | null;
  usdJpyExchangeRate: number | null;
}

export interface UpdateInquiry {
  /**
   * Update an inquiry
   */
  updateInquiry: UpdateInquiry_updateInquiry | null;
}

export interface UpdateInquiryVariables {
  inquiryArgs: InquiryInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateNaccsIda
// ====================================================

export interface updateNaccsIda_updateNaccsIda_consignee_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateNaccsIda_updateNaccsIda_consignee_address_country {
  id: string;
  nameTranslations: updateNaccsIda_updateNaccsIda_consignee_address_country_nameTranslations;
  unLocode: string;
}

export interface updateNaccsIda_updateNaccsIda_consignee_address {
  city: string | null;
  country: updateNaccsIda_updateNaccsIda_consignee_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateNaccsIda_updateNaccsIda_consignee {
  address: updateNaccsIda_updateNaccsIda_consignee_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface updateNaccsIda_updateNaccsIda_importCertificates {
  code: string | null;
  number: string | null;
}

export interface updateNaccsIda_updateNaccsIda_shipper_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface updateNaccsIda_updateNaccsIda_shipper_address_country {
  id: string;
  nameTranslations: updateNaccsIda_updateNaccsIda_shipper_address_country_nameTranslations;
  unLocode: string;
}

export interface updateNaccsIda_updateNaccsIda_shipper_address {
  city: string | null;
  country: updateNaccsIda_updateNaccsIda_shipper_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface updateNaccsIda_updateNaccsIda_shipper {
  address: updateNaccsIda_updateNaccsIda_shipper_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface updateNaccsIda_updateNaccsIda {
  awbNumber: string | null;
  blNumber: string[] | null;
  bondedArea: string | null;
  consignee: updateNaccsIda_updateNaccsIda_consignee | null;
  customsApplicationDate: any | null;
  declarationType: NaccsDeclarationTypeEnum | null;
  depositPaymentNumber: string | null;
  dueDateExtensionType: NaccsDueDateExtensionTypeEnum | null;
  evaluation: NaccsEvaluationEnum | null;
  existingAssessmentNumbers: string[] | null;
  incoterms: IncotermsTypeEnum | null;
  importCertificates: updateNaccsIda_updateNaccsIda_importCertificates[] | null;
  insuranceCoverage: string | null;
  insuranceCurrency: string | null;
  insurancePrice: string | null;
  insuranceType: NaccsInsuranceTypeEnum | null;
  invoiceCurrency: string | null;
  invoiceNumber: string | null;
  invoicePrice: string | null;
  invoiceType: NaccsInvoiceTypeEnum | null;
  mawbNumber: string | null;
  otherRegulations: NaccsImportRegulationCodeEnum[] | null;
  paymentMethod: NaccsPaymentMethodEnum | null;
  realTimeBankAccount: string | null;
  remarkFromShipper: string | null;
  shipper: updateNaccsIda_updateNaccsIda_shipper | null;
  shipperConsigneeStandardCode: string | null;
  shipperReferenceNumber: string | null;
  shipperSectionCode: string | null;
  tradingType: number | null;
}

export interface updateNaccsIda {
  /**
   * Update Naccs IDA
   */
  updateNaccsIda: updateNaccsIda_updateNaccsIda | null;
}

export interface updateNaccsIdaVariables {
  shipmentId: string;
  data: NaccsIdaInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateProduct
// ====================================================

export interface updateProduct_updateProduct_attachments_uploader {
  name: string | null;
}

export interface updateProduct_updateProduct_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: updateProduct_updateProduct_attachments_uploader | null;
  url: string | null;
}

export interface updateProduct_updateProduct_hsCodes {
  code: string | null;
  country: string | null;
}

export interface updateProduct_updateProduct {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: updateProduct_updateProduct_attachments[] | null;
  hsCodes: updateProduct_updateProduct_hsCodes[] | null;
}

export interface updateProduct {
  /**
   * Find a product entry matching the inputs and update it
   */
  updateProduct: updateProduct_updateProduct | null;
}

export interface updateProductVariables {
  productArgs: ProductInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateTask
// ====================================================

export interface updateTask_updateTask_assignee_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface updateTask_updateTask_assignee {
  id: string;
  name: string;
  assigneeType: TaskAssigneeTypeEnum;
  avatar: updateTask_updateTask_assignee_avatar | null;
}

export interface updateTask_updateTask_customerOrganization {
  id: string;
  name: string;
}

export interface updateTask_updateTask {
  assignee: updateTask_updateTask_assignee | null;
  customerOrganization: updateTask_updateTask_customerOrganization;
  deadlineDate: any | null;
  description: string | null;
  doneAt: any | null;
  id: string;
  isPublic: boolean;
  reminderDate: any | null;
  responsibleParty: string;
  shipmentId: string;
  shipmentReference: string;
  shipmentType: string;
  title: string;
}

export interface updateTask {
  /**
   * Update a single tasks
   */
  updateTask: updateTask_updateTask | null;
}

export interface updateTaskVariables {
  taskId: string;
  taskArgs: TaskUpdateInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertBankAccount
// ====================================================

export interface upsertBankAccount_upsertBankAccount {
  accountName: string | null;
  accountNumber: string | null;
  accountType: BankAccountTypeEnum | null;
  bankAddress: string | null;
  bankCode: string | null;
  bankName: string | null;
  branchCode: string | null;
  branchName: string | null;
  customerOrganizationId: string;
  id: string;
  realTime: boolean;
  swiftCode: string | null;
}

export interface upsertBankAccount {
  upsertBankAccount: upsertBankAccount_upsertBankAccount | null;
}

export interface upsertBankAccountVariables {
  id?: string | null;
  data: BankAccountInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertCustomerLocation
// ====================================================

export interface upsertCustomerLocation_upsertCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface upsertCustomerLocation_upsertCustomerLocation_country {
  id: string;
  nameTranslations: upsertCustomerLocation_upsertCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface upsertCustomerLocation_upsertCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface upsertCustomerLocation_upsertCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: upsertCustomerLocation_upsertCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: upsertCustomerLocation_upsertCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface upsertCustomerLocation {
  upsertCustomerLocation: upsertCustomerLocation_upsertCustomerLocation | null;
}

export interface upsertCustomerLocationVariables {
  id?: string | null;
  data: CustomerLocationInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertQuote
// ====================================================

export interface upsertQuote_upsertQuote_details_extra_billItems_partner {
  id: string;
  code: string;
}

export interface upsertQuote_upsertQuote_details_extra_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: upsertQuote_upsertQuote_details_extra_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface upsertQuote_upsertQuote_details_extra {
  billItems: upsertQuote_upsertQuote_details_extra_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface upsertQuote_upsertQuote_details_arrivalDrayage_billItems_partner {
  id: string;
  code: string;
}

export interface upsertQuote_upsertQuote_details_arrivalDrayage_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: upsertQuote_upsertQuote_details_arrivalDrayage_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface upsertQuote_upsertQuote_details_arrivalDrayage {
  billItems: upsertQuote_upsertQuote_details_arrivalDrayage_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface upsertQuote_upsertQuote_details_arrivalTrucking_billItems_partner {
  id: string;
  code: string;
}

export interface upsertQuote_upsertQuote_details_arrivalTrucking_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: upsertQuote_upsertQuote_details_arrivalTrucking_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface upsertQuote_upsertQuote_details_arrivalTrucking {
  billItems: upsertQuote_upsertQuote_details_arrivalTrucking_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface upsertQuote_upsertQuote_details_departureDrayage_billItems_partner {
  id: string;
  code: string;
}

export interface upsertQuote_upsertQuote_details_departureDrayage_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: upsertQuote_upsertQuote_details_departureDrayage_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface upsertQuote_upsertQuote_details_departureDrayage {
  billItems: upsertQuote_upsertQuote_details_departureDrayage_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface upsertQuote_upsertQuote_details_departureTrucking_billItems_partner {
  id: string;
  code: string;
}

export interface upsertQuote_upsertQuote_details_departureTrucking_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: upsertQuote_upsertQuote_details_departureTrucking_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface upsertQuote_upsertQuote_details_departureTrucking {
  billItems: upsertQuote_upsertQuote_details_departureTrucking_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface upsertQuote_upsertQuote_details_transport_billItems_partner {
  id: string;
  code: string;
}

export interface upsertQuote_upsertQuote_details_transport_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: upsertQuote_upsertQuote_details_transport_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface upsertQuote_upsertQuote_details_transport {
  billItems: upsertQuote_upsertQuote_details_transport_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface upsertQuote_upsertQuote_details {
  extra: upsertQuote_upsertQuote_details_extra;
  arrivalDrayage: upsertQuote_upsertQuote_details_arrivalDrayage;
  arrivalTrucking: upsertQuote_upsertQuote_details_arrivalTrucking;
  departureDrayage: upsertQuote_upsertQuote_details_departureDrayage;
  departureTrucking: upsertQuote_upsertQuote_details_departureTrucking;
  transport: upsertQuote_upsertQuote_details_transport;
}

export interface upsertQuote_upsertQuote_inquiry_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: upsertQuote_upsertQuote_inquiry_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface upsertQuote_upsertQuote_inquiry_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: upsertQuote_upsertQuote_inquiry_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: upsertQuote_upsertQuote_inquiry_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_assignedOperator {
  avatar: upsertQuote_upsertQuote_inquiry_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_attachments_uploader {
  name: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: upsertQuote_upsertQuote_inquiry_attachments_uploader | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_billItems_partner {
  id: string;
  code: string;
}

export interface upsertQuote_upsertQuote_inquiry_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: upsertQuote_upsertQuote_inquiry_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface upsertQuote_upsertQuote_inquiry_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: upsertQuote_upsertQuote_inquiry_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: upsertQuote_upsertQuote_inquiry_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: upsertQuote_upsertQuote_inquiry_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: upsertQuote_upsertQuote_inquiry_cargoDescription_departureOptions_vanningInformations | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: upsertQuote_upsertQuote_inquiry_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: upsertQuote_upsertQuote_inquiry_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: upsertQuote_upsertQuote_inquiry_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: upsertQuote_upsertQuote_inquiry_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_cargoDescription {
  arrivalOptions: upsertQuote_upsertQuote_inquiry_cargoDescription_arrivalOptions | null;
  containers: upsertQuote_upsertQuote_inquiry_cargoDescription_containers[] | null;
  departureOptions: upsertQuote_upsertQuote_inquiry_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: upsertQuote_upsertQuote_inquiry_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_channelMessages_channel {
  id: string;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: upsertQuote_upsertQuote_inquiry_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_channelMessages_sender {
  avatar: upsertQuote_upsertQuote_inquiry_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_channelMessages {
  channel: upsertQuote_upsertQuote_inquiry_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: upsertQuote_upsertQuote_inquiry_channelList_channelMessages_file | null;
  id: string;
  sender: upsertQuote_upsertQuote_inquiry_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_lastMessage_channel {
  id: string;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: upsertQuote_upsertQuote_inquiry_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_lastMessage_sender {
  avatar: upsertQuote_upsertQuote_inquiry_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_lastMessage {
  channel: upsertQuote_upsertQuote_inquiry_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: upsertQuote_upsertQuote_inquiry_channelList_lastMessage_file | null;
  id: string;
  sender: upsertQuote_upsertQuote_inquiry_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface upsertQuote_upsertQuote_inquiry_channelList_partnerMembers {
  id: string;
  partner: upsertQuote_upsertQuote_inquiry_channelList_partnerMembers_partner;
}

export interface upsertQuote_upsertQuote_inquiry_channelList {
  channelMessages: upsertQuote_upsertQuote_inquiry_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: upsertQuote_upsertQuote_inquiry_channelList_lastMessage | null;
  partnerMembers: upsertQuote_upsertQuote_inquiry_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface upsertQuote_upsertQuote_inquiry_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_customerOrganization_address_country {
  id: string;
  nameTranslations: upsertQuote_upsertQuote_inquiry_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface upsertQuote_upsertQuote_inquiry_customerOrganization_address {
  city: string | null;
  country: upsertQuote_upsertQuote_inquiry_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_customerOrganization {
  address: upsertQuote_upsertQuote_inquiry_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: upsertQuote_upsertQuote_inquiry_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_departureCustomerLocation_country {
  id: string;
  nameTranslations: upsertQuote_upsertQuote_inquiry_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface upsertQuote_upsertQuote_inquiry_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: upsertQuote_upsertQuote_inquiry_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: upsertQuote_upsertQuote_inquiry_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_followers {
  id: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_channel {
  id: string;
}

export interface upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_file_uploader {
  name: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_file_uploader | null;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_sender {
  avatar: upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage {
  channel: upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_file | null;
  id: string;
  sender: upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage_sender;
  shipmentId: string;
}

export interface upsertQuote_upsertQuote_inquiry_truckingDetails {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface upsertQuote_upsertQuote_inquiry {
  arrivalAddress: upsertQuote_upsertQuote_inquiry_arrivalAddress | null;
  arrivalCustomerLocation: upsertQuote_upsertQuote_inquiry_arrivalCustomerLocation | null;
  arrivalPlace: upsertQuote_upsertQuote_inquiry_arrivalPlace | null;
  assignedOperator: upsertQuote_upsertQuote_inquiry_assignedOperator | null;
  attachments: upsertQuote_upsertQuote_inquiry_attachments[] | null;
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: upsertQuote_upsertQuote_inquiry_billItems[] | null;
  blMetaData: upsertQuote_upsertQuote_inquiry_blMetaData | null;
  cargoDescription: upsertQuote_upsertQuote_inquiry_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoType: CargoTypeEnum | null;
  channelList: upsertQuote_upsertQuote_inquiry_channelList[];
  createdAt: any | null;
  customerOrganization: upsertQuote_upsertQuote_inquiry_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureAddress: upsertQuote_upsertQuote_inquiry_departureAddress | null;
  departureCustomerLocation: upsertQuote_upsertQuote_inquiry_departureCustomerLocation | null;
  departurePlace: upsertQuote_upsertQuote_inquiry_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  followers: upsertQuote_upsertQuote_inquiry_followers[];
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  isFirst: boolean | null;
  lastPublicChannelMessage: upsertQuote_upsertQuote_inquiry_lastPublicChannelMessage | null;
  organizationPaymentTerms: string | null;
  priority: number | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  quotedAt: any | null;
  reference: string | null;
  showTotal: boolean | null;
  status: InquiryStatusEnum;
  taxRate: number | null;
  transportationType: TransportationTypeEnum | null;
  truckingDetails: upsertQuote_upsertQuote_inquiry_truckingDetails | null;
  updatedAt: any | null;
  usdJpyExchangeRate: number | null;
}

export interface upsertQuote_upsertQuote {
  details: upsertQuote_upsertQuote_details;
  id: string;
  inquiry: upsertQuote_upsertQuote_inquiry;
  margin: number | null;
  totalCost: number;
  totalMargin: number;
}

export interface upsertQuote {
  /**
   * Upsert an automatic quote for an inquiry
   */
  upsertQuote: upsertQuote_upsertQuote | null;
}

export interface upsertQuoteVariables {
  shipmentId: string;
  quoteId?: string | null;
  inquiryArgs?: InquiryInput | null;
  extraBillItems?: BillItemInput[] | null;
  margin?: number | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertTasks
// ====================================================

export interface upsertTasks_upsertTasks_assignee_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface upsertTasks_upsertTasks_assignee {
  id: string;
  name: string;
  assigneeType: TaskAssigneeTypeEnum;
  avatar: upsertTasks_upsertTasks_assignee_avatar | null;
}

export interface upsertTasks_upsertTasks_customerOrganization {
  id: string;
  name: string;
}

export interface upsertTasks_upsertTasks {
  assignee: upsertTasks_upsertTasks_assignee | null;
  customerOrganization: upsertTasks_upsertTasks_customerOrganization;
  deadlineDate: any | null;
  description: string | null;
  doneAt: any | null;
  id: string;
  isPublic: boolean;
  reminderDate: any | null;
  responsibleParty: string;
  shipmentId: string;
  shipmentReference: string;
  shipmentType: string;
  title: string;
}

export interface upsertTasks {
  /**
   * Upsert tasks list for a shipment
   */
  upsertTasks: upsertTasks_upsertTasks[] | null;
}

export interface upsertTasksVariables {
  shipmentId: string;
  tasksArgs: TaskInput[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertVessel
// ====================================================

export interface upsertVessel_upsertVessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface upsertVessel {
  /**
   * Create or Update a Vessel
   */
  upsertVessel: upsertVessel_upsertVessel | null;
}

export interface upsertVesselVariables {
  vesselId?: string | null;
  vesselArgs: VesselInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchAttachments
// ====================================================

export interface fetchAttachments_attachments_uploader {
  name: string | null;
}

export interface fetchAttachments_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchAttachments_attachments_uploader | null;
  url: string | null;
}

export interface fetchAttachments {
  /**
   * List attachment related to a shipment
   */
  attachments: fetchAttachments_attachments[];
}

export interface fetchAttachmentsVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: accountList
// ====================================================

export interface accountList_bankAccounts {
  accountName: string | null;
  accountNumber: string | null;
  accountType: BankAccountTypeEnum | null;
  bankAddress: string | null;
  bankCode: string | null;
  bankName: string | null;
  branchCode: string | null;
  branchName: string | null;
  customerOrganizationId: string;
  id: string;
  realTime: boolean;
  swiftCode: string | null;
}

export interface accountList_bankAccountsPagination {
  totalCount: number;
}

export interface accountList {
  /**
   * Lists Bank Account
   */
  bankAccounts: accountList_bankAccounts[];
  /**
   * Pagination details
   */
  bankAccountsPagination: accountList_bankAccountsPagination;
}

export interface accountListVariables {
  customerOrganizationId: string;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipmentBillItems
// ====================================================

export interface fetchShipmentBillItems_shipments_billItems_bill {
  id: string;
}

export interface fetchShipmentBillItems_shipments_billItems_partner {
  id: string;
  code: string;
}

export interface fetchShipmentBillItems_shipments_billItems {
  bill: fetchShipmentBillItems_shipments_billItems_bill | null;
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchShipmentBillItems_shipments_billItems_partner | null;
  quantity: number | null;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchShipmentBillItems_shipments {
  billItems: fetchShipmentBillItems_shipments_billItems[] | null;
  usdJpyExchangeRate: number | null;
}

export interface fetchShipmentBillItems {
  /**
   * List shipments
   */
  shipments: fetchShipmentBillItems_shipments[];
}

export interface fetchShipmentBillItemsVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchChannelList
// ====================================================

export interface fetchChannelList_channels {
  channelType: ChannelTypeEnum;
  id: string;
}

export interface fetchChannelList {
  channels: fetchChannelList_channels[];
}

export interface fetchChannelListVariables {
  shipmentId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchChannels
// ====================================================

export interface fetchChannels_channels_channelMessages_channel {
  id: string;
}

export interface fetchChannels_channels_channelMessages_file_uploader {
  name: string | null;
}

export interface fetchChannels_channels_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchChannels_channels_channelMessages_file_uploader | null;
  url: string | null;
}

export interface fetchChannels_channels_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchChannels_channels_channelMessages_sender {
  avatar: fetchChannels_channels_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchChannels_channels_channelMessages {
  channel: fetchChannels_channels_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchChannels_channels_channelMessages_file | null;
  id: string;
  sender: fetchChannels_channels_channelMessages_sender;
  shipmentId: string;
}

export interface fetchChannels_channels_lastMessage_channel {
  id: string;
}

export interface fetchChannels_channels_lastMessage_file_uploader {
  name: string | null;
}

export interface fetchChannels_channels_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchChannels_channels_lastMessage_file_uploader | null;
  url: string | null;
}

export interface fetchChannels_channels_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchChannels_channels_lastMessage_sender {
  avatar: fetchChannels_channels_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchChannels_channels_lastMessage {
  channel: fetchChannels_channels_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchChannels_channels_lastMessage_file | null;
  id: string;
  sender: fetchChannels_channels_lastMessage_sender;
  shipmentId: string;
}

export interface fetchChannels_channels_partnerMembers_partner {
  id: string;
  name: string;
}

export interface fetchChannels_channels_partnerMembers {
  id: string;
  partner: fetchChannels_channels_partnerMembers_partner;
}

export interface fetchChannels_channels {
  channelMessages: fetchChannels_channels_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: fetchChannels_channels_lastMessage | null;
  partnerMembers: fetchChannels_channels_partnerMembers[] | null;
  shipmentId: string;
}

export interface fetchChannels {
  channels: fetchChannels_channels[];
}

export interface fetchChannelsVariables {
  channelId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchChannelsWithInquiry
// ====================================================

export interface fetchChannelsWithInquiry_inquiries_customerOrganization {
  id: string;
  name: string;
}

export interface fetchChannelsWithInquiry_inquiries_channelList_channelMessages_channel {
  id: string;
}

export interface fetchChannelsWithInquiry_inquiries_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface fetchChannelsWithInquiry_inquiries_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchChannelsWithInquiry_inquiries_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface fetchChannelsWithInquiry_inquiries_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchChannelsWithInquiry_inquiries_channelList_channelMessages_sender {
  avatar: fetchChannelsWithInquiry_inquiries_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchChannelsWithInquiry_inquiries_channelList_channelMessages {
  channel: fetchChannelsWithInquiry_inquiries_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchChannelsWithInquiry_inquiries_channelList_channelMessages_file | null;
  id: string;
  sender: fetchChannelsWithInquiry_inquiries_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface fetchChannelsWithInquiry_inquiries_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface fetchChannelsWithInquiry_inquiries_channelList_partnerMembers {
  partner: fetchChannelsWithInquiry_inquiries_channelList_partnerMembers_partner;
}

export interface fetchChannelsWithInquiry_inquiries_channelList {
  id: string;
  channelType: ChannelTypeEnum;
  channelMessages: fetchChannelsWithInquiry_inquiries_channelList_channelMessages[];
  partnerMembers: fetchChannelsWithInquiry_inquiries_channelList_partnerMembers[] | null;
}

export interface fetchChannelsWithInquiry_inquiries {
  id: string;
  customerOrganization: fetchChannelsWithInquiry_inquiries_customerOrganization;
  channelList: fetchChannelsWithInquiry_inquiries_channelList[];
}

export interface fetchChannelsWithInquiry {
  /**
   * Lists all Inquiries for current shipper
   */
  inquiries: fetchChannelsWithInquiry_inquiries[];
}

export interface fetchChannelsWithInquiryVariables {
  inquiryArgs?: InquiryScopedInput | null;
  channelId?: string | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchCustomers
// ====================================================

export interface fetchCustomers_organizationStaff {
  id: string | null;
  name: string | null;
  status: string | null;
}

export interface fetchCustomers {
  /**
   * List Organization Staffs
   */
  organizationStaff: fetchCustomers_organizationStaff[];
}

export interface fetchCustomersVariables {
  organizationArgs: CustomerOrganizationScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: searchAddress
// ====================================================

export interface searchAddress_customerLocations_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface searchAddress_customerLocations_country {
  id: string;
  nameTranslations: searchAddress_customerLocations_country_nameTranslations;
  unLocode: string;
}

export interface searchAddress_customerLocations_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface searchAddress_customerLocations {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: searchAddress_customerLocations_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: searchAddress_customerLocations_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface searchAddress_customerLocationsPagination {
  totalCount: number;
}

export interface searchAddress {
  /**
   * Lists Customer Locations 
   */
  customerLocations: searchAddress_customerLocations[];
  /**
   * Pagination details
   */
  customerLocationsPagination: searchAddress_customerLocationsPagination;
}

export interface searchAddressVariables {
  filters?: CustomerLocationFilterInput | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipmentDocument
// ====================================================

export interface fetchShipmentDocument_shipmentDocuments_data_billItems {
  id: string;
  category: string | null;
  description: string | null;
  displayCurrency: CurrencyEnum;
  quantity: number | null;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  unitPrice: number | null;
}

export interface fetchShipmentDocument_shipmentDocuments_data_containerNumbers {
  containerCount: number | null;
  containerNumber: string | null;
  containerType: ContainerSizeEnum | null;
  sealNumber: string | null;
}

export interface fetchShipmentDocument_shipmentDocuments_data_delegatedSteps {
  delegatedStep: string | null;
  taxType: TaxTypeEnumBase | null;
}

export interface fetchShipmentDocument_shipmentDocuments_data {
  airCarrier: string | null;
  arrangementRemarks: string | null;
  assignedOperator: string | null;
  attachedDocuments: AttachedDocumentEnum[] | null;
  billItems: fetchShipmentDocument_shipmentDocuments_data_billItems[] | null;
  blNumberOfOriginals: number | null;
  blPlaceOfIssuance: string | null;
  blType: BlTypeEnum | null;
  bookingNumber: string | null;
  cargoCollectionAddress: string | null;
  cargoCollectionContact: string | null;
  cargoPickupDatetime: any | null;
  cargoRemarks: string | null;
  freeTime: any | null;
  clientRemarks: string | null;
  collectionAddress: string | null;
  collectionContact: string | null;
  collectionContactInformation: string | null;
  collectionName: string | null;
  collectionPhone: string | null;
  collectionPreferredDatetime: any | null;
  consolidator: string | null;
  containerNumbers: fetchShipmentDocument_shipmentDocuments_data_containerNumbers[] | null;
  customerAddress: string | null;
  customerBankAccountNumber: string | null;
  customerCompanyNumber: string | null;
  /**
   * 包括 / 付保なし / 個別
   */
  customerInsurance: CustomerInsuranceEnum | null;
  customerInsuranceNumber: string | null;
  customerName: string | null;
  customerPostponementNumber: string | null;
  customerShipperConsigneeStandardCode: string | null;
  customsArrivalDate: any | null;
  customsClearanceDate: any | null;
  customsClearanceDesiredDate: any | null;
  customsLocation: string | null;
  customsPickupDate: any | null;
  cyCfsCutDate: any | null;
  /**
   * O - X
   */
  dangerous: boolean | null;
  declaredValue: string | null;
  delegatedSteps: fetchShipmentDocument_shipmentDocuments_data_delegatedSteps[] | null;
  deliveryLocation: string | null;
  deliveryPlaceRemarks: string | null;
  deliveryRemarks: string | null;
  descriptionOfGoods: string | null;
  /**
   * 希望する・希望しない
   */
  dispatchArrangements: boolean | null;
  dutyTaxPaymentMethod: DutyTaxPaymentMethodEnum | null;
  /**
   * 希望する・希望しない
   */
  emptyVanPickup: boolean | null;
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  /**
   * 希望する・希望しない
   */
  exportRegistration: boolean | null;
  finalCurrency: CurrencyEnum | null;
  finalDestination: string | null;
  finalRemarks: string | null;
  flightNumber: string | null;
  freightDeliveryAddress: string | null;
  freightDeliveryContact: string | null;
  freightDeliveryContactInformation: string | null;
  freightDeliveryDatetime: any | null;
  freightDeliveryName: string | null;
  freightRemarks: string | null;
  grossVolume: number | null;
  grossWeight: number | null;
  houseBlNumber: string | null;
  hsCode: string | null;
  importDestinationAddress: string | null;
  importDestinationPhone: string | null;
  issuanceDate: any | null;
  masterBlNumber: string | null;
  /**
   * O - X
   */
  motorGenerator: boolean | null;
  /**
   * 希望する・希望しない
   */
  naccsAclDockReport: boolean | null;
  naccsCode: string | null;
  /**
   * 希望する・希望しない
   */
  naccsHdl: boolean | null;
  /**
   * free text / なし
   */
  otherLaws: string | null;
  packagingQuantity: number | null;
  packaging: string | null;
  pickupDate: any | null;
  pickupPlaceRemarks: string | null;
  pickupRemarks: string | null;
  placeOfDelivery: string | null;
  placeOfReceipt: string | null;
  portOfDischarge: string | null;
  portOfLoading: string | null;
  preCarriageBy: string | null;
  /**
   * O - X
   */
  preCooling: boolean | null;
  /**
   * 希望する・希望しない
   */
  preliminaryFilings: boolean | null;
  presetTemperature: string | null;
  priceCategorization: PriceCategorization | null;
  /**
   * O - X
   */
  proofOfOrigin: boolean | null;
  quantityOfContainers: number | null;
  remarks: string | null;
  /**
   * X / Free Text
   */
  requiresWarehouseWork: string | null;
  seaCarrier: string | null;
  shipmentAlsoNotifyName: string | null;
  shipmentAlsoNotifyAddress: string | null;
  shipmentAlsoNotifyEmail: string | null;
  shipmentAlsoNotifyPhone: string | null;
  shipmentConsigneeAccountNumber: string | null;
  shipmentConsigneeAddress: string | null;
  shipmentConsigneeEmail: string | null;
  shipmentConsigneeName: string | null;
  shipmentConsigneePhone: string | null;
  shipmentCustomerRole: CustomerRoleEnum | null;
  shipmentDeliveryAgentAccountNumber: string | null;
  shipmentDeliveryAgentAddress: string | null;
  shipmentDeliveryAgentEmail: string | null;
  shipmentDeliveryAgentName: string | null;
  shipmentDeliveryAgentPhone: string | null;
  shipmentExchangeRate: number | null;
  shipmentIncoterms: IncotermsTypeEnum | null;
  shipmentInvoiceNumber: string | null;
  shipmentNotifyAccountNumber: string | null;
  shipmentNotifyAddress: string | null;
  shipmentNotifyEmail: string | null;
  shipmentNotifyName: string | null;
  shipmentNotifyPhone: string | null;
  shipmentPaymentPlace: string | null;
  shipmentPaymentTerms: PaymentTermsTypeEnum | null;
  shipmentReference: string | null;
  shipmentShipperAccountNumber: string | null;
  shipmentShipperAddress: string | null;
  shipmentShipperEmail: string | null;
  shipmentShipperName: string | null;
  shipmentShipperPhone: string | null;
  /**
   * 希望する・希望しない
   */
  shippingCompanyChargeAdvance: boolean | null;
  shippingMarks: string | null;
  shippingPlaceRemarks: string | null;
  shippingRemarks: string | null;
  /**
   * 免税・課税
   */
  taxType: TaxTypeEnumBase | null;
  transportCargoType: TransportationCargoTypeEnum | null;
  transportationType: TransportationTypeEnum | null;
  truckChassisType: AxleTypeEnum | null;
  truckType: TruckTypeEnum | null;
  vanningLocation: string | null;
  vanningLocationAddress: string | null;
  ventilation: string | null;
  vesselName: string | null;
  voyageNumber: string | null;
  /**
   * O - X
   */
  weightCalibration: boolean | null;
}

export interface fetchShipmentDocument_shipmentDocuments_shipment_customerOrganization {
  id: string;
}

export interface fetchShipmentDocument_shipmentDocuments_shipment {
  customerOrganization: fetchShipmentDocument_shipmentDocuments_shipment_customerOrganization;
  id: string;
  transportationType: TransportationTypeEnum | null;
}

export interface fetchShipmentDocument_shipmentDocuments {
  data: fetchShipmentDocument_shipmentDocuments_data;
  documentType: DocumentTypeEnum;
  id: string;
  shipment: fetchShipmentDocument_shipmentDocuments_shipment;
  title: string | null;
  updatedAt: any;
  url: string;
}

export interface fetchShipmentDocument {
  /**
   * List shipment_documents related to a shipment
   */
  shipmentDocuments: fetchShipmentDocument_shipmentDocuments[];
}

export interface fetchShipmentDocumentVariables {
  shipmentId: string;
  documentId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipmentDocuments
// ====================================================

export interface fetchShipmentDocuments_shipmentDocuments {
  documentType: DocumentTypeEnum;
  id: string;
  title: string | null;
  updatedAt: any;
  url: string;
}

export interface fetchShipmentDocuments {
  /**
   * List shipment_documents related to a shipment
   */
  shipmentDocuments: fetchShipmentDocuments_shipmentDocuments[];
}

export interface fetchShipmentDocumentsVariables {
  shipmentId: string;
  documentId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchBill
// ====================================================

export interface fetchBill_bills_billItems {
  id: string;
}

export interface fetchBill_bills_customerOrganization {
  id: string;
  name: string;
}

export interface fetchBill_bills_pdfFile_uploader {
  name: string | null;
}

export interface fetchBill_bills_pdfFile {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchBill_bills_pdfFile_uploader | null;
  url: string | null;
}

export interface fetchBill_bills_shipments {
  billItemTotal: number | null;
  customerReference: string | null;
  id: string;
  quoteAcceptedAt: any | null;
  reference: string | null;
}

export interface fetchBill_bills {
  billItems: fetchBill_bills_billItems[] | null;
  companyName: string | null;
  customerOrganization: fetchBill_bills_customerOrganization | null;
  dueDate: any | null;
  id: string;
  issueDate: any | null;
  reference: string | null;
  remark: string | null;
  language: AvailableLocalesEnum | null;
  pdfFile: fetchBill_bills_pdfFile | null;
  shipments: fetchBill_bills_shipments[] | null;
  status: BillStatusEnum | null;
}

export interface fetchBill {
  /**
   * Lists all Bills
   */
  bills: fetchBill_bills[];
}

export interface fetchBillVariables {
  billArgs: BillScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchBillItemTemplates
// ====================================================

export interface fetchBillItemTemplates_billItemTemplates {
  category: string | null;
  description: string | null;
  id: string;
  taxType: TaxTypeEnum;
}

export interface fetchBillItemTemplates_billItemTemplatesPagination {
  totalCount: number;
}

export interface fetchBillItemTemplates {
  /**
   * Search for bill item templates
   */
  billItemTemplates: fetchBillItemTemplates_billItemTemplates[] | null;
  /**
   * Pagination details
   */
  billItemTemplatesPagination: fetchBillItemTemplates_billItemTemplatesPagination;
}

export interface fetchBillItemTemplatesVariables {
  searchString?: string | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: carriers
// ====================================================

export interface carriers_carriers {
  id: string;
  carrierType: CarrierTypeEnum;
  naccsCode: string;
  name: string | null;
}

export interface carriers {
  /**
   * Lists Carriers
   */
  carriers: carriers_carriers[];
}

export interface carriersVariables {
  filter?: CarrierScopedInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchContacts
// ====================================================

export interface fetchContacts_contacts_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchContacts_contacts_address_country {
  id: string;
  nameTranslations: fetchContacts_contacts_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchContacts_contacts_address {
  city: string | null;
  country: fetchContacts_contacts_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchContacts_contacts_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchContacts_contacts_country {
  id: string;
  nameTranslations: fetchContacts_contacts_country_nameTranslations;
  unLocode: string;
}

export interface fetchContacts_contacts_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchContacts_contacts_customerOrganization_address_country {
  id: string;
  nameTranslations: fetchContacts_contacts_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchContacts_contacts_customerOrganization_address {
  city: string | null;
  country: fetchContacts_contacts_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchContacts_contacts_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchContacts_contacts_customerOrganization {
  address: fetchContacts_contacts_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: fetchContacts_contacts_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface fetchContacts_contacts {
  address: fetchContacts_contacts_address | null;
  country: fetchContacts_contacts_country | null;
  customerOrganization: fetchContacts_contacts_customerOrganization;
  email: string | null;
  faxNumber: string | null;
  id: string;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
}

export interface fetchContacts_contactsPagination {
  totalCount: number;
}

export interface fetchContacts {
  /**
   * List Contacts
   */
  contacts: fetchContacts_contacts[];
  /**
   * Pagination details
   */
  contactsPagination: fetchContacts_contactsPagination;
}

export interface fetchContactsVariables {
  contactArgs?: ContactScopedInput | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchCopyOfInquiry
// ====================================================

export interface fetchCopyOfInquiry_inquiries_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchCopyOfInquiry_inquiries_arrivalPlace {
  id: string;
  code: string | null;
  name: string | null;
  normalizedName: string | null;
  region: string | null;
  countryCode: string | null;
  placeType: PortTypeEnum | null;
}

export interface fetchCopyOfInquiry_inquiries_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface fetchCopyOfInquiry_inquiries_cargoDescription_parcels {
  packagingType: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  netWeight: number | null;
  grossWeight: number | null;
  weightUnit: string | null;
  quantity: number | null;
  description: string | null;
}

export interface fetchCopyOfInquiry_inquiries_cargoDescription {
  containers: fetchCopyOfInquiry_inquiries_cargoDescription_containers[] | null;
  parcels: fetchCopyOfInquiry_inquiries_cargoDescription_parcels[] | null;
  description: string | null;
}

export interface fetchCopyOfInquiry_inquiries_customerOrganization {
  id: string;
  name: string;
}

export interface fetchCopyOfInquiry_inquiries_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchCopyOfInquiry_inquiries_departurePlace {
  id: string;
  code: string | null;
  name: string | null;
  normalizedName: string | null;
  region: string | null;
  countryCode: string | null;
  placeType: PortTypeEnum | null;
}

export interface fetchCopyOfInquiry_inquiries {
  arrivalCustomerLocation: fetchCopyOfInquiry_inquiries_arrivalCustomerLocation | null;
  arrivalPlace: fetchCopyOfInquiry_inquiries_arrivalPlace | null;
  cargoDescription: fetchCopyOfInquiry_inquiries_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoType: CargoTypeEnum | null;
  customerOrganization: fetchCopyOfInquiry_inquiries_customerOrganization;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureCustomerLocation: fetchCopyOfInquiry_inquiries_departureCustomerLocation | null;
  departurePlace: fetchCopyOfInquiry_inquiries_departurePlace | null;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  reference: string | null;
  transportationType: TransportationTypeEnum | null;
}

export interface fetchCopyOfInquiry {
  /**
   * Lists all Inquiries for current shipper
   */
  inquiries: fetchCopyOfInquiry_inquiries[];
}

export interface fetchCopyOfInquiryVariables {
  inquiryArgs?: InquiryScopedInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: searchCountries
// ====================================================

export interface searchCountries_countries_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface searchCountries_countries {
  id: string;
  nameTranslations: searchCountries_countries_nameTranslations;
  unLocode: string;
}

export interface searchCountries {
  /**
   * List UN recognized countries
   */
  countries: searchCountries_countries[];
}

export interface searchCountriesVariables {
  countryArgs: CountryScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchCustomerContact
// ====================================================

export interface fetchCustomerContact_contacts_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchCustomerContact_contacts_address_country {
  id: string;
  nameTranslations: fetchCustomerContact_contacts_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchCustomerContact_contacts_address {
  city: string | null;
  country: fetchCustomerContact_contacts_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchCustomerContact_contacts_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchCustomerContact_contacts_country {
  id: string;
  nameTranslations: fetchCustomerContact_contacts_country_nameTranslations;
  unLocode: string;
}

export interface fetchCustomerContact_contacts_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchCustomerContact_contacts_customerOrganization_address_country {
  id: string;
  nameTranslations: fetchCustomerContact_contacts_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchCustomerContact_contacts_customerOrganization_address {
  city: string | null;
  country: fetchCustomerContact_contacts_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchCustomerContact_contacts_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchCustomerContact_contacts_customerOrganization {
  address: fetchCustomerContact_contacts_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: fetchCustomerContact_contacts_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface fetchCustomerContact_contacts {
  address: fetchCustomerContact_contacts_address | null;
  country: fetchCustomerContact_contacts_country | null;
  customerOrganization: fetchCustomerContact_contacts_customerOrganization;
  email: string | null;
  faxNumber: string | null;
  id: string;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
}

export interface fetchCustomerContact {
  /**
   * List Contacts
   */
  contacts: fetchCustomerContact_contacts[];
}

export interface fetchCustomerContactVariables {
  contactArgs?: ContactScopedInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchCustomerLocations
// ====================================================

export interface fetchCustomerLocations_customerLocations_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchCustomerLocations_customerLocations_country {
  id: string;
  nameTranslations: fetchCustomerLocations_customerLocations_country_nameTranslations;
  unLocode: string;
}

export interface fetchCustomerLocations_customerLocations_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchCustomerLocations_customerLocations {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchCustomerLocations_customerLocations_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchCustomerLocations_customerLocations_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchCustomerLocations {
  /**
   * Lists Customer Locations 
   */
  customerLocations: fetchCustomerLocations_customerLocations[];
}

export interface fetchCustomerLocationsVariables {
  filters?: CustomerLocationFilterInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchCustomerOrganizations
// ====================================================

export interface fetchCustomerOrganizations_customerOrganizations_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchCustomerOrganizations_customerOrganizations_address_country {
  id: string;
  nameTranslations: fetchCustomerOrganizations_customerOrganizations_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchCustomerOrganizations_customerOrganizations_address {
  city: string | null;
  country: fetchCustomerOrganizations_customerOrganizations_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchCustomerOrganizations_customerOrganizations_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchCustomerOrganizations_customerOrganizations {
  address: fetchCustomerOrganizations_customerOrganizations_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: fetchCustomerOrganizations_customerOrganizations_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface fetchCustomerOrganizations_customerOrganizationsPagination {
  totalCount: number;
}

export interface fetchCustomerOrganizations {
  /**
   * Search a CustomerOrganizations
   */
  customerOrganizations: fetchCustomerOrganizations_customerOrganizations[];
  /**
   * Pagination details
   */
  customerOrganizationsPagination: fetchCustomerOrganizations_customerOrganizationsPagination;
}

export interface fetchCustomerOrganizationsVariables {
  customerOrganizationArgs: CustomerOrganizationScopedInput;
  pagination?: PaginationInput | null;
  filter?: CustomerOrganizationFilterEnum | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchInquiry
// ====================================================

export interface fetchInquiry_inquiries_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchInquiry_inquiries_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: fetchInquiry_inquiries_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchInquiry_inquiries_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchInquiry_inquiries_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchInquiry_inquiries_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchInquiry_inquiries_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchInquiry_inquiries_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchInquiry_inquiries_assignedOperator {
  avatar: fetchInquiry_inquiries_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface fetchInquiry_inquiries_attachments_uploader {
  name: string | null;
}

export interface fetchInquiry_inquiries_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchInquiry_inquiries_attachments_uploader | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_billItems_partner {
  id: string;
  code: string;
}

export interface fetchInquiry_inquiries_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchInquiry_inquiries_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchInquiry_inquiries_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface fetchInquiry_inquiries_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface fetchInquiry_inquiries_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface fetchInquiry_inquiries_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: fetchInquiry_inquiries_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: fetchInquiry_inquiries_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface fetchInquiry_inquiries_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface fetchInquiry_inquiries_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface fetchInquiry_inquiries_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface fetchInquiry_inquiries_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: fetchInquiry_inquiries_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: fetchInquiry_inquiries_cargoDescription_departureOptions_vanningInformations | null;
}

export interface fetchInquiry_inquiries_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface fetchInquiry_inquiries_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchInquiry_inquiries_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface fetchInquiry_inquiries_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: fetchInquiry_inquiries_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: fetchInquiry_inquiries_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface fetchInquiry_inquiries_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: fetchInquiry_inquiries_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface fetchInquiry_inquiries_cargoDescription {
  arrivalOptions: fetchInquiry_inquiries_cargoDescription_arrivalOptions | null;
  containers: fetchInquiry_inquiries_cargoDescription_containers[] | null;
  departureOptions: fetchInquiry_inquiries_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: fetchInquiry_inquiries_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface fetchInquiry_inquiries_channelList_channelMessages_channel {
  id: string;
}

export interface fetchInquiry_inquiries_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface fetchInquiry_inquiries_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchInquiry_inquiries_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchInquiry_inquiries_channelList_channelMessages_sender {
  avatar: fetchInquiry_inquiries_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchInquiry_inquiries_channelList_channelMessages {
  channel: fetchInquiry_inquiries_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchInquiry_inquiries_channelList_channelMessages_file | null;
  id: string;
  sender: fetchInquiry_inquiries_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface fetchInquiry_inquiries_channelList_lastMessage_channel {
  id: string;
}

export interface fetchInquiry_inquiries_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface fetchInquiry_inquiries_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchInquiry_inquiries_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchInquiry_inquiries_channelList_lastMessage_sender {
  avatar: fetchInquiry_inquiries_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchInquiry_inquiries_channelList_lastMessage {
  channel: fetchInquiry_inquiries_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchInquiry_inquiries_channelList_lastMessage_file | null;
  id: string;
  sender: fetchInquiry_inquiries_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface fetchInquiry_inquiries_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface fetchInquiry_inquiries_channelList_partnerMembers {
  id: string;
  partner: fetchInquiry_inquiries_channelList_partnerMembers_partner;
}

export interface fetchInquiry_inquiries_channelList {
  channelMessages: fetchInquiry_inquiries_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: fetchInquiry_inquiries_channelList_lastMessage | null;
  partnerMembers: fetchInquiry_inquiries_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface fetchInquiry_inquiries_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchInquiry_inquiries_customerOrganization_address_country {
  id: string;
  nameTranslations: fetchInquiry_inquiries_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchInquiry_inquiries_customerOrganization_address {
  city: string | null;
  country: fetchInquiry_inquiries_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchInquiry_inquiries_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchInquiry_inquiries_customerOrganization {
  address: fetchInquiry_inquiries_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: fetchInquiry_inquiries_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchInquiry_inquiries_departureCustomerLocation_country {
  id: string;
  nameTranslations: fetchInquiry_inquiries_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchInquiry_inquiries_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchInquiry_inquiries_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchInquiry_inquiries_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchInquiry_inquiries_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchInquiry_inquiries_followers {
  id: string | null;
}

export interface fetchInquiry_inquiries_lastPublicChannelMessage_channel {
  id: string;
}

export interface fetchInquiry_inquiries_lastPublicChannelMessage_file_uploader {
  name: string | null;
}

export interface fetchInquiry_inquiries_lastPublicChannelMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchInquiry_inquiries_lastPublicChannelMessage_file_uploader | null;
  url: string | null;
}

export interface fetchInquiry_inquiries_lastPublicChannelMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchInquiry_inquiries_lastPublicChannelMessage_sender {
  avatar: fetchInquiry_inquiries_lastPublicChannelMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchInquiry_inquiries_lastPublicChannelMessage {
  channel: fetchInquiry_inquiries_lastPublicChannelMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchInquiry_inquiries_lastPublicChannelMessage_file | null;
  id: string;
  sender: fetchInquiry_inquiries_lastPublicChannelMessage_sender;
  shipmentId: string;
}

export interface fetchInquiry_inquiries_truckingDetails {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface fetchInquiry_inquiries {
  arrivalAddress: fetchInquiry_inquiries_arrivalAddress | null;
  arrivalCustomerLocation: fetchInquiry_inquiries_arrivalCustomerLocation | null;
  arrivalPlace: fetchInquiry_inquiries_arrivalPlace | null;
  assignedOperator: fetchInquiry_inquiries_assignedOperator | null;
  attachments: fetchInquiry_inquiries_attachments[] | null;
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: fetchInquiry_inquiries_billItems[] | null;
  blMetaData: fetchInquiry_inquiries_blMetaData | null;
  cargoDescription: fetchInquiry_inquiries_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoType: CargoTypeEnum | null;
  channelList: fetchInquiry_inquiries_channelList[];
  createdAt: any | null;
  customerOrganization: fetchInquiry_inquiries_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureAddress: fetchInquiry_inquiries_departureAddress | null;
  departureCustomerLocation: fetchInquiry_inquiries_departureCustomerLocation | null;
  departurePlace: fetchInquiry_inquiries_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  followers: fetchInquiry_inquiries_followers[];
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  isFirst: boolean | null;
  lastPublicChannelMessage: fetchInquiry_inquiries_lastPublicChannelMessage | null;
  organizationPaymentTerms: string | null;
  priority: number | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  quotedAt: any | null;
  reference: string | null;
  showTotal: boolean | null;
  status: InquiryStatusEnum;
  taxRate: number | null;
  transportationType: TransportationTypeEnum | null;
  truckingDetails: fetchInquiry_inquiries_truckingDetails | null;
  updatedAt: any | null;
  usdJpyExchangeRate: number | null;
}

export interface fetchInquiry {
  /**
   * Lists all Inquiries for current shipper
   */
  inquiries: fetchInquiry_inquiries[];
}

export interface fetchInquiryVariables {
  inquiryArgs: InquiryScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchNotifications
// ====================================================

export interface fetchNotifications_notifications_subject {
  id: string;
  subjectType: string;
  shipmentId: string | null;
  shipmentStatus: string | null;
}

export interface fetchNotifications_notifications {
  id: string;
  content: string | null;
  createdAt: any | null;
  notificationType: string;
  status: NotificationStatusEnum;
  subject: fetchNotifications_notifications_subject | null;
}

export interface fetchNotifications {
  /**
   * Lists all notification for current user
   */
  notifications: fetchNotifications_notifications[];
}

export interface fetchNotificationsVariables {
  notificationArgs?: NotificationInput | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: searchOperators
// ====================================================

export interface searchOperators_operators_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface searchOperators_operators {
  avatar: searchOperators_operators_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface searchOperators {
  /**
   * List Operators
   */
  operators: searchOperators_operators[];
}

export interface searchOperatorsVariables {
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: organizationStaff
// ====================================================

export interface organizationStaff_organizationStaff {
  email: string | null;
  emailNotifications: boolean;
  id: string | null;
  language: AvailableLocalesEnum | null;
  name: string | null;
  phoneNumber: string | null;
  status: string | null;
  lastActiveAt: any | null;
}

export interface organizationStaff_organizationStaffPagination {
  totalCount: number;
}

export interface organizationStaff {
  /**
   * List Organization Staffs
   */
  organizationStaff: organizationStaff_organizationStaff[];
  /**
   * Pagination details
   */
  organizationStaffPagination: organizationStaff_organizationStaffPagination;
}

export interface organizationStaffVariables {
  organizationArgs: CustomerOrganizationScopedInput;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: searchPorts
// ====================================================

export interface searchPorts_places {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface searchPorts {
  /**
   * List all available places
   */
  places: searchPorts_places[];
}

export interface searchPortsVariables {
  nameSearch: string;
  placeType?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchProducts
// ====================================================

export interface fetchProducts_products_attachments_uploader {
  name: string | null;
}

export interface fetchProducts_products_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchProducts_products_attachments_uploader | null;
  url: string | null;
}

export interface fetchProducts_products_hsCodes {
  code: string | null;
  country: string | null;
}

export interface fetchProducts_products {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: fetchProducts_products_attachments[] | null;
  hsCodes: fetchProducts_products_hsCodes[] | null;
}

export interface fetchProducts_productsPagination {
  totalCount: number;
}

export interface fetchProducts {
  /**
   * List Products by customer
   */
  products: fetchProducts_products[];
  /**
   * Pagination details
   */
  productsPagination: fetchProducts_productsPagination;
}

export interface fetchProductsVariables {
  productArgs: ProductScopedInput;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchQuotes
// ====================================================

export interface fetchQuotes_inquiries_selectedQuote {
  id: string;
}

export interface fetchQuotes_inquiries_quotes_details_extra_billItems_partner {
  id: string;
  code: string;
}

export interface fetchQuotes_inquiries_quotes_details_extra_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchQuotes_inquiries_quotes_details_extra_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchQuotes_inquiries_quotes_details_extra {
  billItems: fetchQuotes_inquiries_quotes_details_extra_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_details_arrivalDrayage_billItems_partner {
  id: string;
  code: string;
}

export interface fetchQuotes_inquiries_quotes_details_arrivalDrayage_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchQuotes_inquiries_quotes_details_arrivalDrayage_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchQuotes_inquiries_quotes_details_arrivalDrayage {
  billItems: fetchQuotes_inquiries_quotes_details_arrivalDrayage_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_details_arrivalTrucking_billItems_partner {
  id: string;
  code: string;
}

export interface fetchQuotes_inquiries_quotes_details_arrivalTrucking_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchQuotes_inquiries_quotes_details_arrivalTrucking_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchQuotes_inquiries_quotes_details_arrivalTrucking {
  billItems: fetchQuotes_inquiries_quotes_details_arrivalTrucking_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_details_departureDrayage_billItems_partner {
  id: string;
  code: string;
}

export interface fetchQuotes_inquiries_quotes_details_departureDrayage_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchQuotes_inquiries_quotes_details_departureDrayage_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchQuotes_inquiries_quotes_details_departureDrayage {
  billItems: fetchQuotes_inquiries_quotes_details_departureDrayage_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_details_departureTrucking_billItems_partner {
  id: string;
  code: string;
}

export interface fetchQuotes_inquiries_quotes_details_departureTrucking_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchQuotes_inquiries_quotes_details_departureTrucking_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchQuotes_inquiries_quotes_details_departureTrucking {
  billItems: fetchQuotes_inquiries_quotes_details_departureTrucking_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_details_transport_billItems_partner {
  id: string;
  code: string;
}

export interface fetchQuotes_inquiries_quotes_details_transport_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchQuotes_inquiries_quotes_details_transport_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchQuotes_inquiries_quotes_details_transport {
  billItems: fetchQuotes_inquiries_quotes_details_transport_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_details {
  extra: fetchQuotes_inquiries_quotes_details_extra;
  arrivalDrayage: fetchQuotes_inquiries_quotes_details_arrivalDrayage;
  arrivalTrucking: fetchQuotes_inquiries_quotes_details_arrivalTrucking;
  departureDrayage: fetchQuotes_inquiries_quotes_details_departureDrayage;
  departureTrucking: fetchQuotes_inquiries_quotes_details_departureTrucking;
  transport: fetchQuotes_inquiries_quotes_details_transport;
}

export interface fetchQuotes_inquiries_quotes_inquiry_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: fetchQuotes_inquiries_quotes_inquiry_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchQuotes_inquiries_quotes_inquiry_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchQuotes_inquiries_quotes_inquiry_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_assignedOperator {
  avatar: fetchQuotes_inquiries_quotes_inquiry_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_attachments_uploader {
  name: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchQuotes_inquiries_quotes_inquiry_attachments_uploader | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_billItems_partner {
  id: string;
  code: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchQuotes_inquiries_quotes_inquiry_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_departureOptions_vanningInformations | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_cargoDescription {
  arrivalOptions: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_arrivalOptions | null;
  containers: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_containers[] | null;
  departureOptions: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: fetchQuotes_inquiries_quotes_inquiry_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_channel {
  id: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_sender {
  avatar: fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages {
  channel: fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_file | null;
  id: string;
  sender: fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_channel {
  id: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_sender {
  avatar: fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage {
  channel: fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_file | null;
  id: string;
  sender: fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList_partnerMembers {
  id: string;
  partner: fetchQuotes_inquiries_quotes_inquiry_channelList_partnerMembers_partner;
}

export interface fetchQuotes_inquiries_quotes_inquiry_channelList {
  channelMessages: fetchQuotes_inquiries_quotes_inquiry_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: fetchQuotes_inquiries_quotes_inquiry_channelList_lastMessage | null;
  partnerMembers: fetchQuotes_inquiries_quotes_inquiry_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_customerOrganization_address_country {
  id: string;
  nameTranslations: fetchQuotes_inquiries_quotes_inquiry_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_customerOrganization_address {
  city: string | null;
  country: fetchQuotes_inquiries_quotes_inquiry_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_customerOrganization {
  address: fetchQuotes_inquiries_quotes_inquiry_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: fetchQuotes_inquiries_quotes_inquiry_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_departureCustomerLocation_country {
  id: string;
  nameTranslations: fetchQuotes_inquiries_quotes_inquiry_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchQuotes_inquiries_quotes_inquiry_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchQuotes_inquiries_quotes_inquiry_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_followers {
  id: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_channel {
  id: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_file_uploader {
  name: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_file_uploader | null;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_sender {
  avatar: fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage {
  channel: fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_file | null;
  id: string;
  sender: fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage_sender;
  shipmentId: string;
}

export interface fetchQuotes_inquiries_quotes_inquiry_truckingDetails {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface fetchQuotes_inquiries_quotes_inquiry {
  arrivalAddress: fetchQuotes_inquiries_quotes_inquiry_arrivalAddress | null;
  arrivalCustomerLocation: fetchQuotes_inquiries_quotes_inquiry_arrivalCustomerLocation | null;
  arrivalPlace: fetchQuotes_inquiries_quotes_inquiry_arrivalPlace | null;
  assignedOperator: fetchQuotes_inquiries_quotes_inquiry_assignedOperator | null;
  attachments: fetchQuotes_inquiries_quotes_inquiry_attachments[] | null;
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: fetchQuotes_inquiries_quotes_inquiry_billItems[] | null;
  blMetaData: fetchQuotes_inquiries_quotes_inquiry_blMetaData | null;
  cargoDescription: fetchQuotes_inquiries_quotes_inquiry_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoType: CargoTypeEnum | null;
  channelList: fetchQuotes_inquiries_quotes_inquiry_channelList[];
  createdAt: any | null;
  customerOrganization: fetchQuotes_inquiries_quotes_inquiry_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureAddress: fetchQuotes_inquiries_quotes_inquiry_departureAddress | null;
  departureCustomerLocation: fetchQuotes_inquiries_quotes_inquiry_departureCustomerLocation | null;
  departurePlace: fetchQuotes_inquiries_quotes_inquiry_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  followers: fetchQuotes_inquiries_quotes_inquiry_followers[];
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  isFirst: boolean | null;
  lastPublicChannelMessage: fetchQuotes_inquiries_quotes_inquiry_lastPublicChannelMessage | null;
  organizationPaymentTerms: string | null;
  priority: number | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  quotedAt: any | null;
  reference: string | null;
  showTotal: boolean | null;
  status: InquiryStatusEnum;
  taxRate: number | null;
  transportationType: TransportationTypeEnum | null;
  truckingDetails: fetchQuotes_inquiries_quotes_inquiry_truckingDetails | null;
  updatedAt: any | null;
  usdJpyExchangeRate: number | null;
}

export interface fetchQuotes_inquiries_quotes {
  details: fetchQuotes_inquiries_quotes_details;
  id: string;
  inquiry: fetchQuotes_inquiries_quotes_inquiry;
  margin: number | null;
  totalCost: number;
  totalMargin: number;
}

export interface fetchQuotes_inquiries {
  id: string;
  selectedQuote: fetchQuotes_inquiries_selectedQuote | null;
  quotes: fetchQuotes_inquiries_quotes[];
}

export interface fetchQuotes {
  /**
   * Lists all Inquiries for current shipper
   */
  inquiries: fetchQuotes_inquiries[];
}

export interface fetchQuotesVariables {
  inquiryArgs?: InquiryScopedInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipment
// ====================================================

export interface fetchShipment_shipments_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface fetchShipment_shipments_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipment_shipments_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: fetchShipment_shipments_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipment_shipments_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchShipment_shipments_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchShipment_shipments_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchShipment_shipments_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchShipment_shipments_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipment_shipments_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchShipment_shipments_assignedOperator {
  avatar: fetchShipment_shipments_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface fetchShipment_shipments_billItems_partner {
  id: string;
  code: string;
}

export interface fetchShipment_shipments_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchShipment_shipments_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchShipment_shipments_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface fetchShipment_shipments_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface fetchShipment_shipments_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface fetchShipment_shipments_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: fetchShipment_shipments_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: fetchShipment_shipments_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface fetchShipment_shipments_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface fetchShipment_shipments_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface fetchShipment_shipments_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface fetchShipment_shipments_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: fetchShipment_shipments_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: fetchShipment_shipments_cargoDescription_departureOptions_vanningInformations | null;
}

export interface fetchShipment_shipments_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface fetchShipment_shipments_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchShipment_shipments_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface fetchShipment_shipments_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface fetchShipment_shipments_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: fetchShipment_shipments_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: fetchShipment_shipments_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface fetchShipment_shipments_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: fetchShipment_shipments_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface fetchShipment_shipments_cargoDescription {
  arrivalOptions: fetchShipment_shipments_cargoDescription_arrivalOptions | null;
  containers: fetchShipment_shipments_cargoDescription_containers[] | null;
  departureOptions: fetchShipment_shipments_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: fetchShipment_shipments_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface fetchShipment_shipments_cargoReleaseContact {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface fetchShipment_shipments_carrier {
  id: string;
  carrierType: CarrierTypeEnum;
  naccsCode: string;
  name: string | null;
}

export interface fetchShipment_shipments_channelList_channelMessages_channel {
  id: string;
}

export interface fetchShipment_shipments_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface fetchShipment_shipments_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchShipment_shipments_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface fetchShipment_shipments_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchShipment_shipments_channelList_channelMessages_sender {
  avatar: fetchShipment_shipments_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchShipment_shipments_channelList_channelMessages {
  channel: fetchShipment_shipments_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchShipment_shipments_channelList_channelMessages_file | null;
  id: string;
  sender: fetchShipment_shipments_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface fetchShipment_shipments_channelList_lastMessage_channel {
  id: string;
}

export interface fetchShipment_shipments_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface fetchShipment_shipments_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchShipment_shipments_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface fetchShipment_shipments_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchShipment_shipments_channelList_lastMessage_sender {
  avatar: fetchShipment_shipments_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchShipment_shipments_channelList_lastMessage {
  channel: fetchShipment_shipments_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchShipment_shipments_channelList_lastMessage_file | null;
  id: string;
  sender: fetchShipment_shipments_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface fetchShipment_shipments_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface fetchShipment_shipments_channelList_partnerMembers {
  id: string;
  partner: fetchShipment_shipments_channelList_partnerMembers_partner;
}

export interface fetchShipment_shipments_channelList {
  channelMessages: fetchShipment_shipments_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: fetchShipment_shipments_channelList_lastMessage | null;
  partnerMembers: fetchShipment_shipments_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface fetchShipment_shipments_containerInformation {
  containerNumber: string | null;
  containerReference: string | null;
  containerType: ContainerSizeEnum | null;
}

export interface fetchShipment_shipments_consigneeDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface fetchShipment_shipments_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipment_shipments_customerOrganization_address_country {
  id: string;
  nameTranslations: fetchShipment_shipments_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipment_shipments_customerOrganization_address {
  city: string | null;
  country: fetchShipment_shipments_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchShipment_shipments_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipment_shipments_customerOrganization {
  address: fetchShipment_shipments_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: fetchShipment_shipments_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface fetchShipment_shipments_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface fetchShipment_shipments_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipment_shipments_departureCustomerLocation_country {
  id: string;
  nameTranslations: fetchShipment_shipments_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipment_shipments_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchShipment_shipments_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchShipment_shipments_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchShipment_shipments_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchShipment_shipments_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipment_shipments_milestones_details_containerDetails {
  containerNumber: string | null;
}

export interface fetchShipment_shipments_milestones_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: fetchShipment_shipments_milestones_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface fetchShipment_shipments_milestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface fetchShipment_shipments_milestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: fetchShipment_shipments_milestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface fetchShipment_shipments_milestones_devanningDetails {
  container: fetchShipment_shipments_milestones_devanningDetails_container | null;
}

export interface fetchShipment_shipments_milestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface fetchShipment_shipments_milestones_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipment_shipments_milestones_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipment_shipments_milestones_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface fetchShipment_shipments_milestones_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface fetchShipment_shipments_milestones {
  deliveryTime: any | null;
  details: fetchShipment_shipments_milestones_details | null;
  devanningDate: any | null;
  devanningDetails: fetchShipment_shipments_milestones_devanningDetails | null;
  doneDates: fetchShipment_shipments_milestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: fetchShipment_shipments_milestones_pod | null;
  pol: fetchShipment_shipments_milestones_pol | null;
  shipmentId: string | null;
  truckingDetails: fetchShipment_shipments_milestones_truckingDetails | null;
  updatedAt: any | null;
  vessel: fetchShipment_shipments_milestones_vessel | null;
  vesselId: string | null;
}

export interface fetchShipment_shipments_naccsDocument_ida_consignee_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipment_shipments_naccsDocument_ida_consignee_address_country {
  id: string;
  nameTranslations: fetchShipment_shipments_naccsDocument_ida_consignee_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipment_shipments_naccsDocument_ida_consignee_address {
  city: string | null;
  country: fetchShipment_shipments_naccsDocument_ida_consignee_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchShipment_shipments_naccsDocument_ida_consignee {
  address: fetchShipment_shipments_naccsDocument_ida_consignee_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface fetchShipment_shipments_naccsDocument_ida_importCertificates {
  code: string | null;
  number: string | null;
}

export interface fetchShipment_shipments_naccsDocument_ida_shipper_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipment_shipments_naccsDocument_ida_shipper_address_country {
  id: string;
  nameTranslations: fetchShipment_shipments_naccsDocument_ida_shipper_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipment_shipments_naccsDocument_ida_shipper_address {
  city: string | null;
  country: fetchShipment_shipments_naccsDocument_ida_shipper_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchShipment_shipments_naccsDocument_ida_shipper {
  address: fetchShipment_shipments_naccsDocument_ida_shipper_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface fetchShipment_shipments_naccsDocument_ida {
  awbNumber: string | null;
  blNumber: string[] | null;
  bondedArea: string | null;
  consignee: fetchShipment_shipments_naccsDocument_ida_consignee | null;
  customsApplicationDate: any | null;
  declarationType: NaccsDeclarationTypeEnum | null;
  depositPaymentNumber: string | null;
  dueDateExtensionType: NaccsDueDateExtensionTypeEnum | null;
  evaluation: NaccsEvaluationEnum | null;
  existingAssessmentNumbers: string[] | null;
  incoterms: IncotermsTypeEnum | null;
  importCertificates: fetchShipment_shipments_naccsDocument_ida_importCertificates[] | null;
  insuranceCoverage: string | null;
  insuranceCurrency: string | null;
  insurancePrice: string | null;
  insuranceType: NaccsInsuranceTypeEnum | null;
  invoiceCurrency: string | null;
  invoiceNumber: string | null;
  invoicePrice: string | null;
  invoiceType: NaccsInvoiceTypeEnum | null;
  mawbNumber: string | null;
  otherRegulations: NaccsImportRegulationCodeEnum[] | null;
  paymentMethod: NaccsPaymentMethodEnum | null;
  realTimeBankAccount: string | null;
  remarkFromShipper: string | null;
  shipper: fetchShipment_shipments_naccsDocument_ida_shipper | null;
  shipperConsigneeStandardCode: string | null;
  shipperReferenceNumber: string | null;
  shipperSectionCode: string | null;
  tradingType: number | null;
}

export interface fetchShipment_shipments_naccsDocument {
  ida: fetchShipment_shipments_naccsDocument_ida | null;
}

export interface fetchShipment_shipments_notifyPartyDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface fetchShipment_shipments_shipperDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface fetchShipment_shipments_trackableMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface fetchShipment_shipments_trackableMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: fetchShipment_shipments_trackableMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface fetchShipment_shipments_trackableMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface fetchShipment_shipments_trackableMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: fetchShipment_shipments_trackableMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface fetchShipment_shipments_trackableMilestone_devanningDetails {
  container: fetchShipment_shipments_trackableMilestone_devanningDetails_container | null;
}

export interface fetchShipment_shipments_trackableMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface fetchShipment_shipments_trackableMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipment_shipments_trackableMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipment_shipments_trackableMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface fetchShipment_shipments_trackableMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface fetchShipment_shipments_trackableMilestone {
  deliveryTime: any | null;
  details: fetchShipment_shipments_trackableMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: fetchShipment_shipments_trackableMilestone_devanningDetails | null;
  doneDates: fetchShipment_shipments_trackableMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: fetchShipment_shipments_trackableMilestone_pod | null;
  pol: fetchShipment_shipments_trackableMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: fetchShipment_shipments_trackableMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: fetchShipment_shipments_trackableMilestone_vessel | null;
  vesselId: string | null;
}

export interface fetchShipment_shipments {
  arrivalAddress: fetchShipment_shipments_arrivalAddress | null;
  arrivalCustomerLocation: fetchShipment_shipments_arrivalCustomerLocation | null;
  arrivalPlace: fetchShipment_shipments_arrivalPlace | null;
  assignedOperator: fetchShipment_shipments_assignedOperator | null;
  billingComplete: boolean;
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: fetchShipment_shipments_billItems[] | null;
  blMetaData: fetchShipment_shipments_blMetaData | null;
  cargoDescription: fetchShipment_shipments_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoReleaseContact: fetchShipment_shipments_cargoReleaseContact | null;
  cargoType: CargoTypeEnum | null;
  carrier: fetchShipment_shipments_carrier | null;
  channelList: fetchShipment_shipments_channelList[];
  containerInformation: fetchShipment_shipments_containerInformation[];
  consigneeDetails: fetchShipment_shipments_consigneeDetails | null;
  createdAt: any | null;
  customerOrganization: fetchShipment_shipments_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureAddress: fetchShipment_shipments_departureAddress | null;
  departureCustomerLocation: fetchShipment_shipments_departureCustomerLocation | null;
  departurePlace: fetchShipment_shipments_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  endFreeTime: any | null;
  /**
   * true if the current user follow the shipment
   */
  followed: boolean;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  invoiceNumber: string | null;
  isProblem: boolean | null;
  locked: boolean | null;
  milestones: fetchShipment_shipments_milestones[] | null;
  naccsDocument: fetchShipment_shipments_naccsDocument | null;
  notifyPartyDetails: fetchShipment_shipments_notifyPartyDetails | null;
  organizationPaymentTerms: string | null;
  paymentAsArranged: boolean | null;
  paymentPlace: string | null;
  paymentTerms: PaymentTermsTypeEnum | null;
  quoteAcceptedAt: any | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  reference: string | null;
  shipperDetails: fetchShipment_shipments_shipperDetails | null;
  shippingMarks: string | null;
  showTotal: boolean | null;
  status: ShipmentStatusEnum;
  statusComment: string | null;
  taxRate: number | null;
  trackedBlNumber: string | null;
  trackableMilestone: fetchShipment_shipments_trackableMilestone | null;
  transportationType: TransportationTypeEnum | null;
  updatedAt: any | null;
  usdJpyExchangeRate: number | null;
}

export interface fetchShipment {
  /**
   * List shipments
   */
  shipments: fetchShipment_shipments[];
}

export interface fetchShipmentVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShippers
// ====================================================

export interface fetchShippers_shippers_organization {
  id: string;
  name: string;
}

export interface fetchShippers_shippers {
  organization: fetchShippers_shippers_organization;
  id: string | null;
}

export interface fetchShippers_shippersPagination {
  totalCount: number;
}

export interface fetchShippers {
  /**
   * Lists all Shippers
   */
  shippers: fetchShippers_shippers[];
  /**
   * Pagination details
   */
  shippersPagination: fetchShippers_shippersPagination;
}

export interface fetchShippersVariables {
  shipperArgs: ShipperScopedInput;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchTasks
// ====================================================

export interface fetchTasks_tasks_assignee_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchTasks_tasks_assignee {
  id: string;
  name: string;
  assigneeType: TaskAssigneeTypeEnum;
  avatar: fetchTasks_tasks_assignee_avatar | null;
}

export interface fetchTasks_tasks_customerOrganization {
  id: string;
  name: string;
}

export interface fetchTasks_tasks {
  assignee: fetchTasks_tasks_assignee | null;
  customerOrganization: fetchTasks_tasks_customerOrganization;
  deadlineDate: any | null;
  description: string | null;
  doneAt: any | null;
  id: string;
  isPublic: boolean;
  reminderDate: any | null;
  responsibleParty: string;
  shipmentId: string;
  shipmentReference: string;
  shipmentType: string;
  title: string;
}

export interface fetchTasks_tasksPagination {
  totalCount: number;
}

export interface fetchTasks {
  /**
   * List of Tasks
   */
  tasks: fetchTasks_tasks[];
  /**
   * Pagination details
   */
  tasksPagination: fetchTasks_tasksPagination;
}

export interface fetchTasksVariables {
  searchArgs?: TaskScopedInput | null;
  ordering?: TaskOrderEnum | null;
  filter?: TaskFilterEnum | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: tokioMarineContracts
// ====================================================

export interface tokioMarineContracts_tokioMarineContracts {
  id: string;
  tsuuchiFormNo: string;
  yushutsunyuDiv: string | null;
  kamotsuShuruiSentakuFlg: string | null;
  shokenRuiDiv: string | null;
  description: string | null;
  validityStart: any;
  validityEnd: any;
}

export interface tokioMarineContracts {
  /**
   * Tokio Marine Contracts
   */
  tokioMarineContracts: tokioMarineContracts_tokioMarineContracts[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchInquiryQuote
// ====================================================

export interface fetchInquiryQuote_inquiries_billItems_partner {
  id: string;
  code: string;
}

export interface fetchInquiryQuote_inquiries_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchInquiryQuote_inquiries_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchInquiryQuote_inquiries_quoteHistory {
  name: string;
  url: string;
  date: any;
}

export interface fetchInquiryQuote_inquiries {
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  billItemTotalNonSales: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalSales: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: fetchInquiryQuote_inquiries_billItems[] | null;
  id: string;
  quoteRemark: string | null;
  quoteHistory: fetchInquiryQuote_inquiries_quoteHistory[];
  reference: string | null;
  showTotal: boolean | null;
  status: InquiryStatusEnum;
  taxRate: number | null;
  quoteDueDate: any | null;
  usdJpyExchangeRate: number | null;
  organizationPaymentTerms: string | null;
}

export interface fetchInquiryQuote {
  /**
   * Lists all Inquiries for current shipper
   */
  inquiries: fetchInquiryQuote_inquiries[];
}

export interface fetchInquiryQuoteVariables {
  inquiryArgs?: InquiryScopedInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: listInquiries
// ====================================================

export interface listInquiries_inquiries_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface listInquiries_inquiries_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface listInquiries_inquiries_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface listInquiries_inquiries_assignedOperator {
  avatar: listInquiries_inquiries_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface listInquiries_inquiries_arrivalAddress {
  addressComponents: any | null;
}

export interface listInquiries_inquiries_departureAddress {
  addressComponents: any | null;
}

export interface listInquiries_inquiries {
  id: string;
  updatedAt: any | null;
  reference: string | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  departurePlace: listInquiries_inquiries_departurePlace | null;
  arrivalPlace: listInquiries_inquiries_arrivalPlace | null;
  priority: number | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  status: InquiryStatusEnum;
  assignedOperator: listInquiries_inquiries_assignedOperator | null;
  arrivalAddress: listInquiries_inquiries_arrivalAddress | null;
  departureAddress: listInquiries_inquiries_departureAddress | null;
}

export interface listInquiries {
  /**
   * Lists all Inquiries for current shipper
   */
  inquiries: listInquiries_inquiries[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: listShipments
// ====================================================

export interface listShipments_shipments_arrivalPlace {
  id: string;
  normalizedName: string | null;
}

export interface listShipments_shipments_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface listShipments_shipments_assignedOperator {
  avatar: listShipments_shipments_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface listShipments_shipments_bills {
  id: string;
  reference: string | null;
}

export interface listShipments_shipments_cargoDescription_parcels {
  packagingType: string | null;
  quantity: number | null;
}

export interface listShipments_shipments_cargoDescription_containers {
  requestedContainerType: string | null;
  requestedContainerCount: number | null;
}

export interface listShipments_shipments_cargoDescription {
  description: string | null;
  parcels: listShipments_shipments_cargoDescription_parcels[] | null;
  containers: listShipments_shipments_cargoDescription_containers[] | null;
}

export interface listShipments_shipments_customerOrganization {
  id: string;
  name: string;
}

export interface listShipments_shipments_departurePlace {
  id: string;
  normalizedName: string | null;
}

export interface listShipments_shipments_lastPublicChannelMessage_sender {
  id: string;
  senderType: string;
}

export interface listShipments_shipments_lastPublicChannelMessage {
  id: string;
  sender: listShipments_shipments_lastPublicChannelMessage_sender;
}

export interface listShipments_shipments_milestones_details {
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
}

export interface listShipments_shipments_milestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  drayageReserved: boolean | null;
}

export interface listShipments_shipments_milestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: listShipments_shipments_milestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface listShipments_shipments_milestones_devanningDetails {
  container: listShipments_shipments_milestones_devanningDetails_container | null;
}

export interface listShipments_shipments_milestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface listShipments_shipments_milestones {
  details: listShipments_shipments_milestones_details | null;
  devanningDate: any | null;
  devanningDetails: listShipments_shipments_milestones_devanningDetails | null;
  doneDates: listShipments_shipments_milestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
}

export interface listShipments_shipments {
  arrivalPlace: listShipments_shipments_arrivalPlace | null;
  assignedOperator: listShipments_shipments_assignedOperator | null;
  billingComplete: boolean;
  bills: listShipments_shipments_bills[] | null;
  cargoDescription: listShipments_shipments_cargoDescription | null;
  cargoType: CargoTypeEnum | null;
  customerOrganization: listShipments_shipments_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  departurePlace: listShipments_shipments_departurePlace | null;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  isProblem: boolean | null;
  lastPublicChannelMessage: listShipments_shipments_lastPublicChannelMessage | null;
  milestones: listShipments_shipments_milestones[] | null;
  reference: string | null;
  status: ShipmentStatusEnum;
  statusComment: string | null;
  taskCount: number;
  taskDue: boolean;
  transportationType: TransportationTypeEnum | null;
  quoteAcceptedAt: any | null;
}

export interface listShipments_shipmentsPagination {
  totalCount: number;
}

export interface listShipments {
  /**
   * List shipments
   */
  shipments: listShipments_shipments[];
  /**
   * Pagination details
   */
  shipmentsPagination: listShipments_shipmentsPagination;
}

export interface listShipmentsVariables {
  shipmentArgs?: ShipmentScopedInput | null;
  filter?: string | null;
  billArgs?: BillArgumentInput | null;
  showAllStatuses?: boolean | null;
  pagination?: PaginationInput | null;
  billingIncomplete?: boolean | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: loginInit
// ====================================================

export interface loginInit_currentOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface loginInit_currentOperator {
  avatar: loginInit_currentOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
  hasUnreadNotifications: boolean | null;
}

export interface loginInit {
  /**
   * Operator details
   */
  currentOperator: loginInit_currentOperator;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchOperatorFilterList
// ====================================================

export interface fetchOperatorFilterList_operators {
  id: string;
  name: string | null;
}

export interface fetchOperatorFilterList {
  /**
   * List Operators
   */
  operators: fetchOperatorFilterList_operators[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fuelSurcharge
// ====================================================

export interface fuelSurcharge_currentOperator_organization {
  anaMargin: number;
  fclMargin: number;
  fuelSurcharge: number;
  lclMargin: number;
  drayageMarginJapan: number;
  drayageMarginWorld: number;
  truckingMarginJapan: number;
  truckingMarginWorld: number;
  smallTruckingMarginJapan: number;
  taxRate: number;
  usdJpyExchangeRate: number;
}

export interface fuelSurcharge_currentOperator {
  organization: fuelSurcharge_currentOperator_organization;
}

export interface fuelSurcharge {
  /**
   * Operator details
   */
  currentOperator: fuelSurcharge_currentOperator;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchPartnerList
// ====================================================

export interface fetchPartnerList_partners {
  code: string;
  id: string;
  name: string;
}

export interface fetchPartnerList_partnersPagination {
  totalCount: number;
}

export interface fetchPartnerList {
  /**
   * List our various Partners
   */
  partners: fetchPartnerList_partners[] | null;
  /**
   * Pagination details
   */
  partnersPagination: fetchPartnerList_partnersPagination;
}

export interface fetchPartnerListVariables {
  partnerId?: string | null;
  searchString?: string | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchPartnerOptions
// ====================================================

export interface fetchPartnerOptions_partners {
  code: string;
  id: string;
  name: string;
}

export interface fetchPartnerOptions {
  /**
   * List our various Partners
   */
  partners: fetchPartnerOptions_partners[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchPartners
// ====================================================

export interface fetchPartners_partners_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchPartners_partners_address_country {
  id: string;
  nameTranslations: fetchPartners_partners_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchPartners_partners_address {
  city: string | null;
  country: fetchPartners_partners_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchPartners_partners_members_partner {
  id: string;
}

export interface fetchPartners_partners_members {
  deletedAt: any | null;
  email: string;
  id: string;
  locale: AvailableLocalesEnum;
  name: string;
  partner: fetchPartners_partners_members_partner;
  phoneNumber: string | null;
}

export interface fetchPartners_partners {
  address: fetchPartners_partners_address | null;
  code: string;
  deletedAt: any | null;
  faxNumber: string | null;
  id: string;
  name: string;
  normalizedName: string | null;
  note: string | null;
  /**
   * List our various Partner Members
   */
  members: fetchPartners_partners_members[] | null;
  phoneNumber: string | null;
  url: string | null;
}

export interface fetchPartners {
  /**
   * List our various Partners
   */
  partners: fetchPartners_partners[] | null;
}

export interface fetchPartnersVariables {
  partnerId?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchPlaces
// ====================================================

export interface fetchPlaces_places {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchPlaces {
  /**
   * List all available places
   */
  places: fetchPlaces_places[];
}

export interface fetchPlacesVariables {
  id?: string | null;
  inUse?: InUseInput | null;
  nameSearch: string;
  placeTypes?: string[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: searchOperator
// ====================================================

export interface searchOperator_currentOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface searchOperator_currentOperator {
  avatar: searchOperator_currentOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface searchOperator {
  /**
   * Operator details
   */
  currentOperator: searchOperator_currentOperator;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: quoteTemplateSearch
// ====================================================

export interface quoteTemplateSearch_quoteTemplates {
  id: string;
  name: string;
}

export interface quoteTemplateSearch {
  /**
   * Lists all QuoteTemplates
   */
  quoteTemplates: quoteTemplateSearch_quoteTemplates[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ScopedListBills
// ====================================================

export interface ScopedListBills_bills_customerOrganization {
  id: string;
  name: string;
}

export interface ScopedListBills_bills_shipments {
  id: string;
  reference: string | null;
}

export interface ScopedListBills_bills {
  id: string;
  dueDate: any | null;
  issueDate: any | null;
  reference: string | null;
  customerOrganization: ScopedListBills_bills_customerOrganization | null;
  status: BillStatusEnum | null;
  shipments: ScopedListBills_bills_shipments[] | null;
  total: number | null;
}

export interface ScopedListBills_billsPagination {
  totalCount: number;
}

export interface ScopedListBills {
  /**
   * Lists all Bills
   */
  bills: ScopedListBills_bills[];
  /**
   * Pagination details
   */
  billsPagination: ScopedListBills_billsPagination;
}

export interface ScopedListBillsVariables {
  billArgs?: BillScopedInput | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ScopedListInquiries
// ====================================================

export interface ScopedListInquiries_inquiries_arrivalPlace {
  id: string;
  normalizedName: string | null;
}

export interface ScopedListInquiries_inquiries_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface ScopedListInquiries_inquiries_assignedOperator {
  avatar: ScopedListInquiries_inquiries_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface ScopedListInquiries_inquiries_cargoDescription_parcels {
  packagingType: string | null;
  quantity: number | null;
}

export interface ScopedListInquiries_inquiries_cargoDescription_containers {
  requestedContainerType: string | null;
  requestedContainerCount: number | null;
}

export interface ScopedListInquiries_inquiries_cargoDescription {
  description: string | null;
  parcels: ScopedListInquiries_inquiries_cargoDescription_parcels[] | null;
  containers: ScopedListInquiries_inquiries_cargoDescription_containers[] | null;
}

export interface ScopedListInquiries_inquiries_customerOrganization {
  id: string;
  name: string;
}

export interface ScopedListInquiries_inquiries_departurePlace {
  id: string;
  normalizedName: string | null;
}

export interface ScopedListInquiries_inquiries_lastPublicChannelMessage_sender {
  id: string;
  senderType: string;
}

export interface ScopedListInquiries_inquiries_lastPublicChannelMessage {
  id: string;
  sender: ScopedListInquiries_inquiries_lastPublicChannelMessage_sender;
}

export interface ScopedListInquiries_inquiries {
  arrivalPlace: ScopedListInquiries_inquiries_arrivalPlace | null;
  assignedOperator: ScopedListInquiries_inquiries_assignedOperator | null;
  billItemTotal: number | null;
  cargoDescription: ScopedListInquiries_inquiries_cargoDescription | null;
  cargoType: CargoTypeEnum | null;
  customerOrganization: ScopedListInquiries_inquiries_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  departurePlace: ScopedListInquiries_inquiries_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  isFirst: boolean | null;
  lastPublicChannelMessage: ScopedListInquiries_inquiries_lastPublicChannelMessage | null;
  priority: number | null;
  quoteDueDate: any | null;
  quotedAt: any | null;
  reference: string | null;
  showTotal: boolean | null;
  taskCount: number;
  taskDue: boolean;
  transportationType: TransportationTypeEnum | null;
}

export interface ScopedListInquiries_inquiriesPagination {
  totalCount: number;
}

export interface ScopedListInquiries {
  /**
   * Lists all Inquiries for current shipper
   */
  inquiries: ScopedListInquiries_inquiries[];
  /**
   * Pagination details
   */
  inquiriesPagination: ScopedListInquiries_inquiriesPagination;
}

export interface ScopedListInquiriesVariables {
  inquiryArgs?: InquiryScopedInput | null;
  showAllStatuses?: boolean | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: billableItems
// ====================================================

export interface billableItems_shipments_billItems_bill {
  reference: string | null;
}

export interface billableItems_shipments_billItems {
  billId: string | null;
  bill: billableItems_shipments_billItems_bill | null;
  category: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  quantity: number | null;
  totalTax: number;
  totalAmount: number;
  unitPrice: number | null;
}

export interface billableItems_shipments {
  billItems: billableItems_shipments_billItems[] | null;
  billItemTotal: number | null;
  id: string;
  reference: string | null;
}

export interface billableItems_shipmentsPagination {
  totalCount: number;
}

export interface billableItems {
  /**
   * List shipments
   */
  shipments: billableItems_shipments[];
  /**
   * Pagination details
   */
  shipmentsPagination: billableItems_shipmentsPagination;
}

export interface billableItemsVariables {
  shipmentArgs?: ShipmentScopedInput | null;
  billArgs?: BillArgumentInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchBillableShipmentList
// ====================================================

export interface fetchBillableShipmentList_shipments_arrivalPlace {
  name: string | null;
}

export interface fetchBillableShipmentList_shipments_customerOrganization {
  id: string;
  name: string;
}

export interface fetchBillableShipmentList_shipments_departurePlace {
  name: string | null;
}

export interface fetchBillableShipmentList_shipments {
  arrivalPlace: fetchBillableShipmentList_shipments_arrivalPlace | null;
  billItemTotal: number | null;
  customerOrganization: fetchBillableShipmentList_shipments_customerOrganization;
  customerReference: string | null;
  departurePlace: fetchBillableShipmentList_shipments_departurePlace | null;
  id: string;
  quoteAcceptedAt: any | null;
  reference: string | null;
}

export interface fetchBillableShipmentList_shipmentsPagination {
  totalCount: number;
}

export interface fetchBillableShipmentList {
  /**
   * List shipments
   */
  shipments: fetchBillableShipmentList_shipments[];
  /**
   * Pagination details
   */
  shipmentsPagination: fetchBillableShipmentList_shipmentsPagination;
}

export interface fetchBillableShipmentListVariables {
  shipmentArgs?: ShipmentScopedInput | null;
  filter?: string | null;
  billArgs?: BillArgumentInput | null;
  pagination?: PaginationInput | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchMilestoneDetails
// ====================================================

export interface fetchMilestoneDetails_shipments_customerOrganization {
  id: string;
}

export interface fetchMilestoneDetails_shipments_carrier {
  id: string;
  name: string | null;
  naccsCode: string;
  carrierType: CarrierTypeEnum;
}

export interface fetchMilestoneDetails_shipments_containerInformation {
  containerNumber: string | null;
}

export interface fetchMilestoneDetails_shipments_milestones_details_containerDetails {
  containerNumber: string | null;
}

export interface fetchMilestoneDetails_shipments_milestones_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: fetchMilestoneDetails_shipments_milestones_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface fetchMilestoneDetails_shipments_milestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface fetchMilestoneDetails_shipments_milestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: fetchMilestoneDetails_shipments_milestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface fetchMilestoneDetails_shipments_milestones_devanningDetails {
  container: fetchMilestoneDetails_shipments_milestones_devanningDetails_container | null;
}

export interface fetchMilestoneDetails_shipments_milestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface fetchMilestoneDetails_shipments_milestones_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchMilestoneDetails_shipments_milestones_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchMilestoneDetails_shipments_milestones_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface fetchMilestoneDetails_shipments_milestones_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface fetchMilestoneDetails_shipments_milestones {
  deliveryTime: any | null;
  details: fetchMilestoneDetails_shipments_milestones_details | null;
  devanningDate: any | null;
  devanningDetails: fetchMilestoneDetails_shipments_milestones_devanningDetails | null;
  doneDates: fetchMilestoneDetails_shipments_milestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: fetchMilestoneDetails_shipments_milestones_pod | null;
  pol: fetchMilestoneDetails_shipments_milestones_pol | null;
  shipmentId: string | null;
  truckingDetails: fetchMilestoneDetails_shipments_milestones_truckingDetails | null;
  updatedAt: any | null;
  vessel: fetchMilestoneDetails_shipments_milestones_vessel | null;
  vesselId: string | null;
}

export interface fetchMilestoneDetails_shipments {
  id: string;
  customerOrganization: fetchMilestoneDetails_shipments_customerOrganization;
  carrier: fetchMilestoneDetails_shipments_carrier | null;
  containerInformation: fetchMilestoneDetails_shipments_containerInformation[];
  endFreeTime: any | null;
  milestones: fetchMilestoneDetails_shipments_milestones[] | null;
  transportationType: TransportationTypeEnum | null;
}

export interface fetchMilestoneDetails {
  /**
   * List shipments
   */
  shipments: fetchMilestoneDetails_shipments[];
}

export interface fetchMilestoneDetailsVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchNaccsDetails
// ====================================================

export interface fetchNaccsDetails_shipments_customerOrganization_address {
  city: string | null;
  line1: string | null;
  line2: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
  postalCode: string | null;
}

export interface fetchNaccsDetails_shipments_customerOrganization {
  address: fetchNaccsDetails_shipments_customerOrganization_address | null;
  countryCode: string | null;
  depositPaymentNumber: string | null;
  id: string;
  name: string;
  normalizedName: string | null;
  insuranceNumber: string | null;
  phoneNumber: string | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_consignee_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_consignee_address_country {
  id: string;
  nameTranslations: fetchNaccsDetails_shipments_naccsDocument_ida_consignee_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_consignee_address {
  city: string | null;
  country: fetchNaccsDetails_shipments_naccsDocument_ida_consignee_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_consignee {
  address: fetchNaccsDetails_shipments_naccsDocument_ida_consignee_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_importCertificates {
  code: string | null;
  number: string | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_shipper_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_shipper_address_country {
  id: string;
  nameTranslations: fetchNaccsDetails_shipments_naccsDocument_ida_shipper_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_shipper_address {
  city: string | null;
  country: fetchNaccsDetails_shipments_naccsDocument_ida_shipper_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida_shipper {
  address: fetchNaccsDetails_shipments_naccsDocument_ida_shipper_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument_ida {
  awbNumber: string | null;
  blNumber: string[] | null;
  bondedArea: string | null;
  consignee: fetchNaccsDetails_shipments_naccsDocument_ida_consignee | null;
  customsApplicationDate: any | null;
  declarationType: NaccsDeclarationTypeEnum | null;
  depositPaymentNumber: string | null;
  dueDateExtensionType: NaccsDueDateExtensionTypeEnum | null;
  evaluation: NaccsEvaluationEnum | null;
  existingAssessmentNumbers: string[] | null;
  incoterms: IncotermsTypeEnum | null;
  importCertificates: fetchNaccsDetails_shipments_naccsDocument_ida_importCertificates[] | null;
  insuranceCoverage: string | null;
  insuranceCurrency: string | null;
  insurancePrice: string | null;
  insuranceType: NaccsInsuranceTypeEnum | null;
  invoiceCurrency: string | null;
  invoiceNumber: string | null;
  invoicePrice: string | null;
  invoiceType: NaccsInvoiceTypeEnum | null;
  mawbNumber: string | null;
  otherRegulations: NaccsImportRegulationCodeEnum[] | null;
  paymentMethod: NaccsPaymentMethodEnum | null;
  realTimeBankAccount: string | null;
  remarkFromShipper: string | null;
  shipper: fetchNaccsDetails_shipments_naccsDocument_ida_shipper | null;
  shipperConsigneeStandardCode: string | null;
  shipperReferenceNumber: string | null;
  shipperSectionCode: string | null;
  tradingType: number | null;
}

export interface fetchNaccsDetails_shipments_naccsDocument {
  ida: fetchNaccsDetails_shipments_naccsDocument_ida | null;
}

export interface fetchNaccsDetails_shipments {
  billItemTotal: number | null;
  customerOrganization: fetchNaccsDetails_shipments_customerOrganization;
  customerRole: CustomerRoleEnum | null;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  naccsDocument: fetchNaccsDetails_shipments_naccsDocument | null;
  invoiceNumber: string | null;
  transportationType: TransportationTypeEnum | null;
}

export interface fetchNaccsDetails {
  /**
   * List shipments
   */
  shipments: fetchNaccsDetails_shipments[];
}

export interface fetchNaccsDetailsVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipmentChannelList
// ====================================================

export interface fetchShipmentChannelList_shipments_arrivalAddress {
  addressComponents: any | null;
}

export interface fetchShipmentChannelList_shipments_arrivalPlace {
  code: string | null;
  countryCode: string | null;
  name: string | null;
}

export interface fetchShipmentChannelList_shipments_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchShipmentChannelList_shipments_assignedOperator {
  avatar: fetchShipmentChannelList_shipments_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface fetchShipmentChannelList_shipments_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface fetchShipmentChannelList_shipments_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipmentChannelList_shipments_customerOrganization_address_country {
  id: string;
  nameTranslations: fetchShipmentChannelList_shipments_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipmentChannelList_shipments_customerOrganization_address {
  city: string | null;
  country: fetchShipmentChannelList_shipments_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface fetchShipmentChannelList_shipments_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipmentChannelList_shipments_customerOrganization {
  address: fetchShipmentChannelList_shipments_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: fetchShipmentChannelList_shipments_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface fetchShipmentChannelList_shipments_departureAddress {
  addressComponents: any | null;
}

export interface fetchShipmentChannelList_shipments_departurePlace {
  code: string | null;
  countryCode: string | null;
  name: string | null;
}

export interface fetchShipmentChannelList_shipments_followers {
  id: string | null;
}

export interface fetchShipmentChannelList_shipments_shipper {
  id: string | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: fetchShipmentChannelList_shipments_trackableMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: fetchShipmentChannelList_shipments_trackableMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_devanningDetails {
  container: fetchShipmentChannelList_shipments_trackableMilestone_devanningDetails_container | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface fetchShipmentChannelList_shipments_trackableMilestone {
  deliveryTime: any | null;
  details: fetchShipmentChannelList_shipments_trackableMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: fetchShipmentChannelList_shipments_trackableMilestone_devanningDetails | null;
  doneDates: fetchShipmentChannelList_shipments_trackableMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: fetchShipmentChannelList_shipments_trackableMilestone_pod | null;
  pol: fetchShipmentChannelList_shipments_trackableMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: fetchShipmentChannelList_shipments_trackableMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: fetchShipmentChannelList_shipments_trackableMilestone_vessel | null;
  vesselId: string | null;
}

export interface fetchShipmentChannelList_shipments_channelList_channelMessages_channel {
  id: string;
}

export interface fetchShipmentChannelList_shipments_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface fetchShipmentChannelList_shipments_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchShipmentChannelList_shipments_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface fetchShipmentChannelList_shipments_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchShipmentChannelList_shipments_channelList_channelMessages_sender {
  avatar: fetchShipmentChannelList_shipments_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchShipmentChannelList_shipments_channelList_channelMessages {
  channel: fetchShipmentChannelList_shipments_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchShipmentChannelList_shipments_channelList_channelMessages_file | null;
  id: string;
  sender: fetchShipmentChannelList_shipments_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface fetchShipmentChannelList_shipments_channelList_lastMessage_channel {
  id: string;
}

export interface fetchShipmentChannelList_shipments_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface fetchShipmentChannelList_shipments_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: fetchShipmentChannelList_shipments_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface fetchShipmentChannelList_shipments_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface fetchShipmentChannelList_shipments_channelList_lastMessage_sender {
  avatar: fetchShipmentChannelList_shipments_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface fetchShipmentChannelList_shipments_channelList_lastMessage {
  channel: fetchShipmentChannelList_shipments_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: fetchShipmentChannelList_shipments_channelList_lastMessage_file | null;
  id: string;
  sender: fetchShipmentChannelList_shipments_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface fetchShipmentChannelList_shipments_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface fetchShipmentChannelList_shipments_channelList_partnerMembers {
  id: string;
  partner: fetchShipmentChannelList_shipments_channelList_partnerMembers_partner;
}

export interface fetchShipmentChannelList_shipments_channelList {
  channelMessages: fetchShipmentChannelList_shipments_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: fetchShipmentChannelList_shipments_channelList_lastMessage | null;
  partnerMembers: fetchShipmentChannelList_shipments_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface fetchShipmentChannelList_shipments {
  arrivalAddress: fetchShipmentChannelList_shipments_arrivalAddress | null;
  arrivalPlace: fetchShipmentChannelList_shipments_arrivalPlace | null;
  assignedOperator: fetchShipmentChannelList_shipments_assignedOperator | null;
  blMetaData: fetchShipmentChannelList_shipments_blMetaData | null;
  customerOrganization: fetchShipmentChannelList_shipments_customerOrganization;
  customerReference: string | null;
  departureAddress: fetchShipmentChannelList_shipments_departureAddress | null;
  departurePlace: fetchShipmentChannelList_shipments_departurePlace | null;
  followers: fetchShipmentChannelList_shipments_followers[];
  id: string;
  isProblem: boolean | null;
  locked: boolean | null;
  reference: string | null;
  shipper: fetchShipmentChannelList_shipments_shipper | null;
  status: ShipmentStatusEnum;
  statusComment: string | null;
  trackedBlNumber: string | null;
  trackableMilestone: fetchShipmentChannelList_shipments_trackableMilestone | null;
  channelList: fetchShipmentChannelList_shipments_channelList[];
}

export interface fetchShipmentChannelList {
  /**
   * List shipments
   */
  shipments: fetchShipmentChannelList_shipments[];
}

export interface fetchShipmentChannelListVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipmentDetails
// ====================================================

export interface fetchShipmentDetails_shipments_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipmentDetails_shipments_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: fetchShipmentDetails_shipments_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipmentDetails_shipments_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchShipmentDetails_shipments_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchShipmentDetails_shipments_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchShipmentDetails_shipments_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchShipmentDetails_shipments_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface fetchShipmentDetails_shipments_cargoReleaseContact {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface fetchShipmentDetails_shipments_containerInformation {
  containerNumber: string | null;
  containerReference: string | null;
  containerType: ContainerSizeEnum | null;
}

export interface fetchShipmentDetails_shipments_consigneeDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface fetchShipmentDetails_shipments_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipmentDetails_shipments_departureCustomerLocation_country {
  id: string;
  nameTranslations: fetchShipmentDetails_shipments_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipmentDetails_shipments_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchShipmentDetails_shipments_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchShipmentDetails_shipments_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchShipmentDetails_shipments_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchShipmentDetails_shipments_notifyPartyDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface fetchShipmentDetails_shipments_shipperDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface fetchShipmentDetails_shipments {
  arrivalCustomerLocation: fetchShipmentDetails_shipments_arrivalCustomerLocation | null;
  blMetaData: fetchShipmentDetails_shipments_blMetaData | null;
  cargoReleaseContact: fetchShipmentDetails_shipments_cargoReleaseContact | null;
  containerInformation: fetchShipmentDetails_shipments_containerInformation[];
  consigneeDetails: fetchShipmentDetails_shipments_consigneeDetails | null;
  departureCustomerLocation: fetchShipmentDetails_shipments_departureCustomerLocation | null;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  invoiceNumber: string | null;
  notifyPartyDetails: fetchShipmentDetails_shipments_notifyPartyDetails | null;
  paymentAsArranged: boolean | null;
  paymentPlace: string | null;
  paymentTerms: PaymentTermsTypeEnum | null;
  shipperDetails: fetchShipmentDetails_shipments_shipperDetails | null;
  shippingMarks: string | null;
}

export interface fetchShipmentDetails {
  /**
   * List shipments
   */
  shipments: fetchShipmentDetails_shipments[];
}

export interface fetchShipmentDetailsVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipmentForInsurance
// ====================================================

export interface fetchShipmentForInsurance_shipments_insurancePolicy {
  complete: boolean | null;
  registrationRef: string | null;
  currency: string | null;
  amount: number | null;
  amountJpy: number | null;
  request: any;
}

export interface fetchShipmentForInsurance_shipments_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipmentForInsurance_shipments_departureCustomerLocation_country {
  id: string;
  nameTranslations: fetchShipmentForInsurance_shipments_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipmentForInsurance_shipments_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchShipmentForInsurance_shipments_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchShipmentForInsurance_shipments_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchShipmentForInsurance_shipments_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchShipmentForInsurance_shipments_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface fetchShipmentForInsurance_shipments_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: fetchShipmentForInsurance_shipments_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface fetchShipmentForInsurance_shipments_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface fetchShipmentForInsurance_shipments_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: fetchShipmentForInsurance_shipments_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: fetchShipmentForInsurance_shipments_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface fetchShipmentForInsurance_shipments_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentForInsurance_shipments_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_details_containerDetails {
  containerNumber: string | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: fetchShipmentForInsurance_shipments_milestones_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: fetchShipmentForInsurance_shipments_milestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_devanningDetails {
  container: fetchShipmentForInsurance_shipments_milestones_devanningDetails_container | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface fetchShipmentForInsurance_shipments_milestones_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface fetchShipmentForInsurance_shipments_milestones_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface fetchShipmentForInsurance_shipments_milestones {
  deliveryTime: any | null;
  details: fetchShipmentForInsurance_shipments_milestones_details | null;
  devanningDate: any | null;
  devanningDetails: fetchShipmentForInsurance_shipments_milestones_devanningDetails | null;
  doneDates: fetchShipmentForInsurance_shipments_milestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: fetchShipmentForInsurance_shipments_milestones_pod | null;
  pol: fetchShipmentForInsurance_shipments_milestones_pol | null;
  shipmentId: string | null;
  truckingDetails: fetchShipmentForInsurance_shipments_milestones_truckingDetails | null;
  updatedAt: any | null;
  vessel: fetchShipmentForInsurance_shipments_milestones_vessel | null;
  vesselId: string | null;
}

export interface fetchShipmentForInsurance_shipments_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface fetchShipmentForInsurance_shipments {
  id: string;
  reference: string | null;
  customerRole: CustomerRoleEnum | null;
  insurancePolicy: fetchShipmentForInsurance_shipments_insurancePolicy | null;
  departureCustomerLocation: fetchShipmentForInsurance_shipments_departureCustomerLocation | null;
  arrivalCustomerLocation: fetchShipmentForInsurance_shipments_arrivalCustomerLocation | null;
  departurePlace: fetchShipmentForInsurance_shipments_departurePlace | null;
  arrivalPlace: fetchShipmentForInsurance_shipments_arrivalPlace | null;
  milestones: fetchShipmentForInsurance_shipments_milestones[] | null;
  invoiceNumber: string | null;
  blMetaData: fetchShipmentForInsurance_shipments_blMetaData | null;
}

export interface fetchShipmentForInsurance {
  /**
   * List shipments
   */
  shipments: fetchShipmentForInsurance_shipments[];
}

export interface fetchShipmentForInsuranceVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipmentMilestone
// ====================================================

export interface fetchShipmentMilestone_shipments_milestones_details_containerDetails {
  containerNumber: string | null;
}

export interface fetchShipmentMilestone_shipments_milestones_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: fetchShipmentMilestone_shipments_milestones_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface fetchShipmentMilestone_shipments_milestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface fetchShipmentMilestone_shipments_milestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: fetchShipmentMilestone_shipments_milestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface fetchShipmentMilestone_shipments_milestones_devanningDetails {
  container: fetchShipmentMilestone_shipments_milestones_devanningDetails_container | null;
}

export interface fetchShipmentMilestone_shipments_milestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface fetchShipmentMilestone_shipments_milestones_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentMilestone_shipments_milestones_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentMilestone_shipments_milestones_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface fetchShipmentMilestone_shipments_milestones_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface fetchShipmentMilestone_shipments_milestones {
  deliveryTime: any | null;
  details: fetchShipmentMilestone_shipments_milestones_details | null;
  devanningDate: any | null;
  devanningDetails: fetchShipmentMilestone_shipments_milestones_devanningDetails | null;
  doneDates: fetchShipmentMilestone_shipments_milestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: fetchShipmentMilestone_shipments_milestones_pod | null;
  pol: fetchShipmentMilestone_shipments_milestones_pol | null;
  shipmentId: string | null;
  truckingDetails: fetchShipmentMilestone_shipments_milestones_truckingDetails | null;
  updatedAt: any | null;
  vessel: fetchShipmentMilestone_shipments_milestones_vessel | null;
  vesselId: string | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: fetchShipmentMilestone_shipments_trackableMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: fetchShipmentMilestone_shipments_trackableMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_devanningDetails {
  container: fetchShipmentMilestone_shipments_trackableMilestone_devanningDetails_container | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface fetchShipmentMilestone_shipments_trackableMilestone {
  deliveryTime: any | null;
  details: fetchShipmentMilestone_shipments_trackableMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: fetchShipmentMilestone_shipments_trackableMilestone_devanningDetails | null;
  doneDates: fetchShipmentMilestone_shipments_trackableMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: fetchShipmentMilestone_shipments_trackableMilestone_pod | null;
  pol: fetchShipmentMilestone_shipments_trackableMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: fetchShipmentMilestone_shipments_trackableMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: fetchShipmentMilestone_shipments_trackableMilestone_vessel | null;
  vesselId: string | null;
}

export interface fetchShipmentMilestone_shipments {
  customerRole: CustomerRoleEnum | null;
  endFreeTime: any | null;
  id: string;
  milestones: fetchShipmentMilestone_shipments_milestones[] | null;
  trackableMilestone: fetchShipmentMilestone_shipments_trackableMilestone | null;
}

export interface fetchShipmentMilestone {
  /**
   * List shipments
   */
  shipments: fetchShipmentMilestone_shipments[];
}

export interface fetchShipmentMilestoneVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: fetchShipmentQuote
// ====================================================

export interface fetchShipmentQuote_shipments_billItems_partner {
  id: string;
  code: string;
}

export interface fetchShipmentQuote_shipments_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: fetchShipmentQuote_shipments_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface fetchShipmentQuote_shipments_quoteHistory {
  name: string;
  url: string;
  date: any;
}

export interface fetchShipmentQuote_shipments {
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  billItemTotalNonSales: number | null;
  billItemTotalSales: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: fetchShipmentQuote_shipments_billItems[] | null;
  id: string;
  quoteAcceptedAt: any | null;
  quoteRemark: string | null;
  quoteHistory: fetchShipmentQuote_shipments_quoteHistory[];
  reference: string | null;
  showTotal: boolean | null;
  status: ShipmentStatusEnum;
  taxRate: number | null;
  usdJpyExchangeRate: number | null;
  organizationPaymentTerms: string | null;
}

export interface fetchShipmentQuote {
  /**
   * List shipments
   */
  shipments: fetchShipmentQuote_shipments[];
}

export interface fetchShipmentQuoteVariables {
  shipmentArgs: ShipmentScopedInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: customerModalFetchShipper
// ====================================================

export interface customerModalFetchShipper_shippers_organization {
  id: string;
  name: string;
  url: string | null;
  memo: string | null;
}

export interface customerModalFetchShipper_shippers {
  email: string | null;
  id: string | null;
  name: string | null;
  organization: customerModalFetchShipper_shippers_organization;
  phoneNumber: string | null;
}

export interface customerModalFetchShipper {
  /**
   * Lists all Shippers
   */
  shippers: customerModalFetchShipper_shippers[];
}

export interface customerModalFetchShipperVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: vesselsSearch
// ====================================================

export interface vesselsSearch_vessels {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface vesselsSearch {
  /**
   * Search for a vessel by its name
   */
  vessels: vesselsSearch_vessels[];
}

export interface vesselsSearchVariables {
  name?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: AppEventNotification
// ====================================================

export interface AppEventNotification_eventNotification_payload {
  id: string;
  subjectType: string;
  shipmentId: string | null;
  shipmentStatus: string | null;
}

export interface AppEventNotification_eventNotification {
  eventName: string;
  payload: AppEventNotification_eventNotification_payload | null;
}

export interface AppEventNotification {
  /**
   * Triggered when a notification is created
   */
  eventNotification: AppEventNotification_eventNotification;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: channelMessageCreated
// ====================================================

export interface channelMessageCreated_channelMessageCreated_channel {
  id: string;
}

export interface channelMessageCreated_channelMessageCreated_file_uploader {
  name: string | null;
}

export interface channelMessageCreated_channelMessageCreated_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: channelMessageCreated_channelMessageCreated_file_uploader | null;
  url: string | null;
}

export interface channelMessageCreated_channelMessageCreated_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface channelMessageCreated_channelMessageCreated_sender {
  avatar: channelMessageCreated_channelMessageCreated_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface channelMessageCreated_channelMessageCreated {
  channel: channelMessageCreated_channelMessageCreated_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: channelMessageCreated_channelMessageCreated_file | null;
  id: string;
  sender: channelMessageCreated_channelMessageCreated_sender;
  shipmentId: string;
}

export interface channelMessageCreated {
  /**
   * Returns new communication created for a specific shipment
   */
  channelMessageCreated: channelMessageCreated_channelMessageCreated;
}

export interface channelMessageCreatedVariables {
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddressFields
// ====================================================

export interface AddressFields {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AttachmentFields
// ====================================================

export interface AttachmentFields_uploader {
  name: string | null;
}

export interface AttachmentFields {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: AttachmentFields_uploader | null;
  url: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AvatarFields
// ====================================================

export interface AvatarFields {
  id: string;
  name: string;
  url: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BankAccountFields
// ====================================================

export interface BankAccountFields {
  accountName: string | null;
  accountNumber: string | null;
  accountType: BankAccountTypeEnum | null;
  bankAddress: string | null;
  bankCode: string | null;
  bankName: string | null;
  branchCode: string | null;
  branchName: string | null;
  customerOrganizationId: string;
  id: string;
  realTime: boolean;
  swiftCode: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BillFields
// ====================================================

export interface BillFields_shipments {
  id: string;
  billItemTotal: number | null;
  quoteAcceptedAt: any | null;
  reference: string | null;
}

export interface BillFields_pdfFile_uploader {
  name: string | null;
}

export interface BillFields_pdfFile {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: BillFields_pdfFile_uploader | null;
  url: string | null;
}

export interface BillFields_customerOrganization {
  id: string;
  name: string;
}

export interface BillFields {
  id: string;
  dueDate: any | null;
  issueDate: any | null;
  reference: string | null;
  remark: string | null;
  status: BillStatusEnum | null;
  total: number | null;
  language: AvailableLocalesEnum | null;
  shipments: BillFields_shipments[] | null;
  pdfFile: BillFields_pdfFile | null;
  customerOrganization: BillFields_customerOrganization | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BillItemFields
// ====================================================

export interface BillItemFields_partner {
  id: string;
  code: string;
}

export interface BillItemFields {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: BillItemFields_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BillItemTemplateFields
// ====================================================

export interface BillItemTemplateFields {
  category: string | null;
  description: string | null;
  id: string;
  taxType: TaxTypeEnum;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BlMetaDataFields
// ====================================================

export interface BlMetaDataFields {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CargoDescriptionFields
// ====================================================

export interface CargoDescriptionFields_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface CargoDescriptionFields_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface CargoDescriptionFields_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: CargoDescriptionFields_arrivalOptions_truckingInformations | null;
  vanningInformations: CargoDescriptionFields_arrivalOptions_vanningInformations | null;
}

export interface CargoDescriptionFields_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface CargoDescriptionFields_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface CargoDescriptionFields_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface CargoDescriptionFields_departureOptions {
  drayage: boolean | null;
  truckingInformations: CargoDescriptionFields_departureOptions_truckingInformations | null;
  vanningInformations: CargoDescriptionFields_departureOptions_vanningInformations | null;
}

export interface CargoDescriptionFields_parcels_product_attachments_uploader {
  name: string | null;
}

export interface CargoDescriptionFields_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: CargoDescriptionFields_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface CargoDescriptionFields_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface CargoDescriptionFields_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: CargoDescriptionFields_parcels_product_attachments[] | null;
  hsCodes: CargoDescriptionFields_parcels_product_hsCodes[] | null;
}

export interface CargoDescriptionFields_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: CargoDescriptionFields_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface CargoDescriptionFields {
  arrivalOptions: CargoDescriptionFields_arrivalOptions | null;
  containers: CargoDescriptionFields_containers[] | null;
  departureOptions: CargoDescriptionFields_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: CargoDescriptionFields_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CarrierFields
// ====================================================

export interface CarrierFields {
  id: string;
  carrierType: CarrierTypeEnum;
  naccsCode: string;
  name: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChannelFields
// ====================================================

export interface ChannelFields_channelMessages_channel {
  id: string;
}

export interface ChannelFields_channelMessages_file_uploader {
  name: string | null;
}

export interface ChannelFields_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: ChannelFields_channelMessages_file_uploader | null;
  url: string | null;
}

export interface ChannelFields_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface ChannelFields_channelMessages_sender {
  avatar: ChannelFields_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface ChannelFields_channelMessages {
  channel: ChannelFields_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: ChannelFields_channelMessages_file | null;
  id: string;
  sender: ChannelFields_channelMessages_sender;
  shipmentId: string;
}

export interface ChannelFields_lastMessage_channel {
  id: string;
}

export interface ChannelFields_lastMessage_file_uploader {
  name: string | null;
}

export interface ChannelFields_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: ChannelFields_lastMessage_file_uploader | null;
  url: string | null;
}

export interface ChannelFields_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface ChannelFields_lastMessage_sender {
  avatar: ChannelFields_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface ChannelFields_lastMessage {
  channel: ChannelFields_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: ChannelFields_lastMessage_file | null;
  id: string;
  sender: ChannelFields_lastMessage_sender;
  shipmentId: string;
}

export interface ChannelFields_partnerMembers_partner {
  id: string;
  name: string;
}

export interface ChannelFields_partnerMembers {
  id: string;
  partner: ChannelFields_partnerMembers_partner;
}

export interface ChannelFields {
  channelMessages: ChannelFields_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: ChannelFields_lastMessage | null;
  partnerMembers: ChannelFields_partnerMembers[] | null;
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChannelMessageFields
// ====================================================

export interface ChannelMessageFields_channel {
  id: string;
}

export interface ChannelMessageFields_file_uploader {
  name: string | null;
}

export interface ChannelMessageFields_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: ChannelMessageFields_file_uploader | null;
  url: string | null;
}

export interface ChannelMessageFields_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface ChannelMessageFields_sender {
  avatar: ChannelMessageFields_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface ChannelMessageFields {
  channel: ChannelMessageFields_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: ChannelMessageFields_file | null;
  id: string;
  sender: ChannelMessageFields_sender;
  shipmentId: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactFields
// ====================================================

export interface ContactFields_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ContactFields_address_country {
  id: string;
  nameTranslations: ContactFields_address_country_nameTranslations;
  unLocode: string;
}

export interface ContactFields_address {
  city: string | null;
  country: ContactFields_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface ContactFields_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ContactFields_country {
  id: string;
  nameTranslations: ContactFields_country_nameTranslations;
  unLocode: string;
}

export interface ContactFields_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ContactFields_customerOrganization_address_country {
  id: string;
  nameTranslations: ContactFields_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface ContactFields_customerOrganization_address {
  city: string | null;
  country: ContactFields_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface ContactFields_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ContactFields_customerOrganization {
  address: ContactFields_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: ContactFields_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface ContactFields {
  address: ContactFields_address | null;
  country: ContactFields_country | null;
  customerOrganization: ContactFields_customerOrganization;
  email: string | null;
  faxNumber: string | null;
  id: string;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CountryFields
// ====================================================

export interface CountryFields_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface CountryFields {
  id: string;
  nameTranslations: CountryFields_nameTranslations;
  unLocode: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CustomerFields
// ====================================================

export interface CustomerFields_organization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface CustomerFields_organization_address_country {
  id: string;
  nameTranslations: CustomerFields_organization_address_country_nameTranslations;
  unLocode: string;
}

export interface CustomerFields_organization_address {
  city: string | null;
  country: CustomerFields_organization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface CustomerFields_organization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface CustomerFields_organization {
  address: CustomerFields_organization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: CustomerFields_organization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface CustomerFields {
  email: string | null;
  hiddenAt: any | null;
  id: string | null;
  language: AvailableLocalesEnum | null;
  name: string | null;
  phoneNumber: string | null;
  customerOrganizationId: string;
  organization: CustomerFields_organization;
  status: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CustomerLocationFields
// ====================================================

export interface CustomerLocationFields_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface CustomerLocationFields_country {
  id: string;
  nameTranslations: CustomerLocationFields_country_nameTranslations;
  unLocode: string;
}

export interface CustomerLocationFields_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface CustomerLocationFields {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: CustomerLocationFields_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: CustomerLocationFields_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CustomerOrganizationFields
// ====================================================

export interface CustomerOrganizationFields_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface CustomerOrganizationFields_address_country {
  id: string;
  nameTranslations: CustomerOrganizationFields_address_country_nameTranslations;
  unLocode: string;
}

export interface CustomerOrganizationFields_address {
  city: string | null;
  country: CustomerOrganizationFields_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface CustomerOrganizationFields_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface CustomerOrganizationFields {
  address: CustomerOrganizationFields_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: CustomerOrganizationFields_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FullAddressFields
// ====================================================

export interface FullAddressFields_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface FullAddressFields_country {
  id: string;
  nameTranslations: FullAddressFields_country_nameTranslations;
  unLocode: string;
}

export interface FullAddressFields {
  city: string | null;
  country: FullAddressFields_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InquiryFields
// ====================================================

export interface InquiryFields_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface InquiryFields_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface InquiryFields_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: InquiryFields_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface InquiryFields_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface InquiryFields_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: InquiryFields_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: InquiryFields_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface InquiryFields_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface InquiryFields_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface InquiryFields_assignedOperator {
  avatar: InquiryFields_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface InquiryFields_attachments_uploader {
  name: string | null;
}

export interface InquiryFields_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: InquiryFields_attachments_uploader | null;
  url: string | null;
}

export interface InquiryFields_billItems_partner {
  id: string;
  code: string;
}

export interface InquiryFields_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: InquiryFields_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface InquiryFields_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface InquiryFields_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface InquiryFields_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface InquiryFields_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: InquiryFields_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: InquiryFields_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface InquiryFields_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface InquiryFields_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface InquiryFields_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface InquiryFields_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: InquiryFields_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: InquiryFields_cargoDescription_departureOptions_vanningInformations | null;
}

export interface InquiryFields_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface InquiryFields_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: InquiryFields_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface InquiryFields_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface InquiryFields_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: InquiryFields_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: InquiryFields_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface InquiryFields_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: InquiryFields_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface InquiryFields_cargoDescription {
  arrivalOptions: InquiryFields_cargoDescription_arrivalOptions | null;
  containers: InquiryFields_cargoDescription_containers[] | null;
  departureOptions: InquiryFields_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: InquiryFields_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface InquiryFields_channelList_channelMessages_channel {
  id: string;
}

export interface InquiryFields_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface InquiryFields_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: InquiryFields_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface InquiryFields_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface InquiryFields_channelList_channelMessages_sender {
  avatar: InquiryFields_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface InquiryFields_channelList_channelMessages {
  channel: InquiryFields_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: InquiryFields_channelList_channelMessages_file | null;
  id: string;
  sender: InquiryFields_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface InquiryFields_channelList_lastMessage_channel {
  id: string;
}

export interface InquiryFields_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface InquiryFields_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: InquiryFields_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface InquiryFields_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface InquiryFields_channelList_lastMessage_sender {
  avatar: InquiryFields_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface InquiryFields_channelList_lastMessage {
  channel: InquiryFields_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: InquiryFields_channelList_lastMessage_file | null;
  id: string;
  sender: InquiryFields_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface InquiryFields_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface InquiryFields_channelList_partnerMembers {
  id: string;
  partner: InquiryFields_channelList_partnerMembers_partner;
}

export interface InquiryFields_channelList {
  channelMessages: InquiryFields_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: InquiryFields_channelList_lastMessage | null;
  partnerMembers: InquiryFields_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface InquiryFields_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface InquiryFields_customerOrganization_address_country {
  id: string;
  nameTranslations: InquiryFields_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface InquiryFields_customerOrganization_address {
  city: string | null;
  country: InquiryFields_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface InquiryFields_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface InquiryFields_customerOrganization {
  address: InquiryFields_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: InquiryFields_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface InquiryFields_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface InquiryFields_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface InquiryFields_departureCustomerLocation_country {
  id: string;
  nameTranslations: InquiryFields_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface InquiryFields_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface InquiryFields_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: InquiryFields_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: InquiryFields_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface InquiryFields_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface InquiryFields_followers {
  id: string | null;
}

export interface InquiryFields_lastPublicChannelMessage_channel {
  id: string;
}

export interface InquiryFields_lastPublicChannelMessage_file_uploader {
  name: string | null;
}

export interface InquiryFields_lastPublicChannelMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: InquiryFields_lastPublicChannelMessage_file_uploader | null;
  url: string | null;
}

export interface InquiryFields_lastPublicChannelMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface InquiryFields_lastPublicChannelMessage_sender {
  avatar: InquiryFields_lastPublicChannelMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface InquiryFields_lastPublicChannelMessage {
  channel: InquiryFields_lastPublicChannelMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: InquiryFields_lastPublicChannelMessage_file | null;
  id: string;
  sender: InquiryFields_lastPublicChannelMessage_sender;
  shipmentId: string;
}

export interface InquiryFields_truckingDetails {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface InquiryFields {
  arrivalAddress: InquiryFields_arrivalAddress | null;
  arrivalCustomerLocation: InquiryFields_arrivalCustomerLocation | null;
  arrivalPlace: InquiryFields_arrivalPlace | null;
  assignedOperator: InquiryFields_assignedOperator | null;
  attachments: InquiryFields_attachments[] | null;
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: InquiryFields_billItems[] | null;
  blMetaData: InquiryFields_blMetaData | null;
  cargoDescription: InquiryFields_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoType: CargoTypeEnum | null;
  channelList: InquiryFields_channelList[];
  createdAt: any | null;
  customerOrganization: InquiryFields_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureAddress: InquiryFields_departureAddress | null;
  departureCustomerLocation: InquiryFields_departureCustomerLocation | null;
  departurePlace: InquiryFields_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  followers: InquiryFields_followers[];
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  isFirst: boolean | null;
  lastPublicChannelMessage: InquiryFields_lastPublicChannelMessage | null;
  organizationPaymentTerms: string | null;
  priority: number | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  quotedAt: any | null;
  reference: string | null;
  showTotal: boolean | null;
  status: InquiryStatusEnum;
  taxRate: number | null;
  transportationType: TransportationTypeEnum | null;
  truckingDetails: InquiryFields_truckingDetails | null;
  updatedAt: any | null;
  usdJpyExchangeRate: number | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MilestoneFields
// ====================================================

export interface MilestoneFields_details_containerDetails {
  containerNumber: string | null;
}

export interface MilestoneFields_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: MilestoneFields_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface MilestoneFields_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface MilestoneFields_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: MilestoneFields_devanningDetails_container_deliveryPlaces[] | null;
}

export interface MilestoneFields_devanningDetails {
  container: MilestoneFields_devanningDetails_container | null;
}

export interface MilestoneFields_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface MilestoneFields_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface MilestoneFields_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface MilestoneFields_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface MilestoneFields_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface MilestoneFields {
  deliveryTime: any | null;
  details: MilestoneFields_details | null;
  devanningDate: any | null;
  devanningDetails: MilestoneFields_devanningDetails | null;
  doneDates: MilestoneFields_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: MilestoneFields_pod | null;
  pol: MilestoneFields_pol | null;
  shipmentId: string | null;
  truckingDetails: MilestoneFields_truckingDetails | null;
  updatedAt: any | null;
  vessel: MilestoneFields_vessel | null;
  vesselId: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NaccsContactFields
// ====================================================

export interface NaccsContactFields_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface NaccsContactFields_address_country {
  id: string;
  nameTranslations: NaccsContactFields_address_country_nameTranslations;
  unLocode: string;
}

export interface NaccsContactFields_address {
  city: string | null;
  country: NaccsContactFields_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface NaccsContactFields {
  address: NaccsContactFields_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NaccsIdaFields
// ====================================================

export interface NaccsIdaFields_consignee_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface NaccsIdaFields_consignee_address_country {
  id: string;
  nameTranslations: NaccsIdaFields_consignee_address_country_nameTranslations;
  unLocode: string;
}

export interface NaccsIdaFields_consignee_address {
  city: string | null;
  country: NaccsIdaFields_consignee_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface NaccsIdaFields_consignee {
  address: NaccsIdaFields_consignee_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface NaccsIdaFields_importCertificates {
  code: string | null;
  number: string | null;
}

export interface NaccsIdaFields_shipper_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface NaccsIdaFields_shipper_address_country {
  id: string;
  nameTranslations: NaccsIdaFields_shipper_address_country_nameTranslations;
  unLocode: string;
}

export interface NaccsIdaFields_shipper_address {
  city: string | null;
  country: NaccsIdaFields_shipper_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface NaccsIdaFields_shipper {
  address: NaccsIdaFields_shipper_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface NaccsIdaFields {
  awbNumber: string | null;
  blNumber: string[] | null;
  bondedArea: string | null;
  consignee: NaccsIdaFields_consignee | null;
  customsApplicationDate: any | null;
  declarationType: NaccsDeclarationTypeEnum | null;
  depositPaymentNumber: string | null;
  dueDateExtensionType: NaccsDueDateExtensionTypeEnum | null;
  evaluation: NaccsEvaluationEnum | null;
  existingAssessmentNumbers: string[] | null;
  incoterms: IncotermsTypeEnum | null;
  importCertificates: NaccsIdaFields_importCertificates[] | null;
  insuranceCoverage: string | null;
  insuranceCurrency: string | null;
  insurancePrice: string | null;
  insuranceType: NaccsInsuranceTypeEnum | null;
  invoiceCurrency: string | null;
  invoiceNumber: string | null;
  invoicePrice: string | null;
  invoiceType: NaccsInvoiceTypeEnum | null;
  mawbNumber: string | null;
  otherRegulations: NaccsImportRegulationCodeEnum[] | null;
  paymentMethod: NaccsPaymentMethodEnum | null;
  realTimeBankAccount: string | null;
  remarkFromShipper: string | null;
  shipper: NaccsIdaFields_shipper | null;
  shipperConsigneeStandardCode: string | null;
  shipperReferenceNumber: string | null;
  shipperSectionCode: string | null;
  tradingType: number | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NotificationFields
// ====================================================

export interface NotificationFields_subject {
  id: string;
  subjectType: string;
  shipmentId: string | null;
  shipmentStatus: string | null;
}

export interface NotificationFields {
  id: string;
  content: string | null;
  createdAt: any | null;
  notificationType: string;
  status: NotificationStatusEnum;
  subject: NotificationFields_subject | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OperatorFields
// ====================================================

export interface OperatorFields_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface OperatorFields {
  avatar: OperatorFields_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PaginationFields
// ====================================================

export interface PaginationFields {
  totalCount: number;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ParcelFields
// ====================================================

export interface ParcelFields_product_attachments_uploader {
  name: string | null;
}

export interface ParcelFields_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: ParcelFields_product_attachments_uploader | null;
  url: string | null;
}

export interface ParcelFields_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface ParcelFields_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: ParcelFields_product_attachments[] | null;
  hsCodes: ParcelFields_product_hsCodes[] | null;
}

export interface ParcelFields {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: ParcelFields_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PartnerFields
// ====================================================

export interface PartnerFields_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface PartnerFields_address_country {
  id: string;
  nameTranslations: PartnerFields_address_country_nameTranslations;
  unLocode: string;
}

export interface PartnerFields_address {
  city: string | null;
  country: PartnerFields_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface PartnerFields_members_partner {
  id: string;
}

export interface PartnerFields_members {
  deletedAt: any | null;
  email: string;
  id: string;
  locale: AvailableLocalesEnum;
  name: string;
  partner: PartnerFields_members_partner;
  phoneNumber: string | null;
}

export interface PartnerFields {
  address: PartnerFields_address | null;
  code: string;
  deletedAt: any | null;
  faxNumber: string | null;
  id: string;
  name: string;
  normalizedName: string | null;
  note: string | null;
  /**
   * List our various Partner Members
   */
  members: PartnerFields_members[] | null;
  phoneNumber: string | null;
  url: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PartnerMemberFields
// ====================================================

export interface PartnerMemberFields_partner {
  id: string;
}

export interface PartnerMemberFields {
  deletedAt: any | null;
  email: string;
  id: string;
  locale: AvailableLocalesEnum;
  name: string;
  partner: PartnerMemberFields_partner;
  phoneNumber: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PartyDetailsFields
// ====================================================

export interface PartyDetailsFields {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PlaceFields
// ====================================================

export interface PlaceFields {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductFields
// ====================================================

export interface ProductFields_attachments_uploader {
  name: string | null;
}

export interface ProductFields_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: ProductFields_attachments_uploader | null;
  url: string | null;
}

export interface ProductFields_hsCodes {
  code: string | null;
  country: string | null;
}

export interface ProductFields {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: ProductFields_attachments[] | null;
  hsCodes: ProductFields_hsCodes[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QuoteDetailsFields
// ====================================================

export interface QuoteDetailsFields_extra_billItems_partner {
  id: string;
  code: string;
}

export interface QuoteDetailsFields_extra_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: QuoteDetailsFields_extra_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface QuoteDetailsFields_extra {
  billItems: QuoteDetailsFields_extra_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface QuoteDetailsFields_arrivalDrayage_billItems_partner {
  id: string;
  code: string;
}

export interface QuoteDetailsFields_arrivalDrayage_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: QuoteDetailsFields_arrivalDrayage_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface QuoteDetailsFields_arrivalDrayage {
  billItems: QuoteDetailsFields_arrivalDrayage_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface QuoteDetailsFields_arrivalTrucking_billItems_partner {
  id: string;
  code: string;
}

export interface QuoteDetailsFields_arrivalTrucking_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: QuoteDetailsFields_arrivalTrucking_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface QuoteDetailsFields_arrivalTrucking {
  billItems: QuoteDetailsFields_arrivalTrucking_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface QuoteDetailsFields_departureDrayage_billItems_partner {
  id: string;
  code: string;
}

export interface QuoteDetailsFields_departureDrayage_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: QuoteDetailsFields_departureDrayage_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface QuoteDetailsFields_departureDrayage {
  billItems: QuoteDetailsFields_departureDrayage_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface QuoteDetailsFields_departureTrucking_billItems_partner {
  id: string;
  code: string;
}

export interface QuoteDetailsFields_departureTrucking_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: QuoteDetailsFields_departureTrucking_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface QuoteDetailsFields_departureTrucking {
  billItems: QuoteDetailsFields_departureTrucking_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface QuoteDetailsFields_transport_billItems_partner {
  id: string;
  code: string;
}

export interface QuoteDetailsFields_transport_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: QuoteDetailsFields_transport_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface QuoteDetailsFields_transport {
  billItems: QuoteDetailsFields_transport_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

export interface QuoteDetailsFields {
  extra: QuoteDetailsFields_extra;
  arrivalDrayage: QuoteDetailsFields_arrivalDrayage;
  arrivalTrucking: QuoteDetailsFields_arrivalTrucking;
  departureDrayage: QuoteDetailsFields_departureDrayage;
  departureTrucking: QuoteDetailsFields_departureTrucking;
  transport: QuoteDetailsFields_transport;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QuoteHistoryFields
// ====================================================

export interface QuoteHistoryFields {
  name: string;
  url: string;
  date: any;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QuoteSectionFields
// ====================================================

export interface QuoteSectionFields_billItems_partner {
  id: string;
  code: string;
}

export interface QuoteSectionFields_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: QuoteSectionFields_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface QuoteSectionFields {
  billItems: QuoteSectionFields_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QuoteTemplateFields
// ====================================================

export interface QuoteTemplateFields {
  id: string;
  name: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RequestedContainerFields
// ====================================================

export interface RequestedContainerFields {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SenderFields
// ====================================================

export interface SenderFields_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface SenderFields {
  avatar: SenderFields_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ShipmentActivityFields
// ====================================================

export interface ShipmentActivityFields_milestones_details_containerDetails {
  containerNumber: string | null;
}

export interface ShipmentActivityFields_milestones_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: ShipmentActivityFields_milestones_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface ShipmentActivityFields_milestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface ShipmentActivityFields_milestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: ShipmentActivityFields_milestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface ShipmentActivityFields_milestones_devanningDetails {
  container: ShipmentActivityFields_milestones_devanningDetails_container | null;
}

export interface ShipmentActivityFields_milestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface ShipmentActivityFields_milestones_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentActivityFields_milestones_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentActivityFields_milestones_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface ShipmentActivityFields_milestones_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface ShipmentActivityFields_milestones {
  deliveryTime: any | null;
  details: ShipmentActivityFields_milestones_details | null;
  devanningDate: any | null;
  devanningDetails: ShipmentActivityFields_milestones_devanningDetails | null;
  doneDates: ShipmentActivityFields_milestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: ShipmentActivityFields_milestones_pod | null;
  pol: ShipmentActivityFields_milestones_pol | null;
  shipmentId: string | null;
  truckingDetails: ShipmentActivityFields_milestones_truckingDetails | null;
  updatedAt: any | null;
  vessel: ShipmentActivityFields_milestones_vessel | null;
  vesselId: string | null;
}

export interface ShipmentActivityFields {
  customerRole: CustomerRoleEnum | null;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  milestones: ShipmentActivityFields_milestones[] | null;
  status: ShipmentStatusEnum;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ShipmentBaseFields
// ====================================================

export interface ShipmentBaseFields_arrivalAddress {
  addressComponents: any | null;
}

export interface ShipmentBaseFields_arrivalPlace {
  code: string | null;
  countryCode: string | null;
  name: string | null;
}

export interface ShipmentBaseFields_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface ShipmentBaseFields_assignedOperator {
  avatar: ShipmentBaseFields_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface ShipmentBaseFields_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface ShipmentBaseFields_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ShipmentBaseFields_customerOrganization_address_country {
  id: string;
  nameTranslations: ShipmentBaseFields_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface ShipmentBaseFields_customerOrganization_address {
  city: string | null;
  country: ShipmentBaseFields_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface ShipmentBaseFields_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ShipmentBaseFields_customerOrganization {
  address: ShipmentBaseFields_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: ShipmentBaseFields_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface ShipmentBaseFields_departureAddress {
  addressComponents: any | null;
}

export interface ShipmentBaseFields_departurePlace {
  code: string | null;
  countryCode: string | null;
  name: string | null;
}

export interface ShipmentBaseFields_followers {
  id: string | null;
}

export interface ShipmentBaseFields_shipper {
  id: string | null;
}

export interface ShipmentBaseFields_trackableMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface ShipmentBaseFields_trackableMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: ShipmentBaseFields_trackableMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface ShipmentBaseFields_trackableMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface ShipmentBaseFields_trackableMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: ShipmentBaseFields_trackableMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface ShipmentBaseFields_trackableMilestone_devanningDetails {
  container: ShipmentBaseFields_trackableMilestone_devanningDetails_container | null;
}

export interface ShipmentBaseFields_trackableMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface ShipmentBaseFields_trackableMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentBaseFields_trackableMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentBaseFields_trackableMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface ShipmentBaseFields_trackableMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface ShipmentBaseFields_trackableMilestone {
  deliveryTime: any | null;
  details: ShipmentBaseFields_trackableMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: ShipmentBaseFields_trackableMilestone_devanningDetails | null;
  doneDates: ShipmentBaseFields_trackableMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: ShipmentBaseFields_trackableMilestone_pod | null;
  pol: ShipmentBaseFields_trackableMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: ShipmentBaseFields_trackableMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: ShipmentBaseFields_trackableMilestone_vessel | null;
  vesselId: string | null;
}

export interface ShipmentBaseFields {
  arrivalAddress: ShipmentBaseFields_arrivalAddress | null;
  arrivalPlace: ShipmentBaseFields_arrivalPlace | null;
  assignedOperator: ShipmentBaseFields_assignedOperator | null;
  blMetaData: ShipmentBaseFields_blMetaData | null;
  customerOrganization: ShipmentBaseFields_customerOrganization;
  customerReference: string | null;
  departureAddress: ShipmentBaseFields_departureAddress | null;
  departurePlace: ShipmentBaseFields_departurePlace | null;
  followers: ShipmentBaseFields_followers[];
  id: string;
  isProblem: boolean | null;
  locked: boolean | null;
  reference: string | null;
  shipper: ShipmentBaseFields_shipper | null;
  status: ShipmentStatusEnum;
  statusComment: string | null;
  trackedBlNumber: string | null;
  trackableMilestone: ShipmentBaseFields_trackableMilestone | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ShipmentDocumentFields
// ====================================================

export interface ShipmentDocumentFields_data_billItems {
  id: string;
  category: string | null;
  description: string | null;
  displayCurrency: CurrencyEnum;
  quantity: number | null;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  unitPrice: number | null;
}

export interface ShipmentDocumentFields_data_containerNumbers {
  containerCount: number | null;
  containerNumber: string | null;
  containerType: ContainerSizeEnum | null;
  sealNumber: string | null;
}

export interface ShipmentDocumentFields_data_delegatedSteps {
  delegatedStep: string | null;
  taxType: TaxTypeEnumBase | null;
}

export interface ShipmentDocumentFields_data {
  airCarrier: string | null;
  arrangementRemarks: string | null;
  assignedOperator: string | null;
  attachedDocuments: AttachedDocumentEnum[] | null;
  billItems: ShipmentDocumentFields_data_billItems[] | null;
  blNumberOfOriginals: number | null;
  blPlaceOfIssuance: string | null;
  blType: BlTypeEnum | null;
  bookingNumber: string | null;
  cargoCollectionAddress: string | null;
  cargoCollectionContact: string | null;
  cargoPickupDatetime: any | null;
  cargoRemarks: string | null;
  freeTime: any | null;
  clientRemarks: string | null;
  collectionAddress: string | null;
  collectionContact: string | null;
  collectionContactInformation: string | null;
  collectionName: string | null;
  collectionPhone: string | null;
  collectionPreferredDatetime: any | null;
  consolidator: string | null;
  containerNumbers: ShipmentDocumentFields_data_containerNumbers[] | null;
  customerAddress: string | null;
  customerBankAccountNumber: string | null;
  customerCompanyNumber: string | null;
  /**
   * 包括 / 付保なし / 個別
   */
  customerInsurance: CustomerInsuranceEnum | null;
  customerInsuranceNumber: string | null;
  customerName: string | null;
  customerPostponementNumber: string | null;
  customerShipperConsigneeStandardCode: string | null;
  customsArrivalDate: any | null;
  customsClearanceDate: any | null;
  customsClearanceDesiredDate: any | null;
  customsLocation: string | null;
  customsPickupDate: any | null;
  cyCfsCutDate: any | null;
  /**
   * O - X
   */
  dangerous: boolean | null;
  declaredValue: string | null;
  delegatedSteps: ShipmentDocumentFields_data_delegatedSteps[] | null;
  deliveryLocation: string | null;
  deliveryPlaceRemarks: string | null;
  deliveryRemarks: string | null;
  descriptionOfGoods: string | null;
  /**
   * 希望する・希望しない
   */
  dispatchArrangements: boolean | null;
  dutyTaxPaymentMethod: DutyTaxPaymentMethodEnum | null;
  /**
   * 希望する・希望しない
   */
  emptyVanPickup: boolean | null;
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  /**
   * 希望する・希望しない
   */
  exportRegistration: boolean | null;
  finalCurrency: CurrencyEnum | null;
  finalDestination: string | null;
  finalRemarks: string | null;
  flightNumber: string | null;
  freightDeliveryAddress: string | null;
  freightDeliveryContact: string | null;
  freightDeliveryContactInformation: string | null;
  freightDeliveryDatetime: any | null;
  freightDeliveryName: string | null;
  freightRemarks: string | null;
  grossVolume: number | null;
  grossWeight: number | null;
  houseBlNumber: string | null;
  hsCode: string | null;
  importDestinationAddress: string | null;
  importDestinationPhone: string | null;
  issuanceDate: any | null;
  masterBlNumber: string | null;
  /**
   * O - X
   */
  motorGenerator: boolean | null;
  /**
   * 希望する・希望しない
   */
  naccsAclDockReport: boolean | null;
  naccsCode: string | null;
  /**
   * 希望する・希望しない
   */
  naccsHdl: boolean | null;
  /**
   * free text / なし
   */
  otherLaws: string | null;
  packagingQuantity: number | null;
  packaging: string | null;
  pickupDate: any | null;
  pickupPlaceRemarks: string | null;
  pickupRemarks: string | null;
  placeOfDelivery: string | null;
  placeOfReceipt: string | null;
  portOfDischarge: string | null;
  portOfLoading: string | null;
  preCarriageBy: string | null;
  /**
   * O - X
   */
  preCooling: boolean | null;
  /**
   * 希望する・希望しない
   */
  preliminaryFilings: boolean | null;
  presetTemperature: string | null;
  priceCategorization: PriceCategorization | null;
  /**
   * O - X
   */
  proofOfOrigin: boolean | null;
  quantityOfContainers: number | null;
  remarks: string | null;
  /**
   * X / Free Text
   */
  requiresWarehouseWork: string | null;
  seaCarrier: string | null;
  shipmentAlsoNotifyName: string | null;
  shipmentAlsoNotifyAddress: string | null;
  shipmentAlsoNotifyEmail: string | null;
  shipmentAlsoNotifyPhone: string | null;
  shipmentConsigneeAccountNumber: string | null;
  shipmentConsigneeAddress: string | null;
  shipmentConsigneeEmail: string | null;
  shipmentConsigneeName: string | null;
  shipmentConsigneePhone: string | null;
  shipmentCustomerRole: CustomerRoleEnum | null;
  shipmentDeliveryAgentAccountNumber: string | null;
  shipmentDeliveryAgentAddress: string | null;
  shipmentDeliveryAgentEmail: string | null;
  shipmentDeliveryAgentName: string | null;
  shipmentDeliveryAgentPhone: string | null;
  shipmentExchangeRate: number | null;
  shipmentIncoterms: IncotermsTypeEnum | null;
  shipmentInvoiceNumber: string | null;
  shipmentNotifyAccountNumber: string | null;
  shipmentNotifyAddress: string | null;
  shipmentNotifyEmail: string | null;
  shipmentNotifyName: string | null;
  shipmentNotifyPhone: string | null;
  shipmentPaymentPlace: string | null;
  shipmentPaymentTerms: PaymentTermsTypeEnum | null;
  shipmentReference: string | null;
  shipmentShipperAccountNumber: string | null;
  shipmentShipperAddress: string | null;
  shipmentShipperEmail: string | null;
  shipmentShipperName: string | null;
  shipmentShipperPhone: string | null;
  /**
   * 希望する・希望しない
   */
  shippingCompanyChargeAdvance: boolean | null;
  shippingMarks: string | null;
  shippingPlaceRemarks: string | null;
  shippingRemarks: string | null;
  /**
   * 免税・課税
   */
  taxType: TaxTypeEnumBase | null;
  transportCargoType: TransportationCargoTypeEnum | null;
  transportationType: TransportationTypeEnum | null;
  truckChassisType: AxleTypeEnum | null;
  truckType: TruckTypeEnum | null;
  vanningLocation: string | null;
  vanningLocationAddress: string | null;
  ventilation: string | null;
  vesselName: string | null;
  voyageNumber: string | null;
  /**
   * O - X
   */
  weightCalibration: boolean | null;
}

export interface ShipmentDocumentFields_shipment_customerOrganization {
  id: string;
}

export interface ShipmentDocumentFields_shipment {
  customerOrganization: ShipmentDocumentFields_shipment_customerOrganization;
  id: string;
  transportationType: TransportationTypeEnum | null;
}

export interface ShipmentDocumentFields {
  data: ShipmentDocumentFields_data;
  documentType: DocumentTypeEnum;
  id: string;
  shipment: ShipmentDocumentFields_shipment;
  title: string | null;
  updatedAt: any;
  url: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ShipmentFields
// ====================================================

export interface ShipmentFields_arrivalAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface ShipmentFields_arrivalCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ShipmentFields_arrivalCustomerLocation_country {
  id: string;
  nameTranslations: ShipmentFields_arrivalCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface ShipmentFields_arrivalCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface ShipmentFields_arrivalCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: ShipmentFields_arrivalCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: ShipmentFields_arrivalCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface ShipmentFields_arrivalPlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentFields_assignedOperator_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface ShipmentFields_assignedOperator {
  avatar: ShipmentFields_assignedOperator_avatar | null;
  email: string;
  emailNotifications: boolean;
  firstName: string | null;
  id: string;
  language: AvailableLocalesEnum | null;
  lastName: string | null;
  name: string | null;
  phoneNumber: string | null;
}

export interface ShipmentFields_billItems_partner {
  id: string;
  code: string;
}

export interface ShipmentFields_billItems {
  billId: string | null;
  billItemType: string | null;
  category: string | null;
  confirmed: boolean;
  cost: number;
  costJpy: number | null;
  costWithTax: number;
  currency: string | null;
  description: string | null;
  id: string;
  isPrivate: boolean;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  partner: ShipmentFields_billItems_partner | null;
  quantity: number | null;
  shipmentId: string;
  taxRate: number | null;
  taxType: TaxTypeEnum;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
}

export interface ShipmentFields_blMetaData {
  blNumber: string | null;
  blType: BlTypeEnum | null;
  houseBlNumber: string | null;
  issueDate: any | null;
  issuePlace: string | null;
  numberOfCopy: number | null;
  numberOfOriginal: number | null;
}

export interface ShipmentFields_cargoDescription_arrivalOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface ShipmentFields_cargoDescription_arrivalOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface ShipmentFields_cargoDescription_arrivalOptions {
  drayage: boolean | null;
  truckingInformations: ShipmentFields_cargoDescription_arrivalOptions_truckingInformations | null;
  vanningInformations: ShipmentFields_cargoDescription_arrivalOptions_vanningInformations | null;
}

export interface ShipmentFields_cargoDescription_containers {
  contentNetWeight: number | null;
  requestedContainerCount: number | null;
  requestedContainerType: string | null;
}

export interface ShipmentFields_cargoDescription_departureOptions_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface ShipmentFields_cargoDescription_departureOptions_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface ShipmentFields_cargoDescription_departureOptions {
  drayage: boolean | null;
  truckingInformations: ShipmentFields_cargoDescription_departureOptions_truckingInformations | null;
  vanningInformations: ShipmentFields_cargoDescription_departureOptions_vanningInformations | null;
}

export interface ShipmentFields_cargoDescription_parcels_product_attachments_uploader {
  name: string | null;
}

export interface ShipmentFields_cargoDescription_parcels_product_attachments {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: ShipmentFields_cargoDescription_parcels_product_attachments_uploader | null;
  url: string | null;
}

export interface ShipmentFields_cargoDescription_parcels_product_hsCodes {
  code: string | null;
  country: string | null;
}

export interface ShipmentFields_cargoDescription_parcels_product {
  id: string;
  name: string | null;
  sku: string | null;
  category: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  currency: string | null;
  serialNumber: string | null;
  url: string | null;
  price: number | null;
  countryOfOrigin: string | null;
  editable: boolean | null;
  attachments: ShipmentFields_cargoDescription_parcels_product_attachments[] | null;
  hsCodes: ShipmentFields_cargoDescription_parcels_product_hsCodes[] | null;
}

export interface ShipmentFields_cargoDescription_parcels {
  currency: string | null;
  description: string | null;
  grossUnit: string | null;
  grossWeight: number | null;
  height: number | null;
  hsCode: string | null;
  id: string | null;
  length: number | null;
  netWeight: number | null;
  onPallet: boolean | null;
  packagingType: string | null;
  parcelValue: number | null;
  product: ShipmentFields_cargoDescription_parcels_product | null;
  productPrice: number | null;
  productQuantity: number | null;
  quantity: number | null;
  sizeUnit: string | null;
  volume: number | null;
  volumeUnit: string | null;
  width: number | null;
  weightUnit: string | null;
}

export interface ShipmentFields_cargoDescription {
  arrivalOptions: ShipmentFields_cargoDescription_arrivalOptions | null;
  containers: ShipmentFields_cargoDescription_containers[] | null;
  departureOptions: ShipmentFields_cargoDescription_departureOptions | null;
  description: string | null;
  overrideMeasures: boolean;
  parcels: ShipmentFields_cargoDescription_parcels[] | null;
  regulated: boolean;
  totalVolume: number;
  totalWeight: number;
}

export interface ShipmentFields_cargoReleaseContact {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface ShipmentFields_carrier {
  id: string;
  carrierType: CarrierTypeEnum;
  naccsCode: string;
  name: string | null;
}

export interface ShipmentFields_channelList_channelMessages_channel {
  id: string;
}

export interface ShipmentFields_channelList_channelMessages_file_uploader {
  name: string | null;
}

export interface ShipmentFields_channelList_channelMessages_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: ShipmentFields_channelList_channelMessages_file_uploader | null;
  url: string | null;
}

export interface ShipmentFields_channelList_channelMessages_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface ShipmentFields_channelList_channelMessages_sender {
  avatar: ShipmentFields_channelList_channelMessages_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface ShipmentFields_channelList_channelMessages {
  channel: ShipmentFields_channelList_channelMessages_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: ShipmentFields_channelList_channelMessages_file | null;
  id: string;
  sender: ShipmentFields_channelList_channelMessages_sender;
  shipmentId: string;
}

export interface ShipmentFields_channelList_lastMessage_channel {
  id: string;
}

export interface ShipmentFields_channelList_lastMessage_file_uploader {
  name: string | null;
}

export interface ShipmentFields_channelList_lastMessage_file {
  createdAt: any | null;
  dueDate: any | null;
  id: string;
  name: string;
  memo: string | null;
  private: boolean;
  responsibleParty: ResponsiblePartyEnum | null;
  tag: string | null;
  uploadedAt: any | null;
  uploader: ShipmentFields_channelList_lastMessage_file_uploader | null;
  url: string | null;
}

export interface ShipmentFields_channelList_lastMessage_sender_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface ShipmentFields_channelList_lastMessage_sender {
  avatar: ShipmentFields_channelList_lastMessage_sender_avatar | null;
  id: string;
  name: string;
  phoneNumber: string | null;
  senderType: string;
}

export interface ShipmentFields_channelList_lastMessage {
  channel: ShipmentFields_channelList_lastMessage_channel;
  communicationType: CommunicationTypeEnum;
  content: string | null;
  createdAt: any;
  file: ShipmentFields_channelList_lastMessage_file | null;
  id: string;
  sender: ShipmentFields_channelList_lastMessage_sender;
  shipmentId: string;
}

export interface ShipmentFields_channelList_partnerMembers_partner {
  id: string;
  name: string;
}

export interface ShipmentFields_channelList_partnerMembers {
  id: string;
  partner: ShipmentFields_channelList_partnerMembers_partner;
}

export interface ShipmentFields_channelList {
  channelMessages: ShipmentFields_channelList_channelMessages[];
  channelType: ChannelTypeEnum;
  createdAt: any;
  id: string;
  lastMessage: ShipmentFields_channelList_lastMessage | null;
  partnerMembers: ShipmentFields_channelList_partnerMembers[] | null;
  shipmentId: string;
}

export interface ShipmentFields_containerInformation {
  containerNumber: string | null;
  containerReference: string | null;
  containerType: ContainerSizeEnum | null;
}

export interface ShipmentFields_consigneeDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface ShipmentFields_customerOrganization_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ShipmentFields_customerOrganization_address_country {
  id: string;
  nameTranslations: ShipmentFields_customerOrganization_address_country_nameTranslations;
  unLocode: string;
}

export interface ShipmentFields_customerOrganization_address {
  city: string | null;
  country: ShipmentFields_customerOrganization_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface ShipmentFields_customerOrganization_countryName {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ShipmentFields_customerOrganization {
  address: ShipmentFields_customerOrganization_address | null;
  country: string | null;
  countryCode: string | null;
  companyNumber: string | null;
  confirmBeforeCustomApplication: boolean | null;
  countryName: ShipmentFields_customerOrganization_countryName;
  depositPayment: boolean | null;
  depositPaymentNumber: string | null;
  dutyTaxPaymentTerms: DutyTaxPaymentTermsEnum | null;
  exportPaymentTerms: ExportPaymentTermsEnum | null;
  faxNumber: string | null;
  hasInsuranceCoverage: boolean | null;
  hiddenAt: any | null;
  id: string;
  importPaymentTerms: ImportPaymentTermsEnum | null;
  includeSender: boolean;
  insuranceExpiration: any | null;
  insuranceNumber: string | null;
  isFocus: boolean;
  language: LanguageEnum;
  memo: string | null;
  name: string;
  normalizedName: string | null;
  needsInsurance: boolean | null;
  phoneNumber: string | null;
  postalCode: string | null;
  shipperConsigneeStandardCode: string | null;
  url: string | null;
}

export interface ShipmentFields_departureAddress {
  addressComponents: any | null;
  city: string | null;
  country: string | null;
  formattedAddress: string | null;
  fullAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  postalCode: string | null;
  street: string | null;
  url: string | null;
}

export interface ShipmentFields_departureCustomerLocation_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ShipmentFields_departureCustomerLocation_country {
  id: string;
  nameTranslations: ShipmentFields_departureCustomerLocation_country_nameTranslations;
  unLocode: string;
}

export interface ShipmentFields_departureCustomerLocation_gmapsData {
  addressComponents: any | null;
  formattedAddress: string | null;
  latitude: number | null;
  longitude: number | null;
  name: string | null;
  placeId: string | null;
  url: string | null;
}

export interface ShipmentFields_departureCustomerLocation {
  city: string;
  complete: boolean;
  contactName: string | null;
  contactNumber: string | null;
  containerAllowed: boolean | null;
  country: ShipmentFields_departureCustomerLocation_country;
  countryCode: string;
  customerOrganizationId: string;
  fullAddress: string | null;
  gmapsData: ShipmentFields_departureCustomerLocation_gmapsData | null;
  hasCrane: boolean | null;
  hasForklift: boolean | null;
  hasParking: boolean | null;
  id: string;
  memo: string | null;
  name: string;
  region: string | null;
  zipCode: string | null;
}

export interface ShipmentFields_departurePlace {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentFields_milestones_details_containerDetails {
  containerNumber: string | null;
}

export interface ShipmentFields_milestones_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: ShipmentFields_milestones_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface ShipmentFields_milestones_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface ShipmentFields_milestones_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: ShipmentFields_milestones_devanningDetails_container_deliveryPlaces[] | null;
}

export interface ShipmentFields_milestones_devanningDetails {
  container: ShipmentFields_milestones_devanningDetails_container | null;
}

export interface ShipmentFields_milestones_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface ShipmentFields_milestones_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentFields_milestones_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentFields_milestones_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface ShipmentFields_milestones_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface ShipmentFields_milestones {
  deliveryTime: any | null;
  details: ShipmentFields_milestones_details | null;
  devanningDate: any | null;
  devanningDetails: ShipmentFields_milestones_devanningDetails | null;
  doneDates: ShipmentFields_milestones_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: ShipmentFields_milestones_pod | null;
  pol: ShipmentFields_milestones_pol | null;
  shipmentId: string | null;
  truckingDetails: ShipmentFields_milestones_truckingDetails | null;
  updatedAt: any | null;
  vessel: ShipmentFields_milestones_vessel | null;
  vesselId: string | null;
}

export interface ShipmentFields_naccsDocument_ida_consignee_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ShipmentFields_naccsDocument_ida_consignee_address_country {
  id: string;
  nameTranslations: ShipmentFields_naccsDocument_ida_consignee_address_country_nameTranslations;
  unLocode: string;
}

export interface ShipmentFields_naccsDocument_ida_consignee_address {
  city: string | null;
  country: ShipmentFields_naccsDocument_ida_consignee_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface ShipmentFields_naccsDocument_ida_consignee {
  address: ShipmentFields_naccsDocument_ida_consignee_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface ShipmentFields_naccsDocument_ida_importCertificates {
  code: string | null;
  number: string | null;
}

export interface ShipmentFields_naccsDocument_ida_shipper_address_country_nameTranslations {
  en: string | null;
  ja: string | null;
  zh: string | null;
}

export interface ShipmentFields_naccsDocument_ida_shipper_address_country {
  id: string;
  nameTranslations: ShipmentFields_naccsDocument_ida_shipper_address_country_nameTranslations;
  unLocode: string;
}

export interface ShipmentFields_naccsDocument_ida_shipper_address {
  city: string | null;
  country: ShipmentFields_naccsDocument_ida_shipper_address_country | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  /**
   * state/region/prefecture
   */
  prefecture: string | null;
}

export interface ShipmentFields_naccsDocument_ida_shipper {
  address: ShipmentFields_naccsDocument_ida_shipper_address | null;
  name: string | null;
  normalizedName: string | null;
  phoneNumber: string | null;
}

export interface ShipmentFields_naccsDocument_ida {
  awbNumber: string | null;
  blNumber: string[] | null;
  bondedArea: string | null;
  consignee: ShipmentFields_naccsDocument_ida_consignee | null;
  customsApplicationDate: any | null;
  declarationType: NaccsDeclarationTypeEnum | null;
  depositPaymentNumber: string | null;
  dueDateExtensionType: NaccsDueDateExtensionTypeEnum | null;
  evaluation: NaccsEvaluationEnum | null;
  existingAssessmentNumbers: string[] | null;
  incoterms: IncotermsTypeEnum | null;
  importCertificates: ShipmentFields_naccsDocument_ida_importCertificates[] | null;
  insuranceCoverage: string | null;
  insuranceCurrency: string | null;
  insurancePrice: string | null;
  insuranceType: NaccsInsuranceTypeEnum | null;
  invoiceCurrency: string | null;
  invoiceNumber: string | null;
  invoicePrice: string | null;
  invoiceType: NaccsInvoiceTypeEnum | null;
  mawbNumber: string | null;
  otherRegulations: NaccsImportRegulationCodeEnum[] | null;
  paymentMethod: NaccsPaymentMethodEnum | null;
  realTimeBankAccount: string | null;
  remarkFromShipper: string | null;
  shipper: ShipmentFields_naccsDocument_ida_shipper | null;
  shipperConsigneeStandardCode: string | null;
  shipperReferenceNumber: string | null;
  shipperSectionCode: string | null;
  tradingType: number | null;
}

export interface ShipmentFields_naccsDocument {
  ida: ShipmentFields_naccsDocument_ida | null;
}

export interface ShipmentFields_notifyPartyDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface ShipmentFields_shipperDetails {
  name: string | null;
  fullAddress: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  email: string | null;
}

export interface ShipmentFields_trackableMilestone_details_containerDetails {
  containerNumber: string | null;
}

export interface ShipmentFields_trackableMilestone_details {
  /**
   * bl_number/booking number if bl_number is nil
   */
  blNumber: string | null;
  containerDetails: ShipmentFields_trackableMilestone_details_containerDetails | null;
  /**
   * whether drayage has been scheduled
   */
  drayageReserved: boolean | null;
  /**
   * free_text
   */
  eventInfo: string | null;
  /**
   * cy/cfs cut
   */
  eventLocation: string | null;
  /**
   * air_transportation
   */
  flightNumber: string | null;
  /**
   * Client location name
   */
  locationCompanyName: string | null;
  /**
   * Client location P.I.Charge
   */
  locationCompanyPerson: string | null;
  /**
   * Client location phone
   */
  locationCompanyPhone: string | null;
  /**
   * sea_transportation
   */
  vesselName: string | null;
  /**
   * sea_transportation
   */
  voyageNumber: string | null;
}

export interface ShipmentFields_trackableMilestone_devanningDetails_container_deliveryPlaces {
  deliveryDate: any | null;
  deliveryPlace: string | null;
  doneAt: any | null;
  drayageReserved: boolean | null;
}

export interface ShipmentFields_trackableMilestone_devanningDetails_container {
  containerNumber: string | null;
  containerReference: string | null;
  deliveryPlaces: ShipmentFields_trackableMilestone_devanningDetails_container_deliveryPlaces[] | null;
}

export interface ShipmentFields_trackableMilestone_devanningDetails {
  container: ShipmentFields_trackableMilestone_devanningDetails_container | null;
}

export interface ShipmentFields_trackableMilestone_doneDates {
  /**
   * Date and time where event_name has been done
   */
  doneAt: any | null;
  /**
   * Name of the event
   */
  eventName: MilestoneDoneDateEnum;
}

export interface ShipmentFields_trackableMilestone_pod {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentFields_trackableMilestone_pol {
  ccCodeJp: string | null;
  code: string | null;
  countryCode: string | null;
  id: string;
  fullCode: string | null;
  name: string | null;
  normalizedName: string | null;
  placeType: PortTypeEnum | null;
  region: string | null;
}

export interface ShipmentFields_trackableMilestone_truckingDetails {
  companyName: string | null;
  driverName: string | null;
  phoneNumber: string | null;
  truckNumber: string | null;
}

export interface ShipmentFields_trackableMilestone_vessel {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

export interface ShipmentFields_trackableMilestone {
  deliveryTime: any | null;
  details: ShipmentFields_trackableMilestone_details | null;
  devanningDate: any | null;
  devanningDetails: ShipmentFields_trackableMilestone_devanningDetails | null;
  doneDates: ShipmentFields_trackableMilestone_doneDates[];
  estimatedDateOfArrival: any | null;
  estimatedDateOfDeparture: any | null;
  eventDate: any | null;
  id: string;
  milestoneType: MilestoneTypeEnum | null;
  order: number | null;
  pod: ShipmentFields_trackableMilestone_pod | null;
  pol: ShipmentFields_trackableMilestone_pol | null;
  shipmentId: string | null;
  truckingDetails: ShipmentFields_trackableMilestone_truckingDetails | null;
  updatedAt: any | null;
  vessel: ShipmentFields_trackableMilestone_vessel | null;
  vesselId: string | null;
}

export interface ShipmentFields {
  arrivalAddress: ShipmentFields_arrivalAddress | null;
  arrivalCustomerLocation: ShipmentFields_arrivalCustomerLocation | null;
  arrivalPlace: ShipmentFields_arrivalPlace | null;
  assignedOperator: ShipmentFields_assignedOperator | null;
  billingComplete: boolean;
  billItemSubtotal: number | null;
  billItemTotal: number | null;
  billItemTotalCost: number | null;
  /**
   * Gross margin (TOTAL PRICE WITHOUT TAX - COST)
   */
  billItemTotalMargin: number | null;
  billItemTotalNotTaxable: number | null;
  billItemTotalTax: number | null;
  billItemTotalTaxable: number | null;
  billItems: ShipmentFields_billItems[] | null;
  blMetaData: ShipmentFields_blMetaData | null;
  cargoDescription: ShipmentFields_cargoDescription | null;
  cargoInsurance: CargoInsuranceEnum | null;
  cargoReleaseContact: ShipmentFields_cargoReleaseContact | null;
  cargoType: CargoTypeEnum | null;
  carrier: ShipmentFields_carrier | null;
  channelList: ShipmentFields_channelList[];
  containerInformation: ShipmentFields_containerInformation[];
  consigneeDetails: ShipmentFields_consigneeDetails | null;
  createdAt: any | null;
  customerOrganization: ShipmentFields_customerOrganization;
  customerReference: string | null;
  customerRole: CustomerRoleEnum | null;
  customsHandling: CustomsHandlingEnum | null;
  departureAddress: ShipmentFields_departureAddress | null;
  departureCustomerLocation: ShipmentFields_departureCustomerLocation | null;
  departurePlace: ShipmentFields_departurePlace | null;
  desiredArrivalDate: any | null;
  desiredDepartureDate: any | null;
  endFreeTime: any | null;
  /**
   * true if the current user follow the shipment
   */
  followed: boolean;
  id: string;
  incoterm: IncotermsTypeEnum | null;
  inquiryMessage: string | null;
  invoiceNumber: string | null;
  isProblem: boolean | null;
  locked: boolean | null;
  milestones: ShipmentFields_milestones[] | null;
  naccsDocument: ShipmentFields_naccsDocument | null;
  notifyPartyDetails: ShipmentFields_notifyPartyDetails | null;
  organizationPaymentTerms: string | null;
  paymentAsArranged: boolean | null;
  paymentPlace: string | null;
  paymentTerms: PaymentTermsTypeEnum | null;
  quoteAcceptedAt: any | null;
  quoteDueDate: any | null;
  quoteRemark: string | null;
  reference: string | null;
  shipperDetails: ShipmentFields_shipperDetails | null;
  shippingMarks: string | null;
  showTotal: boolean | null;
  status: ShipmentStatusEnum;
  statusComment: string | null;
  taxRate: number | null;
  trackedBlNumber: string | null;
  trackableMilestone: ShipmentFields_trackableMilestone | null;
  transportationType: TransportationTypeEnum | null;
  updatedAt: any | null;
  usdJpyExchangeRate: number | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TaskFields
// ====================================================

export interface TaskFields_assignee_avatar {
  id: string;
  name: string;
  url: string | null;
}

export interface TaskFields_assignee {
  id: string;
  name: string;
  assigneeType: TaskAssigneeTypeEnum;
  avatar: TaskFields_assignee_avatar | null;
}

export interface TaskFields_customerOrganization {
  id: string;
  name: string;
}

export interface TaskFields {
  assignee: TaskFields_assignee | null;
  customerOrganization: TaskFields_customerOrganization;
  deadlineDate: any | null;
  description: string | null;
  doneAt: any | null;
  id: string;
  isPublic: boolean;
  reminderDate: any | null;
  responsibleParty: string;
  shipmentId: string;
  shipmentReference: string;
  shipmentType: string;
  title: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TransportationOptionFields
// ====================================================

export interface TransportationOptionFields_truckingInformations {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

export interface TransportationOptionFields_vanningInformations {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

export interface TransportationOptionFields {
  drayage: boolean | null;
  truckingInformations: TransportationOptionFields_truckingInformations | null;
  vanningInformations: TransportationOptionFields_vanningInformations | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TruckingDetailFields
// ====================================================

export interface TruckingDetailFields {
  cargoForkliftable: boolean;
  cargoStackable: boolean;
  cargoStackableSize: number | null;
  truckCount: number | null;
  truckType: TruckTypeEnum | null;
  truckingArrangement: boolean | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VanningDetailFields
// ====================================================

export interface VanningDetailFields {
  cost: number | null;
  currency: string | null;
  needsVanning: boolean | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VesselFields
// ====================================================

export interface VesselFields {
  id: string;
  name: string;
  naccsCode: string | null;
  imo: string | null;
  mmsi: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WsNotificationFields
// ====================================================

export interface WsNotificationFields_payload {
  id: string;
  subjectType: string;
  shipmentId: string | null;
  shipmentStatus: string | null;
}

export interface WsNotificationFields {
  eventName: string;
  payload: WsNotificationFields_payload | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SimulatedQuoteSectionFields
// ====================================================

export interface SimulatedQuoteSectionFields_billItems {
  category: string | null;
  cost: number;
  costJpy: number | null;
  currency: string | null;
  description: string | null;
  id: string;
  isSection: boolean;
  /**
   * (COST W/O TAX - UNIT PRICE) * QTY
   */
  margin: number;
  order: number | null;
  quantity: number | null;
  taxRate: number | null;
  totalAmount: number;
  totalTax: number;
  unitPrice: number | null;
  taxType: TaxTypeEnum;
  billId: string | null;
}

export interface SimulatedQuoteSectionFields {
  billItems: SimulatedQuoteSectionFields_billItems[];
  total: number;
  totalCost: number;
  totalMargin: number;
  selected: boolean | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AttachedDocumentEnum {
  arrival_notice = "arrival_notice",
  bill_of_landing = "bill_of_landing",
  booking_confirmation = "booking_confirmation",
  commercial_invoice = "commercial_invoice",
  goods_documents = "goods_documents",
  house_airway_bill = "house_airway_bill",
  insurance = "insurance",
  other_reference_documents = "other_reference_documents",
  packing_list = "packing_list",
  shipping_instructions = "shipping_instructions",
}

export enum AvailableLocalesEnum {
  en = "en",
  ja = "ja",
}

export enum AxleTypeEnum {
  three_axle = "three_axle",
  three_axle_overweight = "three_axle_overweight",
  two_axle = "two_axle",
}

export enum BankAccountTypeEnum {
  checking_account = "checking_account",
  deposit_account = "deposit_account",
  savings_account = "savings_account",
}

export enum BillStatusEnum {
  deleted = "deleted",
  draft = "draft",
  paid = "paid",
  published = "published",
}

export enum BlTypeEnum {
  original_bl = "original_bl",
  surrendered_bl = "surrendered_bl",
  waybill = "waybill",
}

export enum CargoFilterEnum {
  AIR = "AIR",
  FCL = "FCL",
  LCL = "LCL",
}

export enum CargoInsuranceEnum {
  consultation_required = "consultation_required",
  no_insurance = "no_insurance",
  self_coverage = "self_coverage",
  shippio_covers = "shippio_covers",
}

export enum CargoTypeEnum {
  FCL = "FCL",
  LCL = "LCL",
}

export enum CarrierTypeEnum {
  air = "air",
  sea = "sea",
}

export enum ChannelTypeEnum {
  partner = "partner",
  private = "private",
  public = "public",
  spam = "spam",
}

/**
 * List of communication
 */
export enum CommunicationTypeEnum {
  file = "file",
  text = "text",
}

export enum ContainerSizeEnum {
  _20ft = "_20ft",
  _20ft_flat = "_20ft_flat",
  _20ft_hc_reefer = "_20ft_hc_reefer",
  _20ft_open_top = "_20ft_open_top",
  _20ft_reefer = "_20ft_reefer",
  _20ft_tank = "_20ft_tank",
  _40ft = "_40ft",
  _40ft_flat = "_40ft_flat",
  _40ft_hc = "_40ft_hc",
  _40ft_hc_reefer = "_40ft_hc_reefer",
  _40ft_open_top = "_40ft_open_top",
  _40ft_reefer = "_40ft_reefer",
}

export enum CurrencyEnum {
  JPY = "JPY",
  USD = "USD",
}

export enum CustomerInsuranceEnum {
  insurance_included = "insurance_included",
  no_insurance = "no_insurance",
  other = "other",
}

export enum CustomerOrganizationFilterEnum {
  active = "active",
  hidden = "hidden",
}

export enum CustomerRoleEnum {
  buyer = "buyer",
  seller = "seller",
}

export enum CustomsHandlingEnum {
  consultation_required = "consultation_required",
  deferment = "deferment",
  pay_on_behalf = "pay_on_behalf",
  prepaid = "prepaid",
  real_time = "real_time",
}

export enum DelegatedStepsEnum {
  container_drayage = "container_drayage",
  export_customs_clearance = "export_customs_clearance",
  import_customs_clearance = "import_customs_clearance",
  truck_delivery = "truck_delivery",
}

export enum DocumentTypeEnum {
  arrival_notice = "arrival_notice",
  customs_clearance_export = "customs_clearance_export",
  customs_clearance_import = "customs_clearance_import",
  land_transportation_export = "land_transportation_export",
  land_transportation_import = "land_transportation_import",
  original_bill_of_landing = "original_bill_of_landing",
  sea_waybill = "sea_waybill",
  shipping_instructions = "shipping_instructions",
}

export enum DutyTaxPaymentMethodEnum {
  advanced_payment = "advanced_payment",
  direct_debit = "direct_debit",
  payment_deferral = "payment_deferral",
}

/**
 * List of duty and tax payment terms
 */
export enum DutyTaxPaymentTermsEnum {
  end_next_month_ata = "end_next_month_ata",
  within_5_wdays_next_month_ata = "within_5_wdays_next_month_ata",
  within_next_10_wdays_ata = "within_next_10_wdays_ata",
  within_next_20_wdays_ata = "within_next_20_wdays_ata",
  within_next_3_wdays_ata = "within_next_3_wdays_ata",
  within_next_5_wdays_ata = "within_next_5_wdays_ata",
}

/**
 * List of export payment terms
 */
export enum ExportPaymentTermsEnum {
  end_next_month_atd = "end_next_month_atd",
  prepaid = "prepaid",
  within_5_wdays_next_month_atd = "within_5_wdays_next_month_atd",
  within_next_10_wdays_atd = "within_next_10_wdays_atd",
  within_next_20_wdays_atd = "within_next_20_wdays_atd",
  within_next_3_wdays_atd = "within_next_3_wdays_atd",
  within_next_5_wdays_atd = "within_next_5_wdays_atd",
}

/**
 * List of import payment terms
 */
export enum ImportPaymentTermsEnum {
  end_next_month_ata = "end_next_month_ata",
  prepaid = "prepaid",
  within_5_wdays_next_month_ata = "within_5_wdays_next_month_ata",
  within_next_10_wdays_ata = "within_next_10_wdays_ata",
  within_next_20_wdays_ata = "within_next_20_wdays_ata",
  within_next_3_wdays_ata = "within_next_3_wdays_ata",
  within_next_5_wdays_ata = "within_next_5_wdays_ata",
}

/**
 * List of incoterms
 */
export enum IncotermsTypeEnum {
  CFR = "CFR",
  CIF = "CIF",
  CIP = "CIP",
  CPT = "CPT",
  DAP = "DAP",
  DAT = "DAT",
  DDP = "DDP",
  DPU = "DPU",
  EXW = "EXW",
  FAS = "FAS",
  FCA = "FCA",
  FOB = "FOB",
}

export enum InquiryOrderEnum {
  inquiry_status = "inquiry_status",
  last_activity_at = "last_activity_at",
}

export enum InquiryStatusEnum {
  inquiry_cancelled = "inquiry_cancelled",
  inquiry_created = "inquiry_created",
  inquiry_quoted = "inquiry_quoted",
  shipment_arrived = "shipment_arrived",
  shipment_cancelled = "shipment_cancelled",
  shipment_completed = "shipment_completed",
  shipment_customs_blocked = "shipment_customs_blocked",
  shipment_customs_in_process = "shipment_customs_in_process",
  shipment_customs_processed = "shipment_customs_processed",
  shipment_in_delivery = "shipment_in_delivery",
  shipment_in_land_transit = "shipment_in_land_transit",
  shipment_in_transit = "shipment_in_transit",
  shipment_land_transit_delayed = "shipment_land_transit_delayed",
  shipment_lost = "shipment_lost",
  shipment_preparing = "shipment_preparing",
  shipment_preparing_for_customs = "shipment_preparing_for_customs",
  shipment_transit_delayed = "shipment_transit_delayed",
  shipment_waiting_for_customer_info = "shipment_waiting_for_customer_info",
  shipment_waiting_for_customs = "shipment_waiting_for_customs",
  shipment_waiting_for_loading = "shipment_waiting_for_loading",
  shipment_waiting_for_pickup = "shipment_waiting_for_pickup",
}

export enum LanguageEnum {
  en = "en",
  ja = "ja",
}

/**
 * Event types that can be marked as done in a milestone
 */
export enum MilestoneDoneDateEnum {
  doneAt = "doneAt",
  etaDoneAt = "etaDoneAt",
  etdDoneAt = "etdDoneAt",
}

export enum MilestoneDonenessFilterEnum {
  with_only_booking_complete = "with_only_booking_complete",
  with_only_booking_incomplete = "with_only_booking_incomplete",
  with_only_delivered = "with_only_delivered",
}

export enum MilestoneTypeEnum {
  air_transportation = "air_transportation",
  custom_clearance = "custom_clearance",
  cy_cfs_cut = "cy_cfs_cut",
  delivery = "delivery",
  devanning = "devanning",
  free_text = "free_text",
  packing = "packing",
  pickup = "pickup",
  sea_transportation = "sea_transportation",
  vanning = "vanning",
}

export enum NaccsDeclarationTypeEnum {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
  G = "G",
  H = "H",
  J = "J",
  K = "K",
  L = "L",
  M = "M",
  N = "N",
  P = "P",
  R = "R",
  S = "S",
  U = "U",
  Y = "Y",
}

export enum NaccsDueDateExtensionTypeEnum {
  A = "A",
  B = "B",
  C = "C",
  E = "E",
  F = "F",
  H = "H",
  K = "K",
  M = "M",
  T = "T",
}

export enum NaccsEvaluationEnum {
  _0 = "_0",
  _5 = "_5",
  _6 = "_6",
  _7 = "_7",
  _Z = "_Z",
}

export enum NaccsImportRegulationCodeEnum {
  AC = "AC",
  AD = "AD",
  AM = "AM",
  AN = "AN",
  CA = "CA",
  CR = "CR",
  EX = "EX",
  FD = "FD",
  FL = "FL",
  FM = "FM",
  FR = "FR",
  FS = "FS",
  GA = "GA",
  HU = "HU",
  IA = "IA",
  MA = "MA",
  NA = "NA",
  OP = "OP",
  PA = "PA",
  PD = "PD",
  PE = "PE",
  PL = "PL",
  PM = "PM",
  PS = "PS",
  RA = "RA",
  SH = "SH",
  SP = "SP",
  ST = "ST",
}

export enum NaccsInsuranceTypeEnum {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
}

export enum NaccsInvoiceTypeEnum {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
}

export enum NaccsPaymentMethodEnum {
  M = "M",
  R = "R",
}

export enum NotificationStatusEnum {
  read = "read",
  unread = "unread",
}

export enum PackagingTypeEnum {
  BA = "BA",
  BE = "BE",
  BG = "BG",
  BK = "BK",
  BL = "BL",
  BN = "BN",
  BR = "BR",
  BX = "BX",
  CA = "CA",
  CG = "CG",
  CH = "CH",
  CK = "CK",
  CL = "CL",
  CO = "CO",
  CP = "CP",
  CR = "CR",
  CS = "CS",
  CT = "CT",
  CX = "CX",
  CY = "CY",
  DJ = "DJ",
  DP = "DP",
  DR = "DR",
  FL = "FL",
  FR = "FR",
  HD = "HD",
  HG = "HG",
  IN = "IN",
  JG = "JG",
  JR = "JR",
  KG = "KG",
  LG = "LG",
  LZ = "LZ",
  MT = "MT",
  NE = "NE",
  NT = "NT",
  PA = "PA",
  PC = "PC",
  PE = "PE",
  PG = "PG",
  PI = "PI",
  PK = "PK",
  PL = "PL",
  PP = "PP",
  PS = "PS",
  PT = "PT",
  PU = "PU",
  PY = "PY",
  PZ = "PZ",
  RL = "RL",
  RO = "RO",
  SA = "SA",
  SD = "SD",
  SE = "SE",
  SK = "SK",
  SL = "SL",
  ST = "ST",
  SZ = "SZ",
  TB = "TB",
  TI = "TI",
  TN = "TN",
  VA = "VA",
  VG = "VG",
  VL = "VL",
  VO = "VO",
  VP = "VP",
  VQ = "VQ",
  VR = "VR",
  VY = "VY",
  ZZ = "ZZ",
}

/**
 * List of payment term
 */
export enum PaymentTermsTypeEnum {
  freight_all_collect = "freight_all_collect",
  freight_collect = "freight_collect",
  freight_prepaid = "freight_prepaid",
}

export enum PortTypeEnum {
  airport = "airport",
  bonded_area = "bonded_area",
  port = "port",
}

export enum PriceCategorization {
  commercial = "commercial",
  non_commercial = "non_commercial",
  partial_non_commercial = "partial_non_commercial",
}

/**
 * Enum containing the list of the different available sections in a quote
 */
export enum QuoteSectionEnum {
  arrival_drayage = "arrival_drayage",
  arrival_trucking = "arrival_trucking",
  departure_drayage = "departure_drayage",
  departure_trucking = "departure_trucking",
  transport = "transport",
}

export enum ResponsiblePartyEnum {
  client = "client",
  shippio = "shippio",
}

export enum ShipmentOrderEnum {
  customs_clearance_asc = "customs_clearance_asc",
  import_arrival_export_delivery_asc = "import_arrival_export_delivery_asc",
  import_delivery_export_collection_asc = "import_delivery_export_collection_asc",
  shipment_status = "shipment_status",
  task = "task",
  updated_at = "updated_at",
}

export enum ShipmentStatusEnum {
  shipment_arrived = "shipment_arrived",
  shipment_cancelled = "shipment_cancelled",
  shipment_completed = "shipment_completed",
  shipment_customs_blocked = "shipment_customs_blocked",
  shipment_customs_in_process = "shipment_customs_in_process",
  shipment_customs_processed = "shipment_customs_processed",
  shipment_in_delivery = "shipment_in_delivery",
  shipment_in_land_transit = "shipment_in_land_transit",
  shipment_in_transit = "shipment_in_transit",
  shipment_land_transit_delayed = "shipment_land_transit_delayed",
  shipment_lost = "shipment_lost",
  shipment_preparing = "shipment_preparing",
  shipment_preparing_for_customs = "shipment_preparing_for_customs",
  shipment_transit_delayed = "shipment_transit_delayed",
  shipment_waiting_for_customer_info = "shipment_waiting_for_customer_info",
  shipment_waiting_for_customs = "shipment_waiting_for_customs",
  shipment_waiting_for_loading = "shipment_waiting_for_loading",
  shipment_waiting_for_pickup = "shipment_waiting_for_pickup",
}

export enum TaskAssigneeTypeEnum {
  operator = "operator",
  shipper = "shipper",
}

export enum TaskFilterEnum {
  DONE = "DONE",
  NOT_DONE = "NOT_DONE",
}

export enum TaskOrderEnum {
  CREATION_ASC = "CREATION_ASC",
  DEADLINE_ASC = "DEADLINE_ASC",
  ORDER_ASC = "ORDER_ASC",
}

export enum TaxTypeEnum {
  no_tax = "no_tax",
  tax_exclusive = "tax_exclusive",
  tax_inclusive = "tax_inclusive",
}

export enum TaxTypeEnumBase {
  no_tax = "no_tax",
  tax_exclusive = "tax_exclusive",
}

export enum TradeDirectionEnum {
  export = "export",
  import = "import",
}

export enum TransportationCargoTypeEnum {
  AIR = "AIR",
  FCL = "FCL",
  LCL = "LCL",
}

export enum TransportationTypeEnum {
  air = "air",
  any = "any",
  sea = "sea",
}

export enum TruckTypeEnum {
  any_10t = "any_10t",
  any_2t = "any_2t",
  any_4t = "any_4t",
  consolidated = "consolidated",
  crane_10t = "crane_10t",
  crane_2t = "crane_2t",
  crane_4t = "crane_4t",
  flat_10t = "flat_10t",
  flat_2t = "flat_2t",
  flat_4t = "flat_4t",
  flat_trailer_20t = "flat_trailer_20t",
  high_flatbed = "high_flatbed",
  lowbed_semi = "lowbed_semi",
  other = "other",
  powergate_10t = "powergate_10t",
  powergate_2t = "powergate_2t",
  powergate_4t = "powergate_4t",
  refrigerated_10t = "refrigerated_10t",
  refrigerated_2t = "refrigerated_2t",
  refrigerated_4t = "refrigerated_4t",
  self_loader = "self_loader",
  small_truck = "small_truck",
  unic_10t = "unic_10t",
  unic_2t = "unic_2t",
  unic_4t = "unic_4t",
  unknown = "unknown",
  wing_10t = "wing_10t",
  wing_2t = "wing_2t",
  wing_4t = "wing_4t",
  wing_trailer_20t = "wing_trailer_20t",
}

export interface AddressInput {
  street?: string | null;
  city?: string | null;
  country?: string | null;
  postalCode?: string | null;
  fullAddress?: string | null;
  addressComponents?: any | null;
  formattedAddress?: string | null;
  placeId?: string | null;
  name?: string | null;
  url?: string | null;
  longitude?: number | null;
  latitude?: number | null;
}

export interface AttachmentInput {
  name?: string | null;
  tag?: string | null;
  memo?: string | null;
  private?: boolean | null;
  dueDate?: any | null;
  responsibleParty?: ResponsiblePartyEnum | null;
}

export interface BankAccountInput {
  customerOrganizationId: string;
  accountName: string;
  accountNumber: string;
  accountType: BankAccountTypeEnum;
  bankAddress: string;
  bankCode?: string | null;
  bankName: string;
  branchCode?: string | null;
  branchName?: string | null;
  realTime?: boolean | null;
  swiftCode?: string | null;
}

/**
 * arguments for sorting shipments by bill
 */
export interface BillArgumentInput {
  unbilled?: boolean | null;
  quoteAcceptedAtOrder?: string | null;
  editBill?: boolean | null;
}

export interface BillInput {
  id?: string | null;
  reference?: string | null;
  companyName?: string | null;
  status?: BillStatusEnum | null;
  remark?: string | null;
  dueDate?: any | null;
  issueDate?: any | null;
  total?: number | null;
  totalTax?: number | null;
  language?: AvailableLocalesEnum | null;
}

export interface BillItemInput {
  id?: string | null;
  shipmentId?: string | null;
  billId?: string | null;
  description?: string | null;
  currency?: string | null;
  category?: string | null;
  unitPrice?: number | null;
  cost?: number | null;
  quantity?: number | null;
  taxed?: boolean | null;
  taxType?: TaxTypeEnum | null;
  taxRate?: number | null;
  order?: number | null;
  isSection?: boolean | null;
  _destroy?: boolean | null;
  billItemType?: string | null;
  partnerId?: string | null;
  isPrivate?: boolean | null;
  confirmed?: boolean | null;
}

export interface BillItemTemplateInput {
  templateId?: string | null;
  description: string;
  category?: string | null;
  taxType: TaxTypeEnum;
}

/**
 * search/find arguments for bill (order is desc by default)
 */
export interface BillScopedInput {
  billId?: string | null;
  customerOrganizationId?: string | null;
  status?: BillStatusEnum | null;
  sorting?: SortingParamsInput | null;
}

export interface BlMetaDataInput {
  blNumber?: string | null;
  blType?: BlTypeEnum | null;
  houseBlNumber?: string | null;
  issueDate?: any | null;
  issuePlace?: string | null;
  numberOfCopy?: number | null;
  numberOfOriginal?: number | null;
}

export interface CargoDescriptionInput {
  description?: string | null;
  containers?: RequestedContainerInput[] | null;
  parcels?: ParcelInput[] | null;
  departureOptions?: TransportationOptionInput | null;
  arrivalOptions?: TransportationOptionInput | null;
  totalWeight?: number | null;
  totalVolume?: number | null;
  regulated?: boolean | null;
}

/**
 * search arguments for carrier
 */
export interface CarrierScopedInput {
  carrierType?: CarrierTypeEnum | null;
  search?: string | null;
}

export interface ChannelMessageInput {
  id?: string | null;
  content?: string | null;
  communicationType?: CommunicationTypeEnum | null;
  attachment?: RemoteDirectUploadLinkInput | null;
}

export interface ContactInput {
  customerOrganizationId?: string | null;
  id?: string | null;
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  postalCode?: string | null;
  country?: string | null;
  address?: FullAddressInput | null;
  deleted?: boolean | null;
  normalizedName?: string | null;
  shipperConsigneeStandardCode?: string | null;
}

/**
 * contact filter arguments
 */
export interface ContactScopedInput {
  name?: string | null;
  customerOrganizationId?: string | null;
}

export interface ContainerInformationInput {
  containerNumber?: string | null;
  containerReference?: string | null;
  containerType?: ContainerSizeEnum | null;
}

export interface ContainerNumberInput {
  containerNumber?: string | null;
  sealNumber?: string | null;
  containerType?: ContainerSizeEnum | null;
  containerCount?: number | null;
}

export interface CountryScopedInput {
  search: string;
}

/**
 * Customer locations filter arguments
 */
export interface CustomerLocationFilterInput {
  name?: string | null;
  customerOrganizationId?: string | null;
  hidden?: boolean | null;
}

export interface CustomerLocationInput {
  customerOrganizationId: string;
  name: string;
  countryCode: string;
  region?: string | null;
  zipCode?: string | null;
  city: string;
  fullAddress: string;
  contactName?: string | null;
  contactNumber?: string | null;
  gmapsData?: GmapsDataInput | null;
  containerAllowed?: boolean | null;
  hasForklift?: boolean | null;
  hasCrane?: boolean | null;
  hasParking?: boolean | null;
  memo?: string | null;
  hidden?: boolean | null;
}

/**
 * hide/unhide arguments for customer organization
 */
export interface CustomerOrganizationHideInput {
  customerOrganizationId: string;
  hide: boolean;
}

export interface CustomerOrganizationInput {
  id?: string | null;
  name?: string | null;
  normalizedName?: string | null;
  url?: string | null;
  postalCode?: string | null;
  countryCode?: string | null;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  address?: FullAddressInput | null;
  memo?: string | null;
  language?: LanguageEnum | null;
  isFocus?: boolean | null;
  includeSender?: boolean | null;
  shipperConsigneeStandardCode?: string | null;
  companyNumber?: string | null;
  hasInsuranceCoverage?: boolean | null;
  insuranceNumber?: string | null;
  insuranceExpiration?: any | null;
  needsInsurance?: boolean | null;
  depositPayment?: boolean | null;
  depositPaymentNumber?: string | null;
  confirmBeforeCustomApplication?: boolean | null;
  importPaymentTerms?: ImportPaymentTermsEnum | null;
  exportPaymentTerms?: ExportPaymentTermsEnum | null;
  dutyTaxPaymentTerms?: DutyTaxPaymentTermsEnum | null;
}

/**
 * search/find/sort arguments for customer organization (order is asc by default)
 */
export interface CustomerOrganizationScopedInput {
  customerOrganizationId?: string | null;
  name?: string | null;
  sorting?: SortingParamsInput | null;
}

export interface DelegatedStepInput {
  step?: DelegatedStepsEnum | null;
  taxType?: TaxTypeEnumBase | null;
  delegatedStep?: string | null;
}

export interface DeliveryPlaceInput {
  deliveryPlace?: string | null;
  deliveryDate?: any | null;
  doneAt?: any | null;
  drayageReserved?: boolean | null;
}

/**
 * devanning container arguments
 */
export interface DevanningContainerInput {
  containerNumber?: string | null;
  containerReference?: string | null;
  deliveryPlaces?: DeliveryPlaceInput[] | null;
}

/**
 * devanning details arguments
 */
export interface DevanningDetailsInput {
  container?: DevanningContainerInput | null;
}

export interface DocumentBillItemInput {
  id: string;
  unitPrice: number;
  description?: string | null;
  quantity: number;
  taxRate: number;
  category?: string | null;
  displayCurrency: CurrencyEnum;
  taxType: TaxTypeEnum;
}

export interface FilelessCreationInput {
  tag?: string | null;
  memo?: string | null;
  dueDate?: any | null;
  responsibleParty?: ResponsiblePartyEnum | null;
}

export interface FullAddressInput {
  city?: string | null;
  countryCode?: string | null;
  line1?: string | null;
  line2?: string | null;
  line3?: string | null;
  line4?: string | null;
  postalCode?: string | null;
  prefecture?: string | null;
}

export interface GmapsDataInput {
  addressComponents?: any | null;
  formattedAddress?: string | null;
  placeId?: string | null;
  name?: string | null;
  url?: string | null;
  longitude?: number | null;
  latitude?: number | null;
}

export interface HSCodesInput {
  country: string;
  code: string;
}

export interface InUseInput {
  active: boolean;
  customerOrganizationId?: string | null;
}

/**
 * Register a new inquiry
 */
export interface InquiryInput {
  id?: string | null;
  departurePlaceId?: string | null;
  arrivalPlaceId?: string | null;
  departureCustomerLocationId?: string | null;
  arrivalCustomerLocationId?: string | null;
  departureAddress?: AddressInput | null;
  arrivalAddress?: AddressInput | null;
  cargoDescription?: CargoDescriptionInput | null;
  shipperId?: string | null;
  shipper?: ShipperInput | null;
  isProblem?: boolean | null;
  statusComment?: string | null;
  blMetaData?: BlMetaDataInput | null;
  reference?: string | null;
  incoterm?: string | null;
  desiredDepartureDate?: any | null;
  desiredArrivalDate?: any | null;
  customerReference?: string | null;
  inquiryMessage?: string | null;
  transportationType?: TransportationTypeEnum | null;
  cargoType?: CargoTypeEnum | null;
  customerRole?: string | null;
  cargoInsurance?: CargoInsuranceEnum | null;
  customsHandling?: CustomsHandlingEnum | null;
  needsInsurance?: boolean | null;
  needsCustoms?: boolean | null;
  requestedContainerCount?: number | null;
  requestedContainerType?: string | null;
  organizationPaymentTerms?: string | null;
  quoteDueDate?: any | null;
  quoteRemark?: string | null;
  status?: InquiryStatusEnum | null;
  truckingDetails?: TruckingDetailInput | null;
  usdJpyExchangeRate?: number | null;
  taxRate?: number | null;
  priority?: number | null;
  isFirst?: boolean | null;
  showTotal?: boolean | null;
}

/**
 * search/find arguments for inquiry
 */
export interface InquiryScopedInput {
  inquiryId?: string | null;
  operatorId?: string | null;
  customerId?: string | null;
  customerOrganizationId?: string | null;
  status?: string | null;
  priority?: number | null;
  quoteAcceptedAt?: any | null;
  reference?: string | null;
  orderBy?: InquiryOrderEnum | null;
  cargo?: CargoFilterEnum | null;
  pol?: string | null;
  pod?: string | null;
  tradeDirection?: TradeDirectionEnum | null;
}

/**
 * The typed fields for the request field on an insurance_policy
 */
export interface InsuranceRequestInput {
  extraInput?: any | null;
  contractData?: any | null;
  assuredData?: any | null;
  routeData?: any | null;
  departureSegmentData?: any | null;
  arrivalSegmentData?: any | null;
  cargoData?: any | null;
  invoiceData?: any | null;
  insuranceData?: any | null;
  freightData?: any | null;
  policyData?: any | null;
  debitNoteData?: any | null;
  customsData?: any | null;
  remarksData?: any | null;
}

/**
 * required sign in arguments
 */
export interface LoginInformationInput {
  email: string;
  password: string;
  role: string;
}

/**
 * mark a milestone as done/not done
 */
export interface MilestoneCheckInput {
  id: string;
  done: boolean;
  eventName?: MilestoneDoneDateEnum | null;
}

/**
 * milestones detail arguments
 */
export interface MilestoneDetailsInput {
  vesselName?: string | null;
  voyageNumber?: string | null;
  bookingNumber?: string | null;
  eventInfo?: string | null;
  flightNumber?: string | null;
  blNumber?: string | null;
  drayageReserved?: boolean | null;
  eventLocation?: string | null;
  locationCompanyName?: string | null;
  locationCompanyPhone?: string | null;
  locationCompanyPerson?: string | null;
  containerDetails?: ContainerInformationInput | null;
}

/**
 * milestones arguments
 */
export interface MilestoneInput {
  vesselId?: string | null;
  polId?: string | null;
  podId?: string | null;
  estimatedDateOfDeparture?: any | null;
  estimatedDateOfArrival?: any | null;
  devanningDate?: any | null;
  deliveryTime?: any | null;
  milestoneType?: MilestoneTypeEnum | null;
  eventDate?: any | null;
  details?: MilestoneDetailsInput | null;
  devanningDetails?: DevanningDetailsInput | null;
  truckingDetails?: MilestoneTruckingDetailsInput | null;
}

/**
 * milestones trucking details arguments
 */
export interface MilestoneTruckingDetailsInput {
  companyName?: string | null;
  truckNumber?: string | null;
  driverName?: string | null;
  phoneNumber?: string | null;
}

export interface NaccsDocumentInput {
  ida?: NaccsIdaInput | null;
}

export interface NaccsIdaInput {
  declarationType?: NaccsDeclarationTypeEnum | null;
  customsApplicationDate?: any | null;
  consignee?: ContactInput | null;
  consigneeName?: string | null;
  consigneeAddress?: string | null;
  consigneePhoneNumber?: string | null;
  bondedArea?: string | null;
  shipperConsigneeStandardCode?: string | null;
  shipper?: ContactInput | null;
  shipperName?: string | null;
  shipperAddress?: string | null;
  blNumber?: string[] | null;
  awbNumber?: string | null;
  mawbNumber?: string | null;
  tradingType?: number | null;
  otherRegulations?: NaccsImportRegulationCodeEnum[] | null;
  foodRegulation?: boolean | null;
  plantRegulation?: boolean | null;
  animalRegulation?: boolean | null;
  importCertificates?: NaccsImportCertificateInput[] | null;
  invoiceNumber?: string | null;
  invoiceType?: NaccsInvoiceTypeEnum | null;
  invoiceCurrency?: string | null;
  invoicePrice?: string | null;
  insuranceType?: NaccsInsuranceTypeEnum | null;
  insuranceCurrency?: string | null;
  insurancePrice?: string | null;
  evaluation?: NaccsEvaluationEnum | null;
  existingAssessmentNumbers?: string[] | null;
  dueDateExtensionType?: NaccsDueDateExtensionTypeEnum | null;
  paymentMethod?: NaccsPaymentMethodEnum | null;
  remarkFromShipper?: string | null;
  shipperSectionCode?: string | null;
  shipperReferenceNumber?: string | null;
}

export interface NaccsImportCertificateInput {
  code?: string | null;
  number?: string | null;
}

/**
 * notification query args
 */
export interface NotificationInput {
  language?: string | null;
}

/**
 * Args to find one notification
 */
export interface NotificationReadInput {
  id?: string | null;
}

export interface OperatorInput {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  avatar?: RemoteDirectUploadLinkInput | null;
  emailNotifications?: boolean | null;
  language?: AvailableLocalesEnum | null;
  phoneNumber?: string | null;
}

export interface OperatorOrganizationInput {
  anaMargin?: number | null;
  fclMargin?: number | null;
  fuelSurcharge?: number | null;
  lclMargin?: number | null;
  drayageMarginJapan?: number | null;
  truckingMarginJapan?: number | null;
  truckingMarginWorld?: number | null;
  drayageMarginWorld?: number | null;
  smallTruckingMarginJapan?: number | null;
  usdJpyExchangeRate?: number | null;
  taxRate?: number | null;
}

export interface PaginationInput {
  page?: number | null;
  per?: number | null;
}

export interface ParcelInput {
  id?: string | null;
  shipmentId?: string | null;
  containerId?: string | null;
  description?: string | null;
  currency?: string | null;
  sizeUnit?: string | null;
  grossUnit?: string | null;
  weightUnit?: string | null;
  volumeUnit?: string | null;
  length?: number | null;
  width?: number | null;
  height?: number | null;
  volume?: number | null;
  netWeight?: number | null;
  grossWeight?: number | null;
  parcelValue?: number | null;
  packagingType?: string | null;
  hsCode?: string | null;
  quantity?: number | null;
  productQuantity?: number | null;
  productPrice?: number | null;
  productId?: string | null;
  onPallet?: boolean | null;
}

export interface PartnerMemberScopedInput {
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  locale?: AvailableLocalesEnum | null;
  deletedAt?: any | null;
}

export interface PartnerScopedInput {
  name?: string | null;
  normalizedName?: string | null;
  url?: string | null;
  address?: FullAddressInput | null;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  note?: string | null;
}

export interface PartyDetailsInput {
  name?: string | null;
  fullAddress?: string | null;
  city?: string | null;
  prefecture?: string | null;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  email?: string | null;
  country?: string | null;
  postalCode?: string | null;
}

export interface ProductInput {
  customerOrganizationId?: string | null;
  id?: string | null;
  name?: string | null;
  sku?: string | null;
  serialNumber?: string | null;
  category?: string | null;
  url?: string | null;
  currency?: string | null;
  weightUnit?: string | null;
  countryOfOrigin?: string | null;
  deleted?: boolean | null;
  editable?: boolean | null;
  hsCodes?: HSCodesInput[] | null;
  price?: number | null;
  length?: number | null;
  width?: number | null;
  height?: number | null;
  weight?: number | null;
  attachments?: RemoteDirectUploadLinkInput[] | null;
  deletedAttachmentIds?: string[] | null;
}

/**
 * product scope
 */
export interface ProductScopedInput {
  search?: string | null;
  customerOrganizationId?: string | null;
}

/**
 *  arguments for quote submit
 */
export interface QuoteInput {
  inquiryId: string;
  quoteDueDate: any;
  quoteRemark?: string | null;
}

/**
 * arguments for quote templates
 */
export interface QuoteTemplateInput {
  name: string;
  shipmentId: string;
}

/**
 * arguments for loading a quote template into a shipment
 */
export interface QuoteTemplateLoadInput {
  shipmentId: string;
  quoteTemplateId: string;
}

/**
 * List of keys referencing anonymous secured uploads on s3
 */
export interface RemoteDirectUploadLinkInput {
  key: string;
  isPrivate?: boolean | null;
}

export interface RequestedContainerInput {
  requestedContainerType?: string | null;
  requestedContainerCount?: number | null;
  contentNetWeight?: number | null;
}

export interface ShipmentAssignInput {
  shipmentId: string;
  operatorId?: string | null;
}

export interface ShipmentDocumentDataInput {
  attachedDocuments?: AttachedDocumentEnum[] | null;
  billItems?: DocumentBillItemInput[] | null;
  containerNumbers?: ContainerNumberInput[] | null;
  delegatedSteps?: DelegatedStepInput[] | null;
  finalCurrency?: CurrencyEnum | null;
  shipmentCustomerRole?: CustomerRoleEnum | null;
  blType?: BlTypeEnum | null;
  shipmentIncoterms?: IncotermsTypeEnum | null;
  dutyTaxPaymentMethod?: DutyTaxPaymentMethodEnum | null;
  taxType?: TaxTypeEnumBase | null;
  transportationType?: TransportationTypeEnum | null;
  truckChassisType?: AxleTypeEnum | null;
  truckType?: TruckTypeEnum | null;
  customerInsurance?: CustomerInsuranceEnum | null;
  transportCargoType?: TransportationCargoTypeEnum | null;
  packagingType?: PackagingTypeEnum | null;
  shipmentPaymentTerms?: PaymentTermsTypeEnum | null;
  priceCategorization?: PriceCategorization | null;
  dispatchArrangements?: boolean | null;
  exportRegistration?: boolean | null;
  emptyVanPickup?: boolean | null;
  shippingCompanyChargeAdvance?: boolean | null;
  naccsHdl?: boolean | null;
  naccsAclDockReport?: boolean | null;
  proofOfOrigin?: boolean | null;
  dangerous?: boolean | null;
  weightCalibration?: boolean | null;
  motorGenerator?: boolean | null;
  preliminaryFilings?: boolean | null;
  preCooling?: boolean | null;
  priceCategory?: boolean | null;
  cargoPickupDatetime?: any | null;
  freeTime?: any | null;
  collectionPreferredDatetime?: any | null;
  customsArrivalDate?: any | null;
  customsClearanceDate?: any | null;
  customsClearanceDesiredDate?: any | null;
  customsPickupDate?: any | null;
  pickupDate?: any | null;
  cyCfsCutDate?: any | null;
  estimatedDateOfDeparture?: any | null;
  estimatedDateOfArrival?: any | null;
  freightDeliveryDatetime?: any | null;
  issuanceDate?: any | null;
  packaging?: string | null;
  hsCode?: string | null;
  shipmentExchangeRate?: number | null;
  customerAddress?: string | null;
  shippingMarks?: string | null;
  descriptionOfGoods?: string | null;
  packagingQuantity?: number | null;
  assignedOperator?: string | null;
  blNumberOfOriginals?: number | null;
  blPlaceOfIssuance?: string | null;
  bookingNumber?: string | null;
  cargoCollectionAddress?: string | null;
  cargoCollectionContact?: string | null;
  airCarrier?: string | null;
  seaCarrier?: string | null;
  consolidator?: string | null;
  collectionAddress?: string | null;
  collectionContact?: string | null;
  collectionContactInformation?: string | null;
  collectionName?: string | null;
  collectionPhone?: string | null;
  customerBankAccountNumber?: string | null;
  customerPostponementNumber?: string | null;
  customerCompanyNumber?: string | null;
  customerInsuranceNumber?: string | null;
  customerName?: string | null;
  customerShipperConsigneeStandardCode?: string | null;
  customsLocation?: string | null;
  declaredValue?: string | null;
  deliveryLocation?: string | null;
  finalDestination?: string | null;
  flightNumber?: string | null;
  fobPrice?: string | null;
  freightDeliveryAddress?: string | null;
  freightDeliveryContact?: string | null;
  freightDeliveryContactInformation?: string | null;
  freightDeliveryName?: string | null;
  grossVolume?: number | null;
  grossWeight?: number | null;
  grossVolumeOfGoods?: string | null;
  grossWeightOfGoods?: string | null;
  houseBlNumber?: string | null;
  importDestinationAddress?: string | null;
  importDestinationPhone?: string | null;
  masterBlNumber?: string | null;
  naccsCode?: string | null;
  otherLaws?: string | null;
  placeOfDelivery?: string | null;
  placeOfReceipt?: string | null;
  portOfDischarge?: string | null;
  portOfLoading?: string | null;
  preCarriageBy?: string | null;
  presetTemperature?: string | null;
  quantityOfContainers?: number | null;
  requiresWarehouseWork?: string | null;
  shipmentConsigneeAddress?: string | null;
  shipmentConsigneeEmail?: string | null;
  shipmentConsigneeName?: string | null;
  shipmentConsigneePhone?: string | null;
  shipmentConsigneeAccountNumber?: string | null;
  shipmentDeliveryAgentAccountNumber?: string | null;
  shipmentDeliveryAgentAddress?: string | null;
  shipmentDeliveryAgentEmail?: string | null;
  shipmentDeliveryAgentName?: string | null;
  shipmentDeliveryAgentPhone?: string | null;
  shipmentInvoiceNumber?: string | null;
  shipmentNotifyAccountNumber?: string | null;
  shipmentNotifyAddress?: string | null;
  shipmentNotifyEmail?: string | null;
  shipmentNotifyName?: string | null;
  shipmentNotifyPhone?: string | null;
  shipmentAlsoNotifyName?: string | null;
  shipmentAlsoNotifyAddress?: string | null;
  shipmentAlsoNotifyEmail?: string | null;
  shipmentAlsoNotifyPhone?: string | null;
  shipmentPaymentPlace?: string | null;
  shipmentReference?: string | null;
  shipmentShipperAccountNumber?: string | null;
  shipmentShipperAddress?: string | null;
  shipmentShipperEmail?: string | null;
  shipmentShipperName?: string | null;
  shipmentShipperPhone?: string | null;
  vanningLocation?: string | null;
  vanningLocationAddress?: string | null;
  ventilation?: string | null;
  vesselName?: string | null;
  voyageNumber?: string | null;
  remarks?: string | null;
  finalRemarks?: string | null;
  clientRemarks?: string | null;
  cargoRemarks?: string | null;
  freightRemarks?: string | null;
  arrangementRemarks?: string | null;
  shippingRemarks?: string | null;
  shippingPlaceRemarks?: string | null;
  deliveryRemarks?: string | null;
  pickupRemarks?: string | null;
}

export interface ShipmentDocumentInput {
  data?: ShipmentDocumentDataInput | null;
  title?: string | null;
}

export interface ShipmentLockInput {
  shipmentId: string;
  locked: boolean;
}

/**
 * shipment scoped argument
 */
export interface ShipmentScopedInput {
  shipmentId?: string | null;
  shipmentIds?: string[] | null;
  customerOrganizationId?: string | null;
  status?: string | null;
  milestoneDoneness?: MilestoneDonenessFilterEnum | null;
  milestoneAddressSearchString?: string | null;
  statuses?: ShipmentStatusEnum[] | null;
  operatorId?: string | null;
  customerId?: string | null;
  reference?: string | null;
  orderBy?: ShipmentOrderEnum | null;
  cargo?: CargoFilterEnum | null;
  pol?: string | null;
  pod?: string | null;
  tradeDirection?: TradeDirectionEnum | null;
}

/**
 * Update a shipment
 */
export interface ShipmentUpdateInput {
  id: string;
  departureCustomerLocationId?: string | null;
  arrivalCustomerLocationId?: string | null;
  carrierId?: string | null;
  cargoReleaseContact?: PartyDetailsInput | null;
  consigneeDetails?: PartyDetailsInput | null;
  shipperDetails?: PartyDetailsInput | null;
  notifyPartyDetails?: PartyDetailsInput | null;
  arrivalAddress?: AddressInput | null;
  blMetaData?: BlMetaDataInput | null;
  cargoDescription?: CargoDescriptionInput | null;
  departureAddress?: AddressInput | null;
  desiredArrivalDate?: any | null;
  desiredDepartureDate?: any | null;
  endFreeTime?: any | null;
  incoterm?: IncotermsTypeEnum | null;
  naccsDocument?: NaccsDocumentInput | null;
  paymentTerms?: PaymentTermsTypeEnum | null;
  status?: string | null;
  containerInformation?: ContainerInformationInput[] | null;
  isProblem?: boolean | null;
  statusComment?: string | null;
  billingComplete?: boolean | null;
  customerReference?: string | null;
  inquiryMessage?: string | null;
  invoiceNumber?: string | null;
  organizationPaymentTerms?: string | null;
  paymentAsArranged?: boolean | null;
  paymentPlace?: string | null;
  shippingMarks?: string | null;
  showTotal?: boolean | null;
  taxRate?: number | null;
  usdJpyExchangeRate?: number | null;
  reference?: string | null;
}

/**
 * shipment uploads
 */
export interface ShipmentUploadInput {
  shipmentId: string;
  attachments?: (RemoteDirectUploadLinkInput | null)[] | null;
}

export interface ShipperInput {
  id?: string | null;
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  tosAccepted?: boolean | null;
  avatar?: RemoteDirectUploadLinkInput | null;
  emailNotifications?: boolean | null;
  language?: AvailableLocalesEnum | null;
  memo?: string | null;
  customerOrganization?: CustomerOrganizationInput | null;
}

export interface ShipperInvitationInput {
  name: string;
  email: string;
}

/**
 * search/find/sort arguments for shipper (order is asc by default)
 */
export interface ShipperScopedInput {
  shipperId?: string | null;
  companyName?: string | null;
  sorting?: SortingParamsInput | null;
}

/**
 * SortingParamsInput
 */
export interface SortingParamsInput {
  field?: string | null;
  order: string;
}

/**
 * mark a task as done/not done
 */
export interface TaskCheckInput {
  taskId: string;
  done: boolean;
}

export interface TaskInput {
  id?: string | null;
  title: string;
  shipmentId?: string | null;
  assigneeType?: TaskAssigneeTypeEnum | null;
  assigneeId?: string | null;
  description?: string | null;
  deadlineDate?: any | null;
  reminderDate?: any | null;
  doneAt?: any | null;
  isPublic?: boolean | null;
}

/**
 * search arguments for task (order is asc by default)
 */
export interface TaskScopedInput {
  shipmentId?: string | null;
  customerOrganizationId?: string | null;
  operatorId?: string | null;
  customerId?: string | null;
}

export interface TaskUpdateInput {
  id?: string | null;
  title?: string | null;
  shipmentId?: string | null;
  description?: string | null;
  isPublic?: boolean | null;
  assigneeType?: TaskAssigneeTypeEnum | null;
  deadlineDate?: any | null;
  reminderDate?: any | null;
  doneAt?: any | null;
  assigneeId?: string | null;
}

export interface TransportationOptionInput {
  drayage?: boolean | null;
  truckingInformations?: TruckingDetailInput | null;
  vanningInformations?: VanningDetailInput | null;
}

export interface TruckingDetailInput {
  truckingArrangement?: boolean | null;
  truckType?: TruckTypeEnum | null;
  truckCount?: number | null;
  cargoForkliftable?: boolean | null;
  cargoStackable?: boolean | null;
  cargoStackableSize?: number | null;
}

export interface UpdatePasswordInput {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}

export interface VanningDetailInput {
  needsVanning: boolean;
  cost: number;
  currency: string;
}

export interface VesselInput {
  name?: string | null;
  imo?: string | null;
  mmsi?: string | null;
  naccsCode?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
